import store from "@/store";
import RBush from "rbush";
// 构件按钮内容
import {
  rlWallModelSectData,
  rlSlabModelSectData,
  rlBeamModelSectData,
  rlColumnModelSectData,
} from "@/rlMxModules/funClass";

import { rlWall, rlBeam, rlColumn } from "@/rlMxModules/index";

import {
  rlWallData,
  rlWallHoleData,
  rlBeamData,
  rlColumnData,
  rlRingBeamData,
  rlSlabData,
  rlSlabHoleData,
  rlSubBeamData,
  rlPartitionWallData,
  rlDoorsWindowsData,
  rlUseData,
  rlCantiSlabData,
  rlTextData,
} from "@/rlMxModules/rlDataClass/index";

import { get_entity_by_id } from "@/rlMxModules/operate/index";
import {
  addEntityToDrawing,
  userSelect,
  ptOnLine,
  sortAxisData,
  getEntityData,
  isInPolygon,
  isPointInModel,
  getEntityById,
  saveDatabaseStore,
  enableSnapCorrection,
  lineInsection,
  lineArcIntersection,
  isPointInPolygon,
  createHighlightEffect,
  clearEntityHighlight,
  GridIsExist,
  gridLineInsertWith,
} from "@/rlMxModules/operate/operateApi";

import { getRlLayer } from "@/mixins/LiteModuleDb.js";
import {
  McDbPolyline,
  McGePoint3d,
  McCmColor,
  MxCpp,
  McDbLine,
  McDbText,
} from "mxcad";
import rlSlabHoleModelSectData from "../funClass/rlSlabHoleModelSectData";
// 全局loading
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import { getrlStdFlr } from "@/mixins/LiteModuleDb.js";

import {
  getInputElement,
  createInputElement,
  setInputElementPosition,
  setCurrDataObj,
  eraseOtherData,
  setOtherData,
  getInptNum,
  setContainerShow,
  setInputBlur,
} from "@/rlMxModules/operate/inputElement.js";

import {
  createOverButton,
  destroyOverButton,
  setOverButtonPosition,
  getClickOverButtonType,
} from "@/rlMxModules/operate/overButton.js";
import {
  createDirectionButton,
  getGridDataRecord,
  setGridDataRecord,
  getDirectionButtonIsCreate,
  setCantiSlabSectData,
} from "@/rlMxModules/operate/createVecButton.js";
import { fixOrthogonal } from "@/rlMxModules/utils/util";
import oneMessage from "@/utils/oneMessage.js";
import { getArcPoints } from "@/rlMxModules/Opencascad/getModelDrawData.js";
import CreateSlab from "./createSlab";
import { drawSnapIcon } from "@/rlMxModules/operate/snapCal.js";
import {
  calculateArcAngle,
  toDegrees,
} from "@/rlMxModules/operate/GraphicDataCal.js";
// 接口数据
import { modelingList } from "@/api/hiSurveyApi";
import { isMobileDevice } from "@/utils/matchMedia";
// 弹窗组件
import { VXETable } from "vxe-table";
import { isLinesOverlapping } from "@/rlMxModules/operate/GraphicDataCal.js";
// 点选生成构件
export const structural_entiy = (topBtnActive, rl_stdFlr_id, rlModules) => {
  return new Promise(async (resolve, reject) => {
    if (topBtnActive.name == "墙") {
      const id = await rlAppObj._rlMx.MxFun.selectEnt("id");
      if (!id) return;
      const moduleForm = topBtnActive.moduleForm;
      const { parameter, tableRow } = moduleForm;
      if (rl_stdFlr_id == -999) {
        return;
      }
      // 拿到对应标准层
      var StlData = await getrlStdFlr(rl_stdFlr_id);
      const rlGridData = get_entity_by_id(id);
      if (!rlGridData) {
        console.warn("当前选择对象为空");
        return;
      }
      if (rlGridData.classTypeName == "rlGrid") {
        if (rlGridData.m_wallId) {
          // 判断当前网格是否存在墙
          const rlWallAssociation = get_entity_by_id(rlGridData.m_wallId);
          if (rlWallAssociation) {
            rlWallAssociation.erase();
          }
          rlGridData.m_wallId = null;
        }

        const rlWallObject = new rlWall();
        const m_sectParamData = new rlWallModelSectData();

        // 编号
        const startAxis = get_entity_by_id(rlGridData.m_stJoint.startAxisObjId);
        const endAxis = get_entity_by_id(rlGridData.m_stJoint.endAxisObjId);
        if (startAxis && endAxis) {
          const startAxis2 = get_entity_by_id(
            rlGridData.m_edJoint.startAxisObjId
          );
          const endAxis2 = get_entity_by_id(rlGridData.m_edJoint.endAxisObjId);
          if (startAxis2 && endAxis2) {
            // rlWallObject.Name = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${startAxis2.Name}-${endAxis.Name} 墙`
            const mAxis = rlGridData.m_Axis;
            rlWallObject.ModelNo = `${rl_stdFlr_id.No_}F ${
              mAxis.axisVector > 0 ? "" : startAxis.Name + "-"
            }${startAxis2.Name}-${endAxis.Name}${
              mAxis.axisVector > 0 ? "-" + endAxis2.Name : ""
            } 墙`;
          }
        }

        /* m_sectParamData.Mat = tableRow.material;
                m_sectParamData.Kind = tableRow.section_param;
                m_sectParamData.B = tableRow.B;
                rlWallObject.m_sectParamData = m_sectParamData
                rlWallObject.m_gridData = rlGridData
                rlWallObject.Height = 3000
                rlWallObject.LevelB = 0
                rlWallObject.Ecc = Number(parameter[0].value)
                rlWallObject.HDiff1 = Number(parameter[1].value)
                rlWallObject.HDiff2 = Number(parameter[2].value)
                rlWallObject.HDiffB = Number(parameter[3].value) */
        // test
        m_sectParamData.Mat = tableRow.material;
        m_sectParamData.Kind = tableRow.section_param;
        m_sectParamData.B = 200;
        rlWallObject.m_sectParamData = m_sectParamData;
        rlWallObject.m_gridData = rlGridData;
        rlWallObject.Ecc = 0;
        rlWallObject.HDiff1 = 0;
        rlWallObject.HDiff2 = 0;
        rlWallObject.HDiffB = 0;
        rlWallObject.Height = StlData.Height ?? 3000;
        rlWallObject.LevelB = 0;

        rlAppObj.rlMxDrawObject.addMxEntity(rlWallObject);
        // 添加到组
        const rlWallGroup = rlAppObj.rlMxDatabase.addGroup(
          rlWallObject.m_groupName
        );
        rlWallGroup.append(rlWallObject);

        // 关联网格对象
        // rlGridData.m_beamId = rlWallObject.objectId()

        resolve(rlWallObject);
      }
    } else if (topBtnActive.name == "梁") {
      const id = await rlAppObj._rlMx.MxFun.selectEnt("id");
      if (!id) return;
      const moduleForm = topBtnActive.moduleForm;
      const { parameter, tableRow } = moduleForm;

      if (rl_stdFlr_id == -999) {
        return;
      }
      const rlGridData = get_entity_by_id(id);

      if (!rlGridData) {
        console.warn("当前选择对象为空");
        return;
      }
      if (rlGridData.classTypeName == "rlGrid") {
        if (rlGridData.m_beamId) {
          // 判断当前网格是否存在梁
          const rlBeamAssociation = get_entity_by_id(rlGridData.m_beamId);
          if (rlBeamAssociation) {
            rlBeamAssociation.erase();
          }
          rlGridData.m_beamId = null;
        }

        const rlBeamObject = new rlBeam();
        const m_sectParamData = new rlBeamModelSectData();

        // 编号
        const startAxis = get_entity_by_id(rlGridData.m_stJoint.startAxisObjId);
        const endAxis = get_entity_by_id(rlGridData.m_stJoint.endAxisObjId);
        if (startAxis && endAxis) {
          const startAxis2 = get_entity_by_id(
            rlGridData.m_edJoint.startAxisObjId
          );
          const endAxis2 = get_entity_by_id(rlGridData.m_edJoint.endAxisObjId);
          if (startAxis2 && endAxis2) {
            // rlBeamObject.Name = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${startAxis2.Name}-${endAxis.Name} 梁`
            const mAxis = rlGridData.m_Axis;
            rlBeamObject.ModelNo = `${rl_stdFlr_id.No_}F ${
              mAxis.axisVector > 0 ? "" : startAxis.Name + "-"
            }${startAxis2.Name}-${endAxis.Name}${
              mAxis.axisVector > 0 ? "-" + endAxis2.Name : ""
            } 梁`;
          }
        }

        /* m_sectParamData.Mat = tableRow.material;
                m_sectParamData.Kind = tableRow.section_param;
                m_sectParamData.ShapeVal = `${tableRow.section_param},${tableRow.section.split('*').join(',')},1,1`;
                rlBeamObject.m_sectParamData = m_sectParamData
                rlBeamObject.m_gridData = rlGridData
                 rlBeamObject.Height = 3000
                rlBeamObject.LevelB = 0
                rlBeamObject.Ecc = Number(parameter[0].value)
                rlBeamObject.HDiff1 = Number(parameter[1].value)
                rlBeamObject.HDiff2 = Number(parameter[2].value) */

        // test
        m_sectParamData.Mat = tableRow.material;
        m_sectParamData.Kind = tableRow.section_param;
        m_sectParamData.ShapeVal = `${1},${tableRow.section
          .split("*")
          .join(",")},1,1`;
        rlBeamObject.m_sectParamData = m_sectParamData;
        rlBeamObject.m_gridData = rlGridData;
        rlBeamObject.Ecc = 0;
        rlBeamObject.HDiff1 = 0;
        rlBeamObject.HDiff2 = 0;
        rlBeamObject.Height = StlData.Height ?? 3000;
        rlBeamObject.LevelB = 0;

        rlAppObj.rlMxDrawObject.addMxEntity(rlBeamObject);
        // 添加到组
        const rlBeamGroup = rlAppObj.rlMxDatabase.addGroup(
          rlBeamObject.m_groupName
        );
        rlBeamGroup.append(rlBeamObject);

        // 关联网格对象
        // rlGridData.rlBeamObjectId = rlBeamObject.objectId()

        resolve(rlBeamObject);
      }
    } else if (topBtnActive.name == "柱") {
      const id = await rlAppObj._rlMx.MxFun.selectEnt("id");
      if (!id) return;
      const moduleForm = topBtnActive.moduleForm;
      const { parameter, tableRow } = moduleForm;

      if (rl_stdFlr_id == -999) {
        return;
      }
      const rlPoint = get_entity_by_id(id);
      if (!rlPoint) {
        console.warn("当前选择对象为空");
        return;
      }
      if (rlPoint.classTypeName == "rlJoint") {
        if (rlPoint.m_cloumId) {
          // 判断当前节点是否存在柱
          const rlColumnAssociation = get_entity_by_id(rlPoint.m_cloumId);
          if (rlColumnAssociation) {
            rlColumnAssociation.erase();
          }
          rlPoint.m_cloumId = null;
        }

        const rlColumnObject = new rlColumn();
        const m_sectParamData = new rlColumnModelSectData();

        // 编号
        const startAxis = get_entity_by_id(rlPoint.startAxisObjId);
        if (startAxis) {
          const endAxis = get_entity_by_id(rlPoint.endAxisObjId);
          rlColumnObject.ModelNo = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${endAxis.Name} 柱`;
        }

        /* m_sectParamData.Mat = tableRow.material
                m_sectParamData.Kind = tableRow.section_param
                m_sectParamData.ShapeVal = `${tableRow.section_param},${tableRow.section.split('*').join(',')},1,1`;

                rlColumnObject.m_JointData = rlPoint
                rlColumnObject.m_sectParamData = m_sectParamData
                rlColumnObject.Height = 3000
                rlColumnObject.LevelB = 0

                rlColumnObject.EccX = Number(parameter[0].value)
                rlColumnObject.EccY = Number(parameter[1].value)
                rlColumnObject.HDiffB = Number(parameter[2].value)
                rlColumnObject.Rotation = Number(parameter[3].value) */

        // test
        m_sectParamData.Mat = tableRow.material;
        m_sectParamData.Kind = tableRow.section_param;
        m_sectParamData.ShapeVal = `${1},${tableRow.section
          .split("*")
          .join(",")},1,1`;
        m_sectParamData.Guid = tableRow.Guid;
        rlColumnObject.m_JointData = rlPoint;
        rlColumnObject.m_sectParamData = m_sectParamData;
        rlColumnObject.EccX = 0;
        rlColumnObject.EccY = 0;
        rlColumnObject.HDiffB = 0;
        rlColumnObject.Rotation = 0;
        rlColumnObject.Height = StlData.Height ?? 3000;
        rlColumnObject.LevelB = 0; // 0;
        rlColumnObject.EccX = Number(parameter[0].value);
        rlColumnObject.EccY = Number(parameter[1].value);
        rlColumnObject.HDiffB = Number(parameter[2].value);
        rlColumnObject.Rotation = Number(parameter[3].value);

        rlAppObj.rlMxDrawObject.addMxEntity(rlColumnObject);

        // 添加到组
        const rlColumnGroup = rlAppObj.rlMxDatabase.addGroup(
          rlColumnObject.m_groupName
        );
        rlColumnGroup.append(rlColumnObject);

        // 关联节点对象
        // rlPoint.rlColumnObjectId = rlColumnObject.objectId()

        resolve(rlColumnObject);
      }
    }
    // else if (topBtnActive.name == "板") {
    //     rlAppObj.rlMxDatabase.getGroup('rlSlabGroup')?.clear()
    //     const rlLineGridGroup = rlAppObj.rlMxDatabase
    //         .getGroup('rlLineGridGroup')
    //         ?.getAll()

    //     const girdData = rlLineGridGroup.filter(ele => (ele.m_beamId || ele.m_wallId)).map(item => [
    //         ...item.m_stJoint.m_pt,
    //         ...item.m_edJoint.m_pt
    //     ])

    //     if (girdData.length) {
    //         return
    //     }
    //     .join(","))
    //
    //     let data = girdData.map(JSON.stringify).join(',')
    //     const res = rlModules.getSlabDataByOtherGrids(
    //         data,
    //         rl_stdFlr_id.ParaVal,
    //         0,
    //         Number(3000)
    //     )
    //     if (!res) return
    //     const modelData = JSON.parse(res)?.Slab
    //     if (rl_stdFlr_id.ID == -1) {
    //
    //         return
    //     }
    //     modelData.forEach(item => {
    //         let rlSlabObject = new rlSlab()
    //         rlSlabObject.points = item[0].Points
    //         rlSlabObject.index3dData = item[0]['3D']['3dFaces']
    //             .map(item => item.index)
    //             .flat()
    //         rlSlabObject.index2dData = item[0]['2D']

    //         rlSlabObject.member = true

    //         rlAppObj.rlMxDrawObject.addMxEntity(rlSlabObject)
    //         // 添加到组
    //         let rlSlabGroup = rlAppObj.rlMxDatabase.addGroup(rlSlabObject.m_groupName)
    //         rlSlabGroup.append(rlSlabObject)
    //     })

    // }
  });
};

// 框选生成构件
export const structural_multiple_entiy = (
  topBtnActive,
  rl_stdFlr_id,
  selectObj,
  rlModules
) => {
  return new Promise(async (resolve, reject) => {
    if (topBtnActive.name == "墙") {
      // const id = await rlAppObj._rlMx.MxFun.selectEnt("id");
      // if (!id) return;
      if (!topBtnActive.moduleForm) return;
      const moduleForm = topBtnActive.moduleForm;
      const { parameter, tableRow } = moduleForm;

      if (rl_stdFlr_id == -999) {
        return;
      }
      // 拿到对应标准层
      var StlData = await getrlStdFlr(rl_stdFlr_id);
      const rlGridData = selectObj;
      if (!rlGridData) {
        console.warn("当前选择对象为空");
        return;
      }
      if (rlGridData.classTypeName == "rlGrid") {
        // 编号
        const startAxis = get_entity_by_id(rlGridData.m_stJoint.startAxisObjId);
        const endAxis = get_entity_by_id(rlGridData.m_stJoint.endAxisObjId);
        let ModelNo = "";
        if (startAxis && endAxis) {
          const startAxis2 = get_entity_by_id(
            rlGridData.m_edJoint.startAxisObjId
          );
          const endAxis2 = get_entity_by_id(rlGridData.m_edJoint.endAxisObjId);
          if (startAxis2 && endAxis2) {
            // rlWallObject.Name = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${startAxis2.Name}-${endAxis.Name} 墙`
            const mAxis = rlGridData.m_Axis;
            ModelNo = `${rl_stdFlr_id.No_}F ${
              mAxis.axisVector > 0 ? "" : startAxis.Name + "-"
            }${startAxis2.Name}-${endAxis.Name}${
              mAxis.axisVector > 0 ? "-" + endAxis2.Name : ""
            } 墙`;
          }
        }

        if (rlGridData.m_wallId) {
          // 判断当前网格是否存在墙
          const rlWallAssociation = get_entity_by_id(rlGridData.m_wallId);
          if (rlWallAssociation) {
            rlWallAssociation.m_sectParamData.Mat = tableRow.material;
            rlWallAssociation.m_sectParamData.Kind = tableRow.section_param;
            rlWallAssociation.m_sectParamData.B = tableRow.params.B
              ? tableRow.params.B
              : tableRow.params.T;
            rlWallAssociation.m_sectParamData.Guid = tableRow.Guid;
            rlWallAssociation.Height = StlData.Height ?? 3000;
            rlWallAssociation.LevelB = 0;
            rlWallAssociation.Ecc = Number(parameter[0].value);
            rlWallAssociation.HDiff1 = Number(parameter[1].value);
            rlWallAssociation.HDiff2 = Number(parameter[2].value);
            rlWallAssociation.HDiffB = Number(parameter[3].value);
            rlWallAssociation.ModelNo = ModelNo;
            rlWallAssociation.setNeedUpdateDisplay(true);
            rlWallAssociation.statusType = 2;
          }
        } else {
          const rlWallObject = new rlWall();
          const m_sectParamData = new rlWallModelSectData();

          m_sectParamData.Mat = tableRow.material;
          m_sectParamData.Kind = tableRow.section_param;
          m_sectParamData.B = tableRow.params.B
            ? tableRow.params.B
            : tableRow.params.T;
          m_sectParamData.Guid = tableRow.Guid;
          rlWallObject.m_sectParamData = m_sectParamData;
          rlWallObject.m_gridData = rlGridData;
          rlWallObject.Height = StlData.Height ?? 3000;
          rlWallObject.LevelB = 0;
          rlWallObject.Ecc = Number(parameter[0].value);
          rlWallObject.HDiff1 = Number(parameter[1].value);
          rlWallObject.HDiff2 = Number(parameter[2].value);
          rlWallObject.HDiffB = Number(parameter[3].value);
          rlWallObject.ModelNo = ModelNo;

          rlAppObj.rlMxDrawObject.addMxEntity(rlWallObject);
          // 添加到组
          const rlWallGroup = rlAppObj.rlMxDatabase.addGroup(
            rlWallObject.m_groupName
          );
          rlWallGroup.append(rlWallObject);

          // 关联网格对象
          // rlGridData.rlWallObjectId = rlWallObject.objectId()

          resolve(rlWallObject);
        }
      }
    } else if (topBtnActive.name == "梁") {
      // const id = await rlAppObj._rlMx.MxFun.selectEnt("id");
      // if (!id) return;
      if (!topBtnActive.moduleForm) return;
      const moduleForm = topBtnActive.moduleForm;
      const { parameter, tableRow } = moduleForm;

      if (rl_stdFlr_id == -999) {
        return;
      }
      const rlGridData = selectObj;

      if (!rlGridData) {
        console.warn("当前选择对象为空");
        return;
      }
      if (rlGridData.classTypeName == "rlGrid") {
        // 编号
        let ModelNo = "";
        const startAxis = get_entity_by_id(rlGridData.m_stJoint.startAxisObjId);
        const endAxis = get_entity_by_id(rlGridData.m_stJoint.endAxisObjId);
        if (startAxis && endAxis) {
          const startAxis2 = get_entity_by_id(
            rlGridData.m_edJoint.startAxisObjId
          );
          const endAxis2 = get_entity_by_id(rlGridData.m_edJoint.endAxisObjId);
          if (startAxis2 && endAxis2) {
            // rlBeamObject.Name = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${startAxis2.Name}-${endAxis.Name} 梁`
            const mAxis = rlGridData.m_Axis;
            ModelNo = `${rl_stdFlr_id.No_}F ${
              mAxis.axisVector > 0 ? "" : startAxis.Name + "-"
            }${startAxis2.Name}-${endAxis.Name}${
              mAxis.axisVector > 0 ? "-" + endAxis2.Name : ""
            } 梁`;
          }
        }

        if (rlGridData.m_beamId) {
          // 判断当前网格是否存在梁
          const rlBeamAssociation = get_entity_by_id(rlGridData.m_beamId);
          if (rlBeamAssociation) {
            rlBeamAssociation.m_sectParamData.Mat = tableRow.material;
            rlBeamAssociation.m_sectParamData.Kind = tableRow.section_param;
            rlBeamAssociation.m_sectParamData.Guid = tableRow.Guid;
            rlBeamAssociation.m_sectParamData.ShapeVal = `${
              tableRow.section_param
            },${tableRow.section.split("*").join(",")},1,1`;

            rlBeamAssociation.Height = StlData.Height ?? 3000;
            rlBeamAssociation.LevelB = 0;
            rlBeamAssociation.Ecc = Number(parameter[0].value);
            rlBeamAssociation.HDiff1 = Number(parameter[1].value);
            rlBeamAssociation.HDiff2 = Number(parameter[2].value);
            rlBeamAssociation.ModelNo = ModelNo;
            rlBeamAssociation.setNeedUpdateDisplay(true);
            rlBeamAssociation.statusType = 2;
          }
        } else {
          const rlBeamObject = new rlBeam();
          const m_sectParamData = new rlBeamModelSectData();
          m_sectParamData.Mat = tableRow.material;
          m_sectParamData.Kind = tableRow.section_param;
          m_sectParamData.Guid = tableRow.Guid;
          m_sectParamData.ShapeVal = `${
            tableRow.section_param
          },${tableRow.section.split("*").join(",")},1,1`;
          rlBeamObject.m_sectParamData = m_sectParamData;
          rlBeamObject.m_gridData = rlGridData;
          rlBeamObject.Height = StlData.Height ?? 3000;
          rlBeamObject.LevelB = 0;
          rlBeamObject.Ecc = Number(parameter[0].value);
          rlBeamObject.HDiff1 = Number(parameter[1].value);
          rlBeamObject.HDiff2 = Number(parameter[2].value);
          rlBeamObject.ModelNo = ModelNo;
          rlAppObj.rlMxDrawObject.addMxEntity(rlBeamObject);
          // 添加到组
          const rlBeamGroup = rlAppObj.rlMxDatabase.addGroup(
            rlBeamObject.m_groupName
          );
          rlBeamGroup.append(rlBeamObject);

          // 关联网格对象
          // rlGridData.rlBeamObjectId = rlBeamObject.objectId()

          resolve(rlBeamObject);
        }
      }
    } else if (topBtnActive.name == "柱") {
      // const id = await rlAppObj._rlMx.MxFun.selectEnt("id");
      // if (!id) return;
      if (!topBtnActive.moduleForm) return;
      const moduleForm = topBtnActive.moduleForm;
      const { parameter, tableRow } = moduleForm;
      if (rl_stdFlr_id == -999) {
        return;
      }
      const rlPoint = selectObj;
      if (!rlPoint) {
        console.warn("当前选择对象为空");
        return;
      }
      if (rlPoint.classTypeName == "rlJoint") {
        // 编号
        let ModelNo = "";
        const startAxis = get_entity_by_id(rlPoint.startAxisObjId);
        if (startAxis) {
          const endAxis = get_entity_by_id(rlPoint.endAxisObjId);
          ModelNo = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${endAxis.Name} 柱`;
        }
        if (rlPoint.m_cloumId) {
          // 判断当前节点是否存在柱
          const rlColumnAssociation = get_entity_by_id(rlPoint.m_cloumId);
          if (rlColumnAssociation) {
            rlColumnAssociation.m_sectParamData.Mat = tableRow.material;
            rlColumnAssociation.m_sectParamData.Kind = tableRow.section_param;
            rlColumnAssociation.m_sectParamData.Guid = tableRow.Guid;
            rlColumnAssociation.m_sectParamData.ShapeVal = `${
              tableRow.section_param
            },${tableRow.section.split("*").join(",")},1,1`;

            rlColumnAssociation.Height = StlData.Height ?? 3000;
            rlColumnAssociation.LevelB = 0;

            rlColumnAssociation.EccX = Number(parameter[0].value);
            rlColumnAssociation.EccY = Number(parameter[1].value);
            rlColumnAssociation.HDiffB = Number(parameter[2].value);
            rlColumnAssociation.Rotation = Number(parameter[3].value);
            rlColumnAssociation.ModelNo = ModelNo;
            rlColumnAssociation.setNeedUpdateDisplay(true);
            rlColumnAssociation.statusType = 2;
          }
        } else {
          const rlColumnObject = new rlColumn();
          const m_sectParamData = new rlColumnModelSectData();

          m_sectParamData.Mat = tableRow.material;
          m_sectParamData.Kind = tableRow.section_param;
          m_sectParamData.Guid = tableRow.Guid;
          m_sectParamData.No_ = tableRow.No_;
          m_sectParamData.ShapeVal = `${
            tableRow.section_param
          },${tableRow.section.split("*").join(",")},1,1`;

          rlColumnObject.m_JointData = rlPoint;
          rlColumnObject.m_sectParamData = m_sectParamData;
          rlColumnObject.Height = StlData.Height ?? 3000;
          rlColumnObject.LevelB = 0;

          rlColumnObject.EccX = Number(parameter[0].value);
          rlColumnObject.EccY = Number(parameter[1].value);
          rlColumnObject.HDiffB = Number(parameter[2].value);
          rlColumnObject.Rotation = Number(parameter[3].value);
          rlColumnObject.ModelNo = ModelNo;

          rlAppObj.rlMxDrawObject.addMxEntity(rlColumnObject);
          // 添加到组

          const rlColumnGroup = rlAppObj.rlMxDatabase.addGroup(
            rlColumnObject.m_groupName
          );
          rlColumnGroup.append(rlColumnObject);

          // 关联节点对象
          // rlPoint.rlColumnObjectId = rlColumnObject.objectId()

          resolve(rlColumnObject);
        }
      }
    }
  });
};

// 创建柱
export const create_column_ents = async (rl_stdFlr_id, moduleForm) => {
  if (!moduleForm) return;
  const { tableRow } = moduleForm;
  if (rl_stdFlr_id == -999) {
    return;
  }
  // 获取模型页面
  // var el = document.querySelector(".MD_PG");
  // Message.info("请框选需要的对象");
  // 拿到对应标准层
  var rlBuilding = store.state.cadModules.rlBuilding;
  var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
  var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
  // 绘制回调方法
  const set_column = async (ids) => {
    if (!ids || !ids.length) return;

    const rlLayer = await getRlLayer();
    let colColor = rlLayer.filter((item) => item.Type == "rlColSeg");

    if (colColor) colColor = colColor[0].Color;

    // 绘制步数
    store.commit("globalData/setCanAddRawStep", true);

    // 执行loading
    if (ids.length > 30) {
      showFullScreenLoading("正在布置柱..");
      // 确保 showFullScreenLoading 执行完毕
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    try {
      for (const item of ids) {
        const mcObj = item.getMcDbEntity();
        const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
        const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型

        if (objClassName == "rlJoint" || objClassName == "rlJointC") {
          const rlPoint = await getEntityData({
            Guid: objGuid,
            classTypeName: objClassName,
          });

          if (!rlPoint) {
            console.warn("当前选择对象为空");
            continue;
          }

          if (rlPoint.m_cloumId) {
            // 判断当前节点是否存在柱
            const rlColumnAssociation = await getEntityData({
              Guid: rlPoint.m_cloumId,
              classTypeName: "rlColSeg",
            }); // await get_entity_by_id(rlPoint.m_cloumId);
            if (rlColumnAssociation) {
              rlColumnAssociation.saveEditRevokeData();
              // 检测删除同类构件
              if (rlColumnAssociation.m_sectParamData.Guid != tableRow.Guid) {
                const isMain = await checkDeleteHomogeneousMember(
                  "rlColSeg",
                  rlColumnAssociation
                );
                if (isMain == false) {
                  rlColumnAssociation.m_RelationGuid = null;
                }
              }
              rlColumnAssociation.m_sectParamData.Mat = tableRow.material;
              rlColumnAssociation.m_sectParamData.Kind = tableRow.section_param;
              rlColumnAssociation.m_sectParamData.Guid = tableRow.Guid;
              rlColumnAssociation.HDiffB = Number(tableRow.elevation);
              rlColumnAssociation.m_sectParamData.ShapeVal = `${
                tableRow.section_param
              },${tableRow.section.split("*").join(",")},1,1`;

              if (tableRow.construction_column == 1) {
                rlColumnAssociation.Attribute = 2;
              }

              rlColumnAssociation.Height =
                currFlrHeight - Number(tableRow.elevation);
              rlColumnAssociation.LevelB = currFlrLevelB;
              rlColumnAssociation.EccX = 0;
              rlColumnAssociation.EccY = 0;
              rlColumnAssociation.Rotation = 0;
              rlColumnAssociation.flrHeight = currFlrHeight;
              rlColumnAssociation.Color = colColor;
              // rlColumnAssociation.ModelNo = ModelNo;
              // 处理更新后重新布置不展示问题
              rlColumnAssociation.isWasmGeted = false;
              // rlColumnAssociation.draw();
              // rlColumnAssociation.mcDbId = rlAppObj.mxcadObject.drawEntity(
              //   rlColumnAssociation.mcDbPolyline
              // );
              // 将数据存储到indexdb
              rlColumnAssociation.updateThisObj(rlColumnAssociation);
              // rlColumnAssociation.statusType = 2;
            }
          } else {
            let { roomNames, roomNameEnts } = get_Ent_RoomName([rlPoint.Guid]);
            const rlColumnObject = new rlColumnData();
            // let m_sectParamData = new rlColumnModelSectData();
            rlColumnObject.initData({
              m_sectParamData: {
                Mat: tableRow.material,
                Kind: tableRow.section_param,
                ShapeVal: `${tableRow.section_param},${tableRow.section
                  .split("*")
                  .join(",")},1,1`,
                Guid: tableRow.Guid,
              },
              EccX: 0,
              EccY: 0,
              Rotation: 0,
              flrHeight: currFlrHeight,
              LevelB: currFlrLevelB,
              Height: currFlrHeight - Number(tableRow.elevation),
              Color: colColor,
              m_JointData: rlPoint,
              HDiffB: Number(tableRow.elevation),
              Attribute: tableRow.construction_column == 1 ? 2 : 1,
              useFunctionNames: roomNames,
            });
            // 新增构件保存到indexdb
            await rlColumnObject.draw();
            await addEntityToDrawing(rlColumnObject, false);
            // 将柱和房间关联
            for (let w = 0; w < roomNameEnts.length; w++) {
              roomNameEnts[w].saveEditRevokeData();
              roomNameEnts[w].allEntGuids.columnGuids.push(rlColumnObject.Guid);
              roomNameEnts[w].updateThisObj(roomNameEnts[w]);
            }
          }
        }
      }
      // 将操作步骤下的所有数据更新到数据库中
      await saveDatabaseStore();
      await rlAppObj.rlMxDrawObject.updateDisplay();
    } catch (error) {
      console.error("Error during set_column operation:", error);
    } finally {
      tryHideFullScreenLoading();
    }
  };

  userSelect(set_column);
};

// 创建梁
export const create_beam_ents = async (rl_stdFlr_id, moduleForm) => {
  return new Promise(async (resolve, reject) => {
    if (!moduleForm) return;
    const { parameter, tableRow } = moduleForm;

    if (rl_stdFlr_id == -999) {
      return;
    }
    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
    var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
    // Message.info("请框选需要的对象");
    // 获取模型数据元素
    // var el = document.querySelector(".MD_PG");
    // 绘制回调方法
    const set_beam = async (ids) => {
      if (!ids || !ids.length) return;
      // 执行loading
      if (ids.length > 30) {
        showFullScreenLoading("正在布置梁..");
        // 确保 showFullScreenLoading 执行完毕
        // await new Promise((resolve) => setTimeout(resolve, 500));
      }
      try {
        const rlLayer = await getRlLayer();
        let beamColor = rlLayer.filter((item) => item.Type == "rlBeamSeg");
        let subBeamColor = rlLayer.filter((item) => item.Type == "rlSubBeam");
        let ringBeamColor = rlLayer.filter(
          (item) => item.Type == "rlRingBeamSeg"
        );

        if (beamColor) beamColor = beamColor[0].Color;
        if (subBeamColor) subBeamColor = subBeamColor[0].Color;
        if (ringBeamColor) ringBeamColor = ringBeamColor[0].Color;
        // 绘制步
        store.commit("globalData/setCanAddRawStep", true);
        let eraseIds = [];
        let eraseObjs = [];
        for (const item of ids) {
          const mcObj = item.getMcDbEntity();
          if (mcObj) {
            const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
            const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型

            if (objClassName == "rlGrid" || objClassName == "rlGridC") {
              let rlGridData = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              //校验网格是否重叠
              let checkResult = await checkGridOverlap(rlGridData, eraseObjs);
              //完全重叠,删除网格
              if (checkResult.isOverlap) {
                eraseIds.push(rlGridData.Guid);
                eraseObjs.push(rlGridData);
                continue;
              }
              //部分重叠,打断网格
              if (checkResult.isLineInsert) {
                item.erase();
                if (checkResult.newGrid.length > 0) {
                  ids.push(...checkResult.newGrid);
                }
                //重新打开网格
                rlGridData = getEntityData({
                  Guid: rlGridData.Guid,
                  classTypeName: objClassName,
                });
                if (!rlGridData) {
                  continue;
                }
              }
              if (!rlGridData) {
                console.warn("当前选择对象为空");
                continue;
              }
              // 如果是无效网格，不需处理
              if (
                Math.abs(
                  rlGridData.m_stJoint.m_pt[0] - rlGridData.m_edJoint.m_pt[0]
                ) < 1 &&
                Math.abs(
                  rlGridData.m_stJoint.m_pt[1] - rlGridData.m_edJoint.m_pt[1]
                ) < 1
              ) {
                continue;
              }

              if (rlGridData.m_beamId) {
                // 判断当前网格是否存在梁
                const rlBeamAssociation = getEntityData({
                  Guid: rlGridData.m_beamId,
                  classTypeName: "rlBeamSeg",
                });

                if (rlBeamAssociation) {
                  rlBeamAssociation.saveEditRevokeData();

                  // 检测删除同类构件
                  if (rlBeamAssociation.m_sectParamData.Guid != tableRow.Guid) {
                    const isMain = await checkDeleteHomogeneousMember(
                      "rlBeamSeg",
                      rlBeamAssociation
                    );
                    if (isMain == false) {
                      rlBeamAssociation.m_RelationGuid = null;
                    }
                  }
                  rlBeamAssociation.m_sectParamData.Mat = tableRow.material;
                  rlBeamAssociation.m_sectParamData.Kind =
                    tableRow.section_param;
                  rlBeamAssociation.m_sectParamData.Guid = tableRow.Guid;
                  rlBeamAssociation.m_sectParamData.ShapeVal = `${
                    tableRow.section_param
                  },${tableRow.section.split("*").join(",")},1,1`;
                  rlBeamAssociation.m_sectParamData.IsRingBeamSeg =
                    tableRow.IsRingBeamSeg;

                  rlBeamAssociation.Height = currFlrHeight;
                  rlBeamAssociation.LevelB = currFlrLevelB;
                  rlBeamAssociation.Ecc = 0;
                  rlBeamAssociation.HDiff1 = Number(tableRow.topElevation1);
                  rlBeamAssociation.HDiff2 = Number(tableRow.topElevation2);
                  rlBeamAssociation.Rotation = 0;
                  // rlBeamAssociation.ModelNo = ModelNo;

                  // 处理更新后重新布置不展示问题
                  rlBeamAssociation.isWasmGeted = false;
                  // rlBeamAssociation.draw();
                  // rlBeamAssociation.mcDbId = rlAppObj.mxcadObject.drawEntity(
                  //   rlBeamAssociation.mcDbPolyline
                  // );
                  rlBeamAssociation.updateThisObj(rlBeamAssociation);
                  // rlBeamAssociation.statusType = 2;
                }
              } else {
                let { roomNames, roomNameEnts } = get_Ent_RoomName([
                  rlGridData.Guid,
                ]);
                const rlBeamObject = new rlBeamData();
                rlBeamObject.isWasmGeted = false;
                // let m_sectParamData = new rlBeamModelSectData();
                rlBeamObject.initData({
                  m_sectParamData: {
                    Mat: tableRow.material, // 材质
                    Kind: tableRow.section_param, // 截面类型
                    ShapeVal: `${tableRow.section_param},${tableRow.section
                      .split("*")
                      .join(",")},1,1`, // 截面尺寸
                    Guid: tableRow.Guid,
                    IsRingBeamSeg: tableRow.IsRingBeamSeg,
                  },
                  Ecc: 0,
                  HDiff1: Number(tableRow.topElevation1),
                  HDiff2: Number(tableRow.topElevation2),
                  Rotation: 0,
                  LevelB: currFlrLevelB,
                  Height: currFlrHeight,
                  m_gridData: rlGridData,
                  Color: tableRow.IsRingBeamSeg ? ringBeamColor : beamColor,
                  Attribute: 1,
                  beamColor: beamColor,
                  subBeamColor: subBeamColor,
                  ringBeamColor: ringBeamColor,
                  useFunctionNames: roomNames,
                });

                rlBeamObject.draw();
                await addEntityToDrawing(rlBeamObject, false);
                // 将梁和房间关联
                for (let w = 0; w < roomNameEnts.length; w++) {
                  roomNameEnts[w].saveEditRevokeData();
                  roomNameEnts[w].allEntGuids.beamGuids.push(rlBeamObject.Guid);
                  roomNameEnts[w].updateThisObj(roomNameEnts[w]);
                }
              }
            }
          }
        }
        if (eraseIds.length > 0) {
          for (const item of eraseIds) {
            const rlGridData = getEntityData({
              Guid: item,
              classTypeName: "rlGrid",
            });
            if (rlGridData) {
              rlGridData.erase();
            }
          }
        }
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
        rlAppObj.rlMxDrawObject.updateDisplay();
      } catch (error) {
        console.error("Error during set_beam operation:", error);
      } finally {
        tryHideFullScreenLoading();
      }
    };

    // 调用 userSelect 并传递 set_beam 回调
    userSelect(set_beam);
  });
};

// 创建墙
export const create_wall_ents = async (rl_stdFlr_id, row) => {
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) {
      return;
    }
    // 显示 loading
    // let el = document.querySelector(".MD_PG");
    // Message.info("请框选需要的对象");
    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度

    var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
    // 绘制回调方法
    const set_wall = async (ids) => {
      if (!ids || !ids.length) return;

      try {
        const rlLayer = await getRlLayer();
        let wallColor = rlLayer.filter((item) => item.Type == "rlWallSeg");
        if (wallColor && wallColor.length > 0) wallColor = wallColor[0].Color;

        // 绘制步数
        store.commit("globalData/setCanAddRawStep", true);

        // 执行loading
        if (ids.length > 30) {
          showFullScreenLoading("正在布置墙..");
          // 确保 showFullScreenLoading 执行完毕
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        let eraseIds = [];
        let eraseObjs = [];
        const addObjs = [];
        for (const item of ids) {
          const mcObj = item.getMcDbEntity();
          if (mcObj) {
            const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
            const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型

            if (objClassName == "rlGrid" || objClassName == "rlGridC") {
              let rlGridData = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              //校验网格是否重叠
              let checkResult = await checkGridOverlap(rlGridData, eraseObjs);
              //完全重叠,删除网格
              if (checkResult.isOverlap) {
                eraseIds.push(rlGridData.Guid);
                eraseObjs.push(rlGridData);
                continue;
              }
              //部分重叠,打断网格
              if (checkResult.isLineInsert) {
                item.erase();
                if (checkResult.newGrid.length > 0) {
                  ids.push(...checkResult.newGrid);
                }
                //重新打开网格
                rlGridData = getEntityData({
                  Guid: rlGridData.Guid,
                  classTypeName: objClassName,
                });
                if (!rlGridData) {
                  continue;
                }
              }
              if (!rlGridData) {
                console.warn("当前选择对象为空");
                continue;
              }
              // 如果是无效网格，不需处理
              if (
                Math.abs(
                  rlGridData.m_stJoint.m_pt[0] - rlGridData.m_edJoint.m_pt[0]
                ) < 1 &&
                Math.abs(
                  rlGridData.m_stJoint.m_pt[1] - rlGridData.m_edJoint.m_pt[1]
                ) < 1
              ) {
                continue;
              }
              if (rlGridData.m_partitionWallId) continue;

              if (rlGridData.m_wallId) {
                // 判断当前网格是否存在墙
                const rlWallAssociation = getEntityData({
                  Guid: rlGridData.m_wallId,
                  classTypeName: "rlWallSeg",
                });

                if (rlWallAssociation) {
                  rlWallAssociation.saveEditRevokeData();

                  // 检测删除同类构件
                  if (rlWallAssociation.m_sectParamData.Guid != row.Guid) {
                    const isMain = await checkDeleteHomogeneousMember(
                      "rlWallSeg",
                      rlWallAssociation
                    );
                    if (isMain == false) {
                      rlWallAssociation.m_RelationGuid = null;
                    }
                  }
                  rlWallAssociation.m_sectParamData.Mat = Number(row.material);
                  rlWallAssociation.m_sectParamData.Kind = Number(
                    row.section_param
                  );
                  const beforeSectB = rlWallAssociation.m_sectParamData.B;
                  rlWallAssociation.m_sectParamData.B = Number(row.B);
                  rlWallAssociation.m_sectParamData.H =
                    Number(row.H) == 0
                      ? currFlrHeight - Number(row.bottomElevation)
                      : Number(row.H);
                  rlWallAssociation.m_sectParamData.Guid = row.Guid;

                  rlWallAssociation.Height =
                    currFlrHeight - Number(row.bottomElevation);
                  rlWallAssociation.LevelB = Number(row.bottomElevation);
                  rlWallAssociation.Ecc = 0;
                  rlWallAssociation.HDiff1 = Number(row.topElevation1);
                  rlWallAssociation.HDiff2 = Number(row.topElevation2);
                  rlWallAssociation.HDiffB = Number(row.bottomElevation);
                  // 处理更新后重新布置不展示问题
                  rlWallAssociation.isWasmGeted = false;
                  rlWallAssociation.updateThisObj(rlWallAssociation);
                  // rlWallAssociation.draw();

                  // rlWallAssociation.mcDbId = rlAppObj.mxcadObject.drawEntity(
                  //   rlWallAssociation.mcDbPolyline
                  // );
                  // //判断墙上是否   墙洞,判断修改后的厚度是否有改变
                  // if (
                  //   rlGridData.m_wallHoleId &&
                  //   beforeSectB !== rlWallAssociation.m_sectParamData.B
                  // ) {
                  //   let rlWallHoleAssociation = getEntityData({
                  //     Guid: rlGridData.m_wallHoleId,
                  //     classTypeName: "rlWallHole",
                  //   });
                  //   if (rlWallHoleAssociation) {
                  //     rlWallHoleAssociation.m_wallThick =
                  //       rlWallAssociation.m_sectParamData.B;
                  //     rlWallHoleAssociation.isWasmGeted = true;
                  //     await rlWallHoleAssociation.updateThisObj(
                  //       rlWallHoleAssociation
                  //     );
                  //     // rlWallHoleAssociation.draw();

                  //     // rlWallHoleAssociation.mcDbId =
                  //     //   rlAppObj.mxcadObject.drawEntity(
                  //     //     rlWallHoleAssociation.mcDbPolyline
                  //     //   );
                  //   }
                  // }
                }
              } else {
                let { roomNames, roomNameEnts } = get_Ent_RoomName([
                  rlGridData.Guid,
                ]);
                const rlWallObject = new rlWallData();
                rlWallObject.initData({
                  m_sectParamData: {
                    Mat: Number(row.material), // 材质
                    Kind: Number(row.section_param), // 截面类型
                    B: Number(row.B), // 墙厚
                    H:
                      Number(row.H) == 0
                        ? currFlrHeight - Number(row.bottomElevation)
                        : Number(row.H),
                    Guid: row.Guid,
                  },
                  Ecc: 0,
                  HDiff1: Number(row.topElevation1),
                  HDiff2: Number(row.topElevation2),
                  LevelB: Number(row.bottomElevation),
                  Height: currFlrHeight - Number(row.bottomElevation),
                  HDiffB: Number(row.bottomElevation),
                  m_gridData: rlGridData,
                  Color: wallColor,
                  Attribute: 1,
                  useFunctionNames: roomNames,
                });

                rlWallObject.draw();
                await addEntityToDrawing(rlWallObject, false);
                addObjs.push(rlWallObject.getDataBase());
                // 将墙和房间关联
                for (let w = 0; w < roomNameEnts.length; w++) {
                  roomNameEnts[w].saveEditRevokeData();
                  roomNameEnts[w].allEntGuids.wallGuids.push(rlWallObject.Guid);
                  roomNameEnts[w].updateThisObj(roomNameEnts[w]);
                }
              }
            }
          }
        }
        if (eraseIds.length > 0) {
          for (const item of eraseIds) {
            const rlGridData = getEntityData({
              Guid: item,
              classTypeName: "rlGrid",
            });
            if (rlGridData) {
              rlGridData.erase();
            }
          }
        }
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
        // 更新显示
        await rlAppObj.rlMxDrawObject.updateDisplay();
      } catch (error) {
        console.error("Error during set_wall operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };

    // 调用 userSelect 并传递 set_wall 回调
    userSelect(set_wall);
  });
};

//检查当前构件是否主构件,如果是,把相应的同类构件置空
export const checkRelationGuidData = async (Guid, classTypeName) => {
  const allEnt = store.state.rlEntData.totalEntityData[classTypeName];
  allEnt.forEach((item) => {
    if (item.m_RelationGuid == Guid) {
      item.saveEditRevokeData();
      item.m_RelationGuid = null;
      item.updateThisObj(item);
    }
  });
  // await saveDatabaseStore();
};

// 检测删除同类构件
export const checkDeleteHomogeneousMember = async (
  classTypeName,
  rlColumnAssociation
) => {
  let isMain = null;
  const rlEntData = store.state.rlEntData.totalEntityData[classTypeName];
  const GroupData = [];
  for (let i = 0; i < rlEntData.length; i++) {
    if (rlEntData[i].m_RelationGuid) {
      const findGroupIndex = GroupData.findIndex(
        (item) => item.RelationGuid == rlEntData[i].m_RelationGuid
      );
      if (findGroupIndex != -1) {
        GroupData[findGroupIndex].childGuid.push(rlEntData[i].Guid);
      } else {
        GroupData.push({
          RelationGuid: rlEntData[i].m_RelationGuid,
          childGuid: [rlEntData[i].Guid],
        });
      }
    }
  }

  if (GroupData.length > 0) {
    let RelationGuid = rlColumnAssociation.m_RelationGuid;
    if (!RelationGuid) {
      // 如果同类构件没有关联，则将当前构件的Guid作为关联,因为主构件的m_RelationGuid是null的
      RelationGuid = rlColumnAssociation.Guid;
    }
    const findGroupData = GroupData.find(
      (item) => item.RelationGuid == RelationGuid
    );
    // 主构件
    if (
      findGroupData &&
      findGroupData.RelationGuid == rlColumnAssociation.Guid
    ) {
      isMain = true;
      for (const item of findGroupData.childGuid) {
        const rlColumnTemp = await getEntityData({
          Guid: item,
          classTypeName: classTypeName,
        });
        rlColumnTemp.saveEditRevokeData();
        rlColumnTemp.m_RelationGuid = null;
        rlColumnTemp.updateThisObj(rlColumnTemp);
      }
    } else if (findGroupData) {
      // 判断当前构件是否是同类构件
      if (findGroupData.childGuid.includes(rlColumnAssociation.Guid)) {
        isMain = false;
      }
    }
  } else return null;
  return isMain;
};

// 创建隔墙
export const create_partitionWall_ents = async (
  rl_stdFlr_id,
  row,
  drawType
) => {
  if (drawType == 0) {
    // 根据网格布置隔墙
    await create_partitionWall_ents_byGrid(rl_stdFlr_id, row, drawType);
  } else {
    await drawFreePartitionWall(rl_stdFlr_id, row, drawType);
    // if (!store.state.app.isPcMode) {
    //   // 自由绘制隔墙
    //   await create_partitionWall_ents_byFreeDrawAd(rl_stdFlr_id, row, drawType);
    // } else {
    //   await create_partitionWall_ents_byFreeDraw(rl_stdFlr_id, row, drawType);
    // }
  }
};

// 绘制自由隔墙
export const drawFreePartitionWall = async (
  rl_stdFlr_id,
  row,
  drawType,
  ptOrigin = null
) => {
  // 调用绘制函数并等待结果返回
  const res = await create_partitionWall_ents_byFreeDrawNew(
    rl_stdFlr_id,
    row,
    drawType,
    5,
    ptOrigin
  );
  if (res && Object.keys(res).length === 0) {
    // 如果res为空，则继续绘制
    return drawFreePartitionWall(rl_stdFlr_id, row, drawType);
  }
  return false;
};

//新自由绘制隔墙
export const create_partitionWall_ents_byFreeDrawNew = async (
  rl_stdFlr_id,
  row,
  drawType,
  straightLineSimulate,
  ptOrigin
) => {
  //打开鼠标捕捉
  store.commit("cadModules/setSnapPoint", {
    snapPoint: null,
    needCatchSnap: true,
  });
  return new Promise((resolve, reject) => {
    // 实例化取点对象
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    getPoint.clearLastInputPoint();

    // 鼠标第一次点击
    if (!ptOrigin) {
      // 关闭正交模式
      fixOrthogonal(false);
      getPoint.go((status) => {
        if (status === -1 || status !== 0 || !straightLineSimulate) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识
          store.commit("globalData/setFreePartitionWallPoints", []);
          return resolve();
        }

        store.commit("drawModules/setDrawPlay", true);
        // 开启正交模式
        fixOrthogonal(true);

        // 当前鼠标位置
        let pt1 = store.state.cadModules.snapPoint.snapPoint; //getPoint.value();
        store.commit("cadModules/setSnapPoint", {
          snapPoint: pt1,
          needCatchSnap: false,
        });
        // //设置捕捉优化
        if (!pt1) {
          pt1 = getPoint.value();
          let snapPoint = enableSnapCorrection(pt1);
          pt1 = snapPoint ? snapPoint : pt1;
        }

        let res = drawFreePartitionWallDraw(
          rl_stdFlr_id,
          row,
          drawType,
          getPoint,
          pt1,
          straightLineSimulate
        );
        resolve(res);
      });
    } else {
      fixOrthogonal(true);
      let res = drawFreePartitionWallDraw(
        rl_stdFlr_id,
        row,
        drawType,
        getPoint,
        ptOrigin,
        straightLineSimulate
      );
      resolve(res);
    }
    getPoint.clearLastInputPoint();
    store.commit("drawModules/setDrawPlay", false);
  });
};

export const drawFreePartitionWallDraw = (
  rl_stdFlr_id,
  row,
  drawType,
  getPoint,
  pt1,
  straightLineSimulate
) => {
  let modulusDistance = 0; // 模数距离
  // 获取隔墙厚度参数
  const wallThick = Number(row.B);
  let angle = 0; // 角度
  let midPoint = null; // 中点
  var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
  const wallColor = getNonStructuralColor(Number(row.Mat));
  getPoint.setBasePt(pt1);
  let polyLineId = null;
  // 保存初始点
  store.commit("globalData/setFreePartitionWallPoints", [pt1]);
  return new Promise((resolve, reject) => {
    let inputElement = getInputElement();
    if (!inputElement) {
      inputElement = createInputElement();
      setContainerShow(false);
    } else if (inputElement.style.display == "none") {
      setContainerShow(false);
    }
    // 绘制步数
    store.commit("globalData/setCanAddRawStep", true);
    inputElement.readOnly = true;
    getPoint.setUserDraw((currentPoint, pWorldDraw) => {
      // 获取当前视区的显示范围
      const viewDocCoord =
        rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord();

      // 开启正交模式并设置点
      fixOrthogonal(true);

      const isOrthogonal = store.state.platBtns.isOrthogonal;
      //当开启正交的时候,纠正偏移,正交有bug,没办法,只能来硬的了
      if (isOrthogonal) {
        // 在需要判断方向的地方使用:
        let direction = new THREE.Vector3()
          .subVectors(pt1, currentPoint)
          .normalize();
        if (Math.abs(direction.x) > Math.abs(direction.y)) {
          // 更偏向于X轴的处理
          currentPoint.y = pt1.y;
        } else {
          // 更偏向于Y轴的处理
          currentPoint.x = pt1.x;
        }
      }

      let snapPoint = enableSnapCorrection(currentPoint, pt1);
      currentPoint = snapPoint ? snapPoint : currentPoint;
      store.commit("globalData/setFreePartitionWallPoints", [
        pt1,
        currentPoint,
      ]);

      if (store.state.globalData.freePartitionWallPoints.length >= 2) {
        const startPoint = pt1;
        const endPoint = currentPoint.clone();
        const distance = startPoint.distanceTo(endPoint);

        // 如果在移动设备上并且距离小于等于5，不显示任何内容
        if (isMobileDevice() && distance <= 5) {
          // 清除所有绘制内容和输入框
          if (typeof pWorldDraw.clear === "function") {
            pWorldDraw.clear();
          }
          // 清空输入框中的内容并隐藏
          if (inputElement) {
            inputElement.value = "";
            setContainerShow(false);
          }
          return;
        }

        // 调整距离到模数的最近整数倍
        modulusDistance =
          Math.ceil(distance / straightLineSimulate) * straightLineSimulate;
        endPoint
          .sub(startPoint)
          .normalize()
          .multiplyScalar(modulusDistance)
          .add(startPoint);
        store.commit("globalData/setFreePartitionWallPoints", [
          startPoint,
          endPoint,
        ]);
        // 计算中点位置用于显示距离
        midPoint = new THREE.Vector3().lerpVectors(startPoint, endPoint, 0.5);
        // 显示输入元素及文本
        setContainerShow(true);
        setInputElementPosition(
          modulusDistance.toFixed(0),
          midPoint.x,
          midPoint.y
        );
        // 获取矩形点集，用于绘制隔墙轮廓
        const RectPoints = getRectPoints(startPoint, endPoint, wallThick);
        if (polyLineId) {
          //打开多段线
          let plineObj = polyLineId.getMcDbEntity();
          // 将矩形点添加到多段线中
          for (let i = 0; i < RectPoints.length; i++) {
            plineObj.setPointAt(i, RectPoints[i]);
          }
        } else {
          // 创建临时多段线用于预览
          const tempPolyLine = new McDbPolyline();
          RectPoints.forEach((item) => {
            tempPolyLine.addVertexAt(item);
          });
          tempPolyLine.trueColor = new McCmColor(
            wallColor.r,
            wallColor.g,
            wallColor.b
          );
          polyLineId = rlAppObj.mxcadObject.drawEntity(tempPolyLine);
          setOtherData({
            rl_stdFlr_id,
            row,
            drawType,
            polylineObj: polyLineId,
          });
        }
      }
    });
    // 设置触摸事件
    getPoint.setInputToucheType(2);
    getPoint.go(async (status2) => {
      window.canvas
        .getContext("2d")
        .clearRect(0, 0, canvas.width, canvas.height); //清空捕捉标识

      inputElement.readOnly = false;
      // 鼠标右键结束绘制
      if (status2 !== 0) {
        // 右键取消时清空点数组
        return resolve();
      }
      if (polyLineId) {
        polyLineId.erase();
      }
      // 如果只有一个点或没有点，就直接返回
      if (store.state.globalData.freePartitionWallPoints.length <= 1) {
        store.commit("globalData/setFreePartitionWallPoints", []);
        // 返回一个空对象，表示需要继续绘制
        return resolve({});
      }

      // 检查最终的两点之间的距离，确保大于500才绘制（仅移动设备）
      const finalDistance =
        store.state.globalData.freePartitionWallPoints[0].distanceTo(
          store.state.globalData.freePartitionWallPoints[1]
        );

      if (isMobileDevice() && finalDistance <= 5) {
        // 如果在移动设备上并且最终距离小于等于5，不创建轴线，并清空点数组
        store.commit("globalData/setFreePartitionWallPoints", []);
        // 返回一个空对象，表示需要继续绘制
        return resolve({});
      }

      let startPoint = new McGePoint3d(
        store.state.globalData.freePartitionWallPoints[0]
      );
      let endPoint = new McGePoint3d(
        store.state.globalData.freePartitionWallPoints[1]
      );

      let tempPoints = [startPoint, endPoint];
      // console.log("startPoint x:", startPoint.x, "y:", startPoint.y);
      // console.log("endPoint x:", endPoint.x, "y:", endPoint.y);
      // 处理与已有隔墙的相交情况
      const groupPoints = await handlePartitionWallIntersection(tempPoints);

      // 遍历分组点，创建隔墙实体
      for (let i = 0; i < groupPoints.length; i++) {
        if (isPointEqual(groupPoints[i].startPoint, groupPoints[i].endPoint)) {
          continue;
        }
        // 准备隔墙的其他数据
        const otherData = {
          startPoint: {
            x: groupPoints[i].startPoint.x,
            y: groupPoints[i].startPoint.y,
            z: 0,
          },
          endPoint: {
            x: groupPoints[i].endPoint.x,
            y: groupPoints[i].endPoint.y,
            z: 0,
          },
        };

        // 转换为字符串
        const otherDataStr = JSON.stringify(otherData);

        // 创建隔墙数据对象
        const rlPartitionWallObject = new rlPartitionWallData();

        // 初始化隔墙数据
        rlPartitionWallObject.initData({
          m_sectParamData: {
            Mat: Number(row.Mat), // 材质
            Kind: Number(row.section_param), // 截面类型
            B: Number(row.B), // 墙厚
            Guid: row.Guid, // 全局唯一标识符
          },
          OtherData: otherDataStr, // 其他数据
          Ecc: 0, // 偏心率
          Mat: Number(row.Mat), // 材质
          partitionWallHeight: Number(row.H), // 隔墙高度
          LevelB: currFlrLevelB, // 楼层标高
          Color: wallColor, // 颜色
          Attribute: 0, // 属性
          m_gridData: null, // 网格数据
          LinkGuids: [], // 关联的GUID
        });

        // 绘制隔墙实体
        rlPartitionWallObject.draw();

        if (rlPartitionWallObject.index2dData) {
          // 将隔墙实体添加到图纸中
          await addEntityToDrawing(rlPartitionWallObject, false);
        }
        if (i == groupPoints.length - 1) {
          let dist = groupPoints[i].startPoint.distanceTo(
            groupPoints[i].endPoint
          );
          // 计算中点位置用于显示距离
          let midTmpPoint = new THREE.Vector3().lerpVectors(
            groupPoints[i].startPoint,
            groupPoints[i].endPoint,
            0.5
          );
          // 显示输入元素及文本
          setContainerShow(true);
          setInputElementPosition(
            dist.toFixed(0),
            midTmpPoint.x,
            midTmpPoint.y
          );
          setCurrDataObj(rlPartitionWallObject);
        }
        // addObjs.push(rlPartitionWallObject.getDataBase());
      }

      rlAppObj.rlMxDrawObject.updateDisplay();
      saveDatabaseStore();
      // setInputBlur();
      return resolve({});
    });
  });
};

// 自由绘制隔墙 - 通过用户自由绘制的方式创建隔墙
export const create_partitionWall_ents_byFreeDrawAd = async (
  rl_stdFlr_id, // 标准楼层ID，用于确定隔墙所在的楼层
  row, // 隔墙的参数信息，包含材质、厚度等属性
  drawType // 绘制类型，用于区分不同的绘制模式
) => {
  // 返回一个Promise，使函数可以异步执行
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;

    // 在最外层作用域定义事件处理器变量
    const handleInterrupt = null;

    // 定义removeEventListeners函数在最外层作用域
    const removeEventListeners = () => {
      try {
        if (handleInterrupt) {
          window.removeEventListener("commandInterrupt", handleInterrupt);
        }
      } catch (error) {
        console.warn("移除事件监听器失败:", error);
      }
    };

    try {
      // 定义自由布置隔墙的核心函数
      const set_partitionWall = async () => {
        /**
         * 隔墙自由绘制逻辑
         * 通过getPoint.go获取用户点击的点
         *
         * 这是一个内部使用的函数，不直接从外部调用
         */

        // 创建用于存储需要清理的临时资源的对象
        const cleanup = {
          previewPlineIds: [], // 存储预览多段线的ID列表
          overButton: null, // 存储结束按钮引用
          auxiliaryLineId: null, // 存储辅助线ID
        };

        // 定义资源清理函数，用于清除所有临时创建的图形对象和UI元素
        const cleanupResources = () => {
          // 清除所有预览线
          if (cleanup.previewPlineIds && cleanup.previewPlineIds.length > 0) {
            cleanup.previewPlineIds.forEach((id) => {
              if (id && id.getMcDbEntity) {
                try {
                  id.erase();
                } catch (e) {
                  console.warn("清除预览线失败:", e);
                }
              }
            });
            cleanup.previewPlineIds = []; // 清空预览线ID数组
          }

          // 清除辅助线
          if (
            cleanup.auxiliaryLineId &&
            cleanup.auxiliaryLineId.getMcDbEntity
          ) {
            try {
              cleanup.auxiliaryLineId.erase();
            } catch (e) {
              console.warn("清除辅助线失败:", e);
            }
            cleanup.auxiliaryLineId = null;
          }

          // 销毁结束按钮
          if (cleanup.overButton) {
            try {
              // 确保按钮被隐藏
              cleanup.overButton.style.display = "none";
              destroyOverButton(); // 调用销毁按钮的函数
            } catch (e) {
              console.warn("销毁按钮失败:", e);
            }
            cleanup.overButton = null;
          }

          // 隐藏输入框（如果存在）
          if (getInputElement() && getInputElement().style.display == "block") {
            try {
              eraseOtherData(); // 擦除其他相关数据
              getInputElement().style.display = "none"; // 隐藏输入框
            } catch (e) {
              console.warn("隐藏输入框失败:", e);
            }
          }

          // 清除绘制回调
          if (window.currentSetUserDrawCallback) {
            window.currentSetUserDrawCallback = null;
          }

          // 停止当前命令的执行
          if (rlAppObj._rlMx && rlAppObj._rlMx.MxFun) {
            try {
              rlAppObj._rlMx.MxFun.stopRunCommand();
            } catch (e) {
              console.warn("停止命令执行失败:", e);
            }
          }

          // 移除事件监听器
          removeEventListeners();
        };

        try {
          // 获取当前楼层的标高，默认为0
          var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;

          // 获取隔墙颜色，根据材质类型确定
          const wallColor = getNonStructuralColor(Number(row.Mat));

          // 创建数组用于存储用户绘制的所有点
          const points = [];

          // 预览多段线的ID变量（将在绘制过程中不断更新）
          let previewId;

          // 获取隔墙厚度参数
          const wallThick = Number(row.B);

          // 创建用于获取用户点击点位的对象
          const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();

          // 标记是否是第一个点，用于区分不同的处理逻辑
          let isFirstPoint = true;

          // 用于存储捕捉到的点，提升作用域，使handlePointSelection可以访问
          let ptCapture = null;

          // 确保之前可能存在的资源被完全清理
          cleanupResources();

          // 创建用于结束绘制的按钮
          const overButton = createOverButton();
          overButton.style.display = "none"; // 初始时隐藏按钮
          cleanup.overButton = overButton; // 添加到清理列表

          // 定义外部中断处理函数（如用户取消操作时调用）
          // 现在handleInterrupt在外部作用域已定义，这里只是赋值
          const handleInterrupt = () => {
            cleanupResources(); // 执行资源清理
          };

          // 注册中断处理器，监听命令中断事件
          window.addEventListener("commandInterrupt", handleInterrupt);

          // 标记是否继续绘制的布尔值
          let bGoOnDraw = false;

          // 标记是否通过点击结束按钮退出，需要在结束时执行stopRunCommand
          let needStopCommandAfterCleanup = false;

          // 获取已有的所有隔墙数据，用于辅助绘制和相交处理
          const allPartitionWalls =
            store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];

          // 创建数组记录现有的隔墙线段，用于后续的辅助线查找
          const partitionWallLines = [];
          for (let i = 0; i < allPartitionWalls.length; i++) {
            partitionWallLines.push({
              stPt: allPartitionWalls[i].startPoint, // 起点
              edPt: allPartitionWalls[i].endPoint, // 终点
            });
          }

          // 获取当前CAD对象
          const mxcad = MxCpp.getCurrentMxCAD();

          // 设置虚线类型，用于绘制辅助线
          mxcad.addLinetype("MyLineType", "6,-10");

          // 创建辅助线对象
          const auxiliaryLineId = mxcad.drawLine(0, 0, 0, -100);
          cleanup.auxiliaryLineId = auxiliaryLineId; // 保存到cleanup对象中
          const auxiliaryLineObj = auxiliaryLineId.getMcDbEntity();
          auxiliaryLineObj.linetype = "MyLineType"; // 设置为虚线
          auxiliaryLineObj.visible = false; // 初始化为不可见

          /**
           * 处理点选择的函数，可以通过getPoint.go调用或直接传入坐标调用
           * @param {number} status - 状态码：0表示成功，-1表示取消
           * @param {Object} pointValue - 点坐标对象，包含x、y属性
           * @param {boolean} isDirectInput - 是否是直接输入的坐标（而非通过getPoint.go获取）
           * @returns {Object|null} - 返回点坐标对象或null（取消时）
           */
          const handlePointSelection = async (
            status,
            pointValue,
            isDirectInput = false
          ) => {
            // 视图坐标
            const viewDocCoord =
              rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord(); // 获取当前视图的文档坐标
            // 计算视图的宽度差值
            const coordDiffX = Math.abs(
              viewDocCoord.pt4.x - viewDocCoord.pt1.x
            );
            // 动态计算视图差值
            const difflength = coordDiffX / 15;
            // 清除预览线和辅助线，避免重复绘制
            if (auxiliaryLineObj) {
              auxiliaryLineObj.visible = false;
            }

            if (status === 0) {
              // 成功获取到点，显示结束按钮
              if (overButton) {
                overButton.style.display = "block";
                setOverButtonPosition(pointValue.x, pointValue.y + difflength);
              }

              // 处理点击点，创建3D点对象
              let clickPoint = new McGePoint3d(pointValue.x, pointValue.y, 0);

              // 应用捕捉优化，纠正点的位置（直接输入的坐标不需要捕捉优化）
              if (!isDirectInput) {
                const snapPoint = enableSnapCorrection(
                  clickPoint,
                  null,
                  false,
                  100
                );
                clickPoint = snapPoint || clickPoint;
              }

              // 初始化上一个点为当前点
              let prevPoint = new McGePoint3d(clickPoint.x, clickPoint.y, 0);

              // 控制是否设置输入实体的标志
              let bSetInputEnt = false;

              // 如果不是第一个点，则使用上一个点作为参考
              if (!isFirstPoint) {
                prevPoint = new McGePoint3d(
                  points[points.length - 1].x,
                  points[points.length - 1].y,
                  0
                );
                bSetInputEnt = true; // 需要设置输入实体
              } else {
                isFirstPoint = false; // 标记不再是第一个点
              }

              // 判断是否有捕捉点，且当前点与捕捉点距离足够近
              if (
                !isDirectInput &&
                ptCapture &&
                clickPoint.distanceTo(ptCapture) <= 100
              ) {
                clickPoint = ptCapture; // 使用捕捉点
                ptCapture = null; // 清除捕捉点
              }

              // 将点添加到点集合中
              points.push(clickPoint);

              // 创建临时多段线用于预览
              const tempPolyLine = new McDbPolyline();

              // 获取矩形点集，用于绘制隔墙轮廓
              const RectPoints = getRectPoints(
                prevPoint,
                clickPoint,
                wallThick
              );

              // 将矩形点添加到多段线中
              RectPoints.forEach((item) => {
                tempPolyLine.addVertexAt(item);
              });

              // 设置多段线为闭合，形成封闭的隔墙轮廓
              tempPolyLine.isClosed = true;

              // 设置多段线颜色，与隔墙材质对应
              // 如果不是第一个点且线段长度小于300，使用红色显示预览线
              if (!isFirstPoint) {
                const distance = clickPoint.distanceTo(prevPoint);
                if (distance < 300) {
                  // 使用红色显示不符合长度要求的线段
                  tempPolyLine.trueColor = new McCmColor(255, 0, 0);
                } else {
                  // 使用正常颜色
                  tempPolyLine.trueColor = new McCmColor(
                    wallColor.r,
                    wallColor.g,
                    wallColor.b
                  );
                }
              } else {
                // 第一个点使用正常颜色
                tempPolyLine.trueColor = new McCmColor(
                  wallColor.r,
                  wallColor.g,
                  wallColor.b
                );
              }

              // 绘制预览多段线
              previewId = rlAppObj.mxcadObject.drawEntity(tempPolyLine);
              // 如果已经有预览多段线，先清除
              if (
                cleanup.previewPlineIds &&
                cleanup.previewPlineIds.length > 0
              ) {
                cleanup.previewPlineIds.forEach((id) => {
                  if (id && id.getMcDbEntity) {
                    try {
                      id.erase();
                    } catch (e) {
                      console.warn("清除预览线失败:", e);
                    }
                  }
                });
                cleanup.previewPlineIds = []; // 清空预览线ID数组
              }
              // 将新的预览ID添加到清理列表
              cleanup.previewPlineIds.push(previewId);

              // 如果是绘制后续点且已经有预览线，则创建实际的隔墙实体
              if (bSetInputEnt && cleanup.previewPlineIds.length >= 1) {
                bGoOnDraw = true; // 标记继续绘制

                // 准备处理隔墙的点集
                const tempPoints = [];
                tempPoints.push(prevPoint); // 添加起点
                tempPoints.push(clickPoint); // 添加终点

                // 处理与已有隔墙的相交情况
                const groupPoints = await handlePartitionWallIntersection(
                  tempPoints
                );

                // 初始化变量，用于记录最后创建的隔墙对象和点
                let lastPartitionWallObj = null;
                let lastStartPoint = null;
                let lastEndPoint = null;

                // 遍历分组点，创建隔墙实体
                for (let i = 0; i < groupPoints.length; i++) {
                  if (
                    isPointEqual(
                      groupPoints[i].startPoint,
                      groupPoints[i].endPoint
                    )
                  ) {
                    continue;
                  }
                  // 准备隔墙的其他数据
                  const otherData = {
                    startPoint: {
                      x: groupPoints[i].startPoint.x,
                      y: groupPoints[i].startPoint.y,
                      z: 0,
                    },
                    endPoint: {
                      x: groupPoints[i].endPoint.x,
                      y: groupPoints[i].endPoint.y,
                      z: 0,
                    },
                  };

                  // 保存新的隔墙线段，用于后续找辅助线
                  partitionWallLines.push({
                    stPt: groupPoints[i].startPoint,
                    edPt: groupPoints[i].endPoint,
                  });

                  // 转换为字符串
                  const otherDataStr = JSON.stringify(otherData);

                  // 创建隔墙数据对象
                  const rlPartitionWallObject = new rlPartitionWallData();

                  // 初始化隔墙数据
                  rlPartitionWallObject.initData({
                    m_sectParamData: {
                      Mat: Number(row.Mat), // 材质
                      Kind: Number(row.section_param), // 截面类型
                      B: Number(row.B), // 墙厚
                      Guid: row.Guid, // 全局唯一标识符
                    },
                    OtherData: otherDataStr, // 其他数据
                    Ecc: 0, // 偏心率
                    Mat: Number(row.Mat), // 材质
                    partitionWallHeight: Number(row.H), // 隔墙高度
                    LevelB: currFlrLevelB, // 楼层标高
                    Color: wallColor, // 颜色
                    Attribute: 0, // 属性
                    m_gridData: null, // 网格数据
                    LinkGuids: [], // 关联的GUID
                  });

                  // 绘制隔墙实体
                  rlPartitionWallObject.draw();

                  if (rlPartitionWallObject.index2dData) {
                    // 将隔墙实体添加到图纸中
                    await addEntityToDrawing(rlPartitionWallObject, false);

                    // 如果是最后一个分段，记录其信息用于后续处理
                    if (i == groupPoints.length - 1) {
                      lastPartitionWallObj = rlPartitionWallObject;
                      lastStartPoint = groupPoints[i].startPoint;
                      lastEndPoint = groupPoints[i].endPoint;
                    }
                  }

                  // addObjs.push(rlPartitionWallObject.getDataBase());
                }
                // 擦除其他数据
                eraseOtherData();
                if (lastEndPoint && lastStartPoint) {
                  // 设置其他数据，用于后续编辑和显示
                  setOtherData({
                    type: "partitionWall", // 类型为隔墙
                    clickPoint: lastEndPoint, // 点击点（终点）
                    prevPoint: lastStartPoint, // 上一个点（起点）
                    wallThick: wallThick, // 墙厚
                    partitionWallObj: lastPartitionWallObj, // 隔墙对象
                    vecMove: new THREE.Vector3()
                      .subVectors(lastEndPoint, lastStartPoint)
                      .normalize(), // 移动方向向量
                  });

                  // 添加长度输入框
                  let inputElement = getInputElement();
                  if (!inputElement) {
                    // 如果不存在输入框则创建
                    inputElement = createInputElement();
                  } else {
                    // 显示容器
                    setContainerShow(true);
                  }

                  // 计算隔墙中点位置，用于放置输入框
                  const midX = (lastEndPoint.x + lastStartPoint.x) / 2;
                  const midY = (lastEndPoint.y + lastStartPoint.y) / 2;

                  // 设置输入框位置和初始值（显示线段长度）
                  setInputElementPosition(
                    lastEndPoint.distanceTo(lastStartPoint).toFixed(0),
                    midX,
                    midY
                  );

                  // 获取多段线对象，用于关联到输入框
                  const plineObj =
                    cleanup.previewPlineIds[
                      cleanup.previewPlineIds.length - 1
                    ].getMcDbEntity();
                  setCurrDataObj(plineObj);
                }
              }

              // 返回获取到的点位
              return pointValue;
            } else if (status === -1) {
              // 取消或发生错误时，清理按钮
              await destroyOverButton();
              return null;
            }
          };

          // 进入绘制循环，直到用户完成绘制或取消操作
          while (true) {
            // 视图坐标
            const viewDocCoord =
              rlAppObj._rlMx.MxFun.getCurrentDraw().getViewDocCoord(); // 获取当前视图的文档坐标
            // 计算视图的宽度差值
            const coordDiffX = Math.abs(
              viewDocCoord.pt4.x - viewDocCoord.pt1.x
            );
            // 动态计算视图差值
            const difflength = coordDiffX / 30;
            const difflength2 = coordDiffX / 200;

            // 显示提示信息，指导用户进行操作
            oneMessage.info(isFirstPoint ? "请点击第一个点" : "请点击下一个点");

            // 获取用户点击的点位，使用Promise等待用户交互
            const clickPoint = await new Promise((resolve) => {
              // 设置捕捉点状态，启用捕捉功能
              store.commit("cadModules/setSnapPoint", {
                snapPoint: null,
                needCatchSnap: true,
              });

              // 用于存储捕捉到的点
              ptCapture = null;

              // 定义用户绘制回调函数，处理鼠标移动过程中的实时预览
              const userDrawCallback = async (currentPoint) => {
                // 减少节流时间到50ms，提高响应速度
                if (
                  userDrawCallback.lastCallTime &&
                  Date.now() - userDrawCallback.lastCallTime < 5
                ) {
                  return true;
                }

                userDrawCallback.lastCallTime = Date.now();

                // 优化点移动距离检测
                if (userDrawCallback.lastPoint) {
                  const minDistance = 0.1; // 降低最小移动距离阈值，提高灵敏度
                  const dx = currentPoint.x - userDrawCallback.lastPoint.x;
                  const dy = currentPoint.y - userDrawCallback.lastPoint.y;
                  const distance = Math.sqrt(dx * dx + dy * dy);

                  if (distance < minDistance) {
                    return true;
                  }
                }

                // 保存当前点作为下一次比较的基准
                userDrawCallback.lastPoint = {
                  x: currentPoint.x,
                  y: currentPoint.y,
                };

                // 获取正交模式的当前状态
                const isOrthogonal = store.state.platBtns.isOrthogonal;

                // 根据是否为第一个点，控制正交模式
                // 使用状态变量跟踪正交模式的切换，避免频繁切换
                if (!isFirstPoint) {
                  // 非第一个点时，只在必要时打开正交模式
                  if (!userDrawCallback.orthogonalEnabled && isOrthogonal) {
                    fixOrthogonal(true);
                    userDrawCallback.orthogonalEnabled = true;
                  }
                } else {
                  // 第一个点时，只在必要时关闭正交模式
                  if (
                    userDrawCallback.orthogonalEnabled ||
                    userDrawCallback.orthogonalEnabled === undefined
                  ) {
                    fixOrthogonal(false);
                    userDrawCallback.orthogonalEnabled = false;
                  }
                }

                // 检查是否点击了结束按钮
                if (getClickOverButtonType()) {
                  getPoint.clearLastInputPoint(); // 清除最后的输入点
                  store.commit("drawModules/setDrawPlay", false); // 设置绘制状态为结束

                  // 清理UI元素
                  eraseOtherData();

                  // 先将标记设置为false，防止反复触发
                  await destroyOverButton();

                  // 确保全局回调被清理
                  window.currentSetUserDrawCallback = null;

                  // 设置标记，在循环结束和清理完成后停止命令
                  needStopCommandAfterCleanup = true;

                  resolve(null);
                  return;
                }

                // 如果已有点，则设置基准点为最后一个点
                if (points.length > 0) {
                  const basePt = points[points.length - 1];
                  getPoint.setBasePt(new McGePoint3d(basePt.x, basePt.y, 0));
                }

                // 更新预览线 - 当有点存在时，动态显示从上一点到当前鼠标位置的预览线
                if (points.length > 0) {
                  // 检查预览ID是否有效，如果无效则创建新的预览线
                  let plineObj;

                  if (!previewId || !previewId.getMcDbEntity()) {
                    // 创建临时多段线用于预览
                    const tempPolyLine = new McDbPolyline();

                    // 初始化多段线属性
                    tempPolyLine.trueColor = new McCmColor(
                      wallColor.r,
                      wallColor.g,
                      wallColor.b
                    );

                    // 绘制预览多段线
                    previewId = rlAppObj.mxcadObject.drawEntity(tempPolyLine);

                    // 将新创建的预览ID添加到预览列表中
                    if (!cleanup.previewPlineIds.includes(previewId)) {
                      cleanup.previewPlineIds.push(previewId);
                    }
                  }

                  plineObj = previewId.getMcDbEntity(); // 获取预览多段线对象

                  // 创建当前点对象
                  let clickPoint = new McGePoint3d(
                    currentPoint.x,
                    currentPoint.y,
                    0
                  );

                  // 获取上一个点的位置
                  const prevPoint = new McGePoint3d(
                    points[points.length - 1].x,
                    points[points.length - 1].y,
                    0
                  );

                  // 应用捕捉优化，纠正点的位置
                  const snapPoint = enableSnapCorrection(clickPoint, prevPoint);
                  clickPoint = snapPoint || clickPoint;

                  // 计算当前线段长度
                  const distance = clickPoint.distanceTo(prevPoint);

                  // 获取正交模式状态
                  const isOrthogonal = store.state.platBtns.isOrthogonal;

                  // 根据线段长度调整预览线的颜色
                  if (plineObj) {
                    // 如果长度小于300，使用红色显示预览线，表示不符合要求
                    if (distance < 300) {
                      plineObj.trueColor = new McCmColor(255, 0, 0);
                    } else {
                      // 使用正常颜色
                      plineObj.trueColor = new McCmColor(
                        wallColor.r,
                        wallColor.g,
                        wallColor.b
                      );
                    }
                  }

                  // 约束角度到特定值(90°, 45°, 30°或它们的倍数)的函数
                  const constrainAngle = (p1, p2) => {
                    if (isPointEqual(p1, p2)) {
                      return 0;
                    }

                    const angle = Math.atan2(p2.y - p1.y, p2.x - p1.x);

                    if (
                      typeof constrainAngle.lastActivityTime === "undefined"
                    ) {
                      constrainAngle.lastActivityTime = Date.now();
                      constrainAngle.lastConstrainedDegrees = null;
                      constrainAngle.lastRawDegrees = null;
                      constrainAngle.stabilityCounter = 0;
                      constrainAngle.lockAngle = false;
                    }

                    const currentTime = Date.now();
                    const idleTime =
                      currentTime - constrainAngle.lastActivityTime;
                    constrainAngle.lastActivityTime = currentTime;

                    // 减少重置时间到100ms
                    if (idleTime > 100) {
                      constrainAngle.lastConstrainedDegrees = null;
                      constrainAngle.lastRawDegrees = null;
                      constrainAngle.stabilityCounter = 0;
                      constrainAngle.lockAngle = false;
                    }

                    const angleDegrees = ((angle * 180) / Math.PI + 360) % 360;
                    const threshold = 3; // 降低角度阈值，提高灵敏度

                    if (constrainAngle.lastRawDegrees !== null) {
                      const angleChange = Math.abs(
                        angleDegrees - constrainAngle.lastRawDegrees
                      );
                      if (angleChange < 0.5) {
                        constrainAngle.stabilityCounter++;
                      } else {
                        constrainAngle.stabilityCounter = Math.max(
                          0,
                          constrainAngle.stabilityCounter - 1
                        );
                      }
                    }
                    constrainAngle.lastRawDegrees = angleDegrees;

                    // 降低锁定阈值到3
                    if (constrainAngle.stabilityCounter >= 3) {
                      constrainAngle.lockAngle = true;
                    }

                    if (
                      constrainAngle.lockAngle &&
                      constrainAngle.lastConstrainedDegrees !== null
                    ) {
                      const lockDiff = Math.abs(
                        angleDegrees - constrainAngle.lastConstrainedDegrees
                      );
                      if (
                        lockDiff > threshold * 2 &&
                        lockDiff < 360 - threshold * 2
                      ) {
                        constrainAngle.lockAngle = false;
                        constrainAngle.stabilityCounter = 0;
                      } else {
                        return (
                          (constrainAngle.lastConstrainedDegrees * Math.PI) /
                          180
                        );
                      }
                    }

                    // 优化特定角度检测
                    const targetAngles = [];

                    // 90度角检测（优先级最高）
                    for (let i = 0; i < 4; i++) {
                      targetAngles.push({
                        angle: i * 90,
                        threshold: threshold * 0.8, // 降低90度角的阈值，使其更容易捕捉
                        priority: 3,
                      });
                    }

                    // 45度角检测
                    for (let i = 0; i < 8; i++) {
                      const angle = i * 45;
                      if (angle % 90 !== 0) {
                        targetAngles.push({
                          angle: angle,
                          threshold: threshold,
                          priority: 2,
                        });
                      }
                    }

                    // 30度角检测
                    for (let i = 0; i < 12; i++) {
                      const angle = i * 30;
                      if (angle % 45 !== 0) {
                        targetAngles.push({
                          angle: angle,
                          threshold: threshold * 1.2, // 增加30度角的阈值，使其更容易捕捉
                          priority: 1,
                        });
                      }
                    }

                    let closestTarget = null;
                    let minDiff = Infinity;

                    for (const target of targetAngles) {
                      const diff = Math.min(
                        Math.abs(angleDegrees - target.angle),
                        Math.abs(angleDegrees - target.angle - 360)
                      );

                      if (
                        diff <= target.threshold &&
                        (closestTarget === null ||
                          diff < minDiff ||
                          (diff === minDiff &&
                            target.priority > closestTarget.priority))
                      ) {
                        minDiff = diff;
                        closestTarget = target;
                      }
                    }

                    if (closestTarget !== null) {
                      constrainAngle.lastConstrainedDegrees =
                        closestTarget.angle;
                      constrainAngle.stabilityCounter++; // 增加稳定性计数
                      return (closestTarget.angle * Math.PI) / 180;
                    }

                    constrainAngle.lastConstrainedDegrees = null;
                    constrainAngle.stabilityCounter = Math.max(
                      0,
                      constrainAngle.stabilityCounter - 1
                    );
                    constrainAngle.lockAngle = false;
                    return angle;
                  };

                  // 定义一个函数，用于完全重置constrainAngle的状态
                  const resetConstrainAngle = () => {
                    if (constrainAngle.reset) {
                      constrainAngle.reset();
                    } else {
                      // 兼容性处理
                      constrainAngle.lastConstrainedDegrees = null;
                      constrainAngle.lastRawDegrees = null;
                      constrainAngle.stabilityCounter = 0;
                      constrainAngle.lockAngle = false;
                      constrainAngle.lastActivityTime = Date.now();
                    }

                    // 清除预览线和辅助线，避免重复绘制
                    if (auxiliaryLineObj) {
                      auxiliaryLineObj.visible = false;
                    }
                  };

                  // 当启用正交模式时，纠正点的位置使其水平或垂直对齐
                  if (isOrthogonal) {
                    // 获取当前鼠标位置
                    const coordinates =
                      rlAppObj._rlMx.MxFun.getCurrentMousePostion();

                    // 获取当前鼠标位置的CAD坐标
                    const wdCoord = rlAppObj._rlMx.MxFun.screenCoord2Doc(
                      coordinates.x,
                      coordinates.y,
                      coordinates.z
                    );
                    const cadCoord = rlAppObj._rlMx.MxFun.docCoord2Cad(wdCoord);

                    // 比较clickPoint和CAD坐标，使用更宽松的条件和优化的检测逻辑
                    if (
                      Math.abs(clickPoint.x - cadCoord.x) < 1 &&
                      Math.abs(clickPoint.y - cadCoord.y) > difflength
                    ) {
                      // 使用提取出的函数处理点选择
                      const result = await handlePointSelection(
                        0,
                        currentPoint
                      );
                      // 显式解析Promise并立即返回，不继续执行getPoint.go
                      resolve(result);
                    } else if (
                      Math.abs(clickPoint.y - cadCoord.y) < 1 &&
                      Math.abs(clickPoint.x - cadCoord.x) > difflength
                    ) {
                      // 使用提取出的函数处理点选择
                      const result = await handlePointSelection(
                        0,
                        currentPoint
                      );
                      // 显式解析Promise并立即返回，不继续执行getPoint.go
                      resolve(result);
                    }

                    // 计算方向向量
                    const direction = new THREE.Vector3()
                      .subVectors(prevPoint, clickPoint)
                      .normalize();

                    // 根据方向更偏向于哪个轴来调整点的位置
                    if (isMoreAlongX(direction)) {
                      // 如果更偏向X轴，则Y坐标保持不变
                      clickPoint.y = prevPoint.y;
                      currentPoint.y = prevPoint.y;
                    } else {
                      // 如果更偏向Y轴，则X坐标保持不变
                      clickPoint.x = prevPoint.x;
                      currentPoint.x = prevPoint.x;
                    }
                  } else {
                    // 非正交模式下，通过角度变化来触发点选择
                    const coordinates =
                      rlAppObj._rlMx.MxFun.getCurrentMousePostion();

                    const wdCoord = rlAppObj._rlMx.MxFun.screenCoord2Doc(
                      coordinates.x,
                      coordinates.y,
                      coordinates.z
                    );
                    const cadCoord = rlAppObj._rlMx.MxFun.docCoord2Cad(wdCoord);

                    // 创建当前CAD坐标点
                    const cadPoint = new McGePoint3d(cadCoord.x, cadCoord.y, 0);

                    if (points.length > 0) {
                      // 初始化检测标志
                      if (
                        typeof userDrawCallback.isProcessing === "undefined"
                      ) {
                        userDrawCallback.isProcessing = false;
                        userDrawCallback.initialDirection = null;
                        userDrawCallback.lastAngle = null;
                        userDrawCallback.stableAngleCounter = 0; // 添加角度稳定计数器
                        userDrawCallback.angleStabilityThreshold = 20; // 增加角度稳定阈值，使其更稳定
                        userDrawCallback.lastAngles = []; // 添加角度历史记录数组
                      }

                      // 获取约束角度（90、45、30度或其倍数）
                      const constrainedAngle = constrainAngle(
                        prevPoint,
                        cadPoint
                      );

                      // 将角度标准化为0-360度
                      const degreeAngle =
                        ((constrainedAngle * 180) / Math.PI + 360) % 360;
                      const roundedAngle = Math.round(degreeAngle);

                      // 跟踪最近的角度，维护一个历史记录数组
                      if (userDrawCallback.lastAngles.length >= 5) {
                        userDrawCallback.lastAngles.shift(); // 移除最旧的角度
                      }
                      userDrawCallback.lastAngles.push(roundedAngle);

                      // 检查是否所有最近的角度都非常接近
                      function areAnglesStable(angles, tolerance = 2) {
                        if (angles.length < 3) return false;
                        const baseAngle = angles[angles.length - 1];
                        for (let i = 0; i < angles.length - 1; i++) {
                          const diff = Math.abs(angles[i] - baseAngle);
                          if (diff > tolerance && diff < 360 - tolerance) {
                            return false;
                          }
                        }
                        return true;
                      }

                      // 计算当前点到上一个点的距离
                      const distance = prevPoint.distanceTo(cadPoint);

                      // 计算约束后的点坐标
                      const newX =
                        prevPoint.x + distance * Math.cos(constrainedAngle);
                      const newY =
                        prevPoint.y + distance * Math.sin(constrainedAngle);

                      // 更新当前点坐标
                      clickPoint.x = newX;
                      clickPoint.y = newY;
                      currentPoint.x = newX;
                      currentPoint.y = newY;

                      // 确定是否需要触发点选择
                      let shouldTriggerSelection = false;

                      // 只有满足一定条件才触发点选择
                      if (
                        !userDrawCallback.isProcessing &&
                        distance >= difflength2
                      ) {
                        // 保存第一次方向用于比较
                        if (!userDrawCallback.initialDirection) {
                          userDrawCallback.initialDirection = roundedAngle;
                          userDrawCallback.lastAngle = roundedAngle;
                          userDrawCallback.stableAngleCounter = 0;
                          userDrawCallback.lastAngles = [roundedAngle];
                        }
                        // 角度与初始方向明显不同且稳定时触发
                        else if (
                          Math.abs(
                            roundedAngle - userDrawCallback.initialDirection
                          ) > 5 &&
                          roundedAngle !== userDrawCallback.lastAngle
                        ) {
                          // 检查角度是否稳定
                          if (areAnglesStable(userDrawCallback.lastAngles)) {
                            userDrawCallback.stableAngleCounter += 2; // 更快速地增加稳定计数
                          } else {
                            // 如果连续多次检测到相同角度，则增加稳定计数
                            if (
                              userDrawCallback.stableAngleCounter > 0 &&
                              Math.abs(
                                roundedAngle - userDrawCallback.lastStableAngle
                              ) < 1
                            ) {
                              userDrawCallback.stableAngleCounter++;
                            } else {
                              // 角度变化，重置计数，但不完全重置，保留一定的稳定性
                              userDrawCallback.stableAngleCounter = Math.max(
                                1,
                                userDrawCallback.stableAngleCounter - 1
                              );
                              userDrawCallback.lastStableAngle = roundedAngle;
                            }
                          }

                          // 检查角度是否为30度或45度的倍数，如果是，给予更高的优先级
                          const checkSpecialAngle = (angle) => {
                            // 检查是否为30度的倍数
                            for (let i = 0; i < 12; i++) {
                              if (
                                Math.abs(angle - i * 30) < 2 ||
                                Math.abs(angle - i * 30 - 360) < 2
                              ) {
                                return true;
                              }
                            }
                            // 检查是否为45度的倍数
                            for (let i = 0; i < 8; i++) {
                              if (
                                Math.abs(angle - i * 45) < 2 ||
                                Math.abs(angle - i * 45 - 360) < 2
                              ) {
                                return true;
                              }
                            }
                            return false;
                          };

                          // 如果是特殊角度，加速稳定计数的增加
                          if (checkSpecialAngle(roundedAngle)) {
                            userDrawCallback.stableAngleCounter += 3;
                          }

                          // 只有当角度稳定超过阈值时才触发选择
                          if (
                            userDrawCallback.stableAngleCounter >=
                            userDrawCallback.angleStabilityThreshold
                          ) {
                            shouldTriggerSelection = true;
                            userDrawCallback.lastAngle = roundedAngle;
                            userDrawCallback.stableAngleCounter = 0;
                          }
                        } else {
                          // 角度没有明显变化，保持当前状态
                          userDrawCallback.stableAngleCounter = 0;
                        }
                      }

                      // 如果需要触发点选择
                      if (shouldTriggerSelection) {
                        // 设置处理标志，防止重入
                        userDrawCallback.isProcessing = true;

                        // 检查线段长度
                        const distance = cadPoint.distanceTo(prevPoint);

                        // 只有当线段长度大于300时才触发点选择，否则只显示警告而不中断绘制
                        if (distance >= 300) {
                          // 清除预览线，确保没有重复绘制
                          if (auxiliaryLineObj) {
                            auxiliaryLineObj.visible = false;
                          }

                          // 触发点选择
                          const result = await handlePointSelection(
                            0,
                            currentPoint
                          );

                          // 完成后重置标志
                          userDrawCallback.isProcessing = false;
                          userDrawCallback.initialDirection = null;
                          userDrawCallback.lastAngle = null;
                          userDrawCallback.lastAngles = [];
                          userDrawCallback.stableAngleCounter = 0;
                          userDrawCallback.lastStableAngle = null;

                          // 重置constrainAngle函数的静态属性
                          resetConstrainAngle();

                          // 解析Promise并返回
                          resolve(result);
                          return;
                        } else {
                          // 重置处理标志，允许继续绘制
                          userDrawCallback.isProcessing = false;
                        }
                      }
                    }
                  }

                  // 寻找平行线辅助，提高绘图精度
                  // 在所有现有隔墙线中找到与当前线段平行且距离较近的线段作为辅助
                  let dMin = 999999; // 初始化最小距离为一个很大的值

                  // 计算当前线段的方向向量
                  const vec = new THREE.Vector3()
                    .subVectors(clickPoint, prevPoint)
                    .normalize();

                  // 用于存储找到的辅助点
                  let pt1 = null;
                  let pt2 = null;

                  // 设置移动距离，用于辅助线绘制
                  const moveDistance = 800;

                  // 内联定义isParallel函数，用于判断两条线段是否平行
                  const isParallel = (A, B, C, D) => {
                    // 计算线段AB的方向向量
                    const AB = new THREE.Vector3().subVectors(B, A);
                    // 计算线段CD的方向向量
                    const CD = new THREE.Vector3().subVectors(D, C);

                    // 计算斜率，如果分母接近0，则使用一个极大值表示垂直线
                    const slope1 =
                      Math.abs(AB.x) < Math.exp(-1) ? 9999 : AB.y / AB.x;
                    const slope2 =
                      Math.abs(CD.x) < Math.exp(-1) ? 9999 : CD.y / CD.x;

                    // 两线段斜率相等，则平行（使用一个小的容差值）
                    if (Math.abs(slope1 - slope2) < Math.exp(-2)) {
                      return true;
                    } else {
                      return false;
                    }
                  };

                  // 遍历所有现有隔墙线段
                  for (let i = 0; i < partitionWallLines.length; i++) {
                    // 判断现有线段是否与当前绘制线段平行
                    if (
                      isParallel(
                        prevPoint,
                        clickPoint,
                        partitionWallLines[i].stPt,
                        partitionWallLines[i].edPt
                      )
                    ) {
                      // 计算当前线段到辅助线的距离
                      const line = new McDbLine();
                      line.startPoint = MovePt(
                        partitionWallLines[i].stPt,
                        vec,
                        moveDistance
                      );
                      line.endPoint = MovePt(
                        partitionWallLines[i].edPt,
                        vec,
                        moveDistance
                      );

                      // 获取当前点到线的最近点
                      const closestPoint =
                        line.getClosestPointTo(clickPoint).val;

                      // 计算从最近点到当前点的方向向量
                      const vecMove = new THREE.Vector3()
                        .subVectors(clickPoint, closestPoint)
                        .normalize();

                      // 获取辅助线端点中距离最近点较近的那个点
                      const NearPt =
                        closestPoint.distanceTo(partitionWallLines[i].stPt) <
                        closestPoint.distanceTo(partitionWallLines[i].edPt)
                          ? partitionWallLines[i].stPt
                          : partitionWallLines[i].edPt;

                      // 计算最近端点到最近点的方向向量
                      const vecTemp1 = new THREE.Vector3()
                        .subVectors(NearPt, closestPoint)
                        .normalize();

                      // 判断向量是否垂直，用于确定辅助线方向是否合适
                      if (isPerpendicular(vecTemp1, vecMove)) {
                        // 判断方向向量是否与当前线段方向一致
                        if (isPointEqual(vecTemp1, vec)) {
                          // 计算距离
                          const d = closestPoint.distanceTo(NearPt);

                          // 如果距离小于之前找到的最小距离，则更新辅助点
                          if (d < dMin) {
                            dMin = d;
                            pt1 = NearPt;
                            pt2 = MovePt(
                              pt1,
                              vecMove,
                              closestPoint.distanceTo(clickPoint)
                            );
                          }
                        }
                      }
                    }
                  }

                  // 如果找到适合的辅助点，则显示辅助线和捕捉图标
                  if (pt1 && pt2) {
                    ptCapture = pt2; // 设置捕捉点
                    auxiliaryLineObj.startPoint = pt1; // 设置辅助线起点
                    auxiliaryLineObj.endPoint = pt2; // 设置辅助线终点
                    drawSnapIcon(new THREE.Vector3(pt2.x, pt2.y, 0), 1); // 绘制捕捉图标

                    auxiliaryLineObj.visible = true; // 显示辅助线
                  } else {
                    auxiliaryLineObj.visible = false; // 隐藏辅助线
                  }

                  // 计算矩形点集，用于绘制隔墙多段线
                  const RectPoints = getRectPoints(
                    prevPoint,
                    clickPoint,
                    wallThick
                  );

                  // 更新预览多段线的各个点
                  try {
                    // 确保多段线对象存在
                    if (plineObj) {
                      // 检查多段线是否有足够的顶点，如果没有则添加
                      if (plineObj.numVerts < RectPoints.length) {
                        for (let i = 0; i < RectPoints.length; i++) {
                          if (i < plineObj.numVerts) {
                            plineObj.setPointAt(i, RectPoints[i]);
                          } else {
                            plineObj.addVertexAt(RectPoints[i]);
                          }
                        }
                      } else {
                        // 更新现有顶点
                        for (let i = 0; i < RectPoints.length; i++) {
                          plineObj.setPointAt(i, RectPoints[i]);
                        }

                        // 如果多段线的顶点数超过了需要的顶点数，移除多余的顶点
                        if (plineObj.numVerts > RectPoints.length) {
                          for (
                            let i = plineObj.numVerts - 1;
                            i >= RectPoints.length;
                            i--
                          ) {
                            plineObj.removeVertexAt(i);
                          }
                        }
                      }

                      // 确保多段线是闭合的
                      plineObj.isClosed = true;
                    }
                  } catch (error) {
                    console.error("更新预览线出错:", error);

                    // 如果发生错误，尝试重新创建预览线
                    if (previewId) {
                      try {
                        previewId.erase();
                      } catch (e) {
                        console.warn("清除预览线失败:", e);
                      }
                    }

                    // 创建新的临时多段线
                    const tempPolyLine = new McDbPolyline();

                    // 设置多段线颜色
                    tempPolyLine.trueColor = new McCmColor(
                      wallColor.r,
                      wallColor.g,
                      wallColor.b
                    );

                    // 将矩形点添加到多段线中
                    RectPoints.forEach((item) => {
                      tempPolyLine.addVertexAt(item);
                    });

                    // 设置多段线为闭合
                    tempPolyLine.isClosed = true;

                    // 绘制新的预览多段线
                    previewId = rlAppObj.mxcadObject.drawEntity(tempPolyLine);

                    // 将新的预览ID添加到预览列表中
                    if (!cleanup.previewPlineIds.includes(previewId)) {
                      cleanup.previewPlineIds.push(previewId);
                    }
                  }
                }
              };

              // 设置输入触摸类型，根据点的数量决定
              getPoint.setInputToucheType(points.length === 0 ? 1 : 2);
              // 保存回调函数到全局变量
              window.currentSetUserDrawCallback = userDrawCallback;

              // 为点位获取函数设置用户绘制回调
              getPoint.setUserDraw(userDrawCallback);
              // 启动点位获取过程，并处理结果
              getPoint.go(async (status) => {
                // 处理不同的状态值
                const result = await handlePointSelection(
                  status,
                  getPoint.value()
                );
                if (status === 0) {
                  resolve(result);
                }
              });
            });

            // 处理右键结束绘制的情况
            if (!clickPoint) {
              // 如果点集合少于两个点，则提示并返回
              if (points.length < 2) {
                oneMessage.warning("至少需要两个点");
                // 不能在这里直接return，因为会跳过后续清理代码
                // 这里需要跳出循环而不是直接返回
                break;
              }
              // 清除最后输入的点
              getPoint.clearLastInputPoint();
              // 设置绘制状态为结束
              store.commit("drawModules/setDrawPlay", false);
              // 同样，这里应该跳出循环而不是直接返回
              break;
            }
            // 将新创建的预览多段线添加到清理列表中（移到前面处理）
            // 避免重复添加同一个previewId
            if (previewId && !cleanup.previewPlineIds.includes(previewId)) {
              cleanup.previewPlineIds.push(previewId);
            }
          }

          // 清除所有预览线
          cleanup.previewPlineIds.forEach((id) => {
            if (id && id.getMcDbEntity()) {
              try {
                id.erase();
              } catch (e) {
                console.warn("清除预览线失败:", e);
              }
            }
          });

          // 清除辅助线
          auxiliaryLineId.erase();

          // 判断是否继续布置
          if (bGoOnDraw) {
            // 将操作步骤下的所有数据更新到数据库中
            await saveDatabaseStore();

            // 更新显示，刷新图形
            await rlAppObj.rlMxDrawObject.updateDisplay();

            // 连续布置，继续调用隔墙布置函数
            await create_partitionWall_ents(rl_stdFlr_id, row, drawType);
          }

          // 成功完成，解决Promise
          resolve();

          // 如果是通过点击结束按钮退出的，在完成所有清理后停止命令
          if (needStopCommandAfterCleanup) {
            rlAppObj._rlMx.MxFun.stopRunCommand();
          }
        } catch (error) {
          // 捕获并处理错误
          console.error("Error during free partition wall placement:", error);
          oneMessage.error("布置隔墙失败");
        } finally {
          // 确保在任何情况下都进行资源清理
          cleanupResources();

          // 移除事件监听器
          removeEventListeners();

          // 尝试隐藏全屏加载提示
          tryHideFullScreenLoading();
        }
      };

      // 调用 set_partitionWall 函数开始自由绘制隔墙
      set_partitionWall();
    } catch (error) {
      console.error("绘制隔墙时发生错误:", error);
      reject(error);
    } finally {
      // 确保移除所有事件监听器
      removeEventListeners();

      // 清理可能未被正确清理的全局变量
      window.currentSetUserDrawCallback = null;
      window.currentResolve = null;
    }
  });
};

// 自由绘制隔墙
export const create_partitionWall_ents_byFreeDraw = async (
  rl_stdFlr_id,
  row,
  drawType
) => {
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    // 自由布置
    const set_partitionWall = async () => {
      // 存储需要清理的资源
      const cleanup = {
        previewPlineIds: [],
        overButton: null,
      };

      // 清理函数
      const cleanupResources = () => {
        // 清除所有预览线
        if (cleanup.previewPlineIds.length > 0) {
          cleanup.previewPlineIds.forEach((id) => {
            if (id && id.getMcDbEntity()) {
              id.erase();
            }
          });
          cleanup.previewPlineIds = [];
        }

        // 销毁结束按钮
        if (cleanup.overButton) {
          destroyOverButton();
          cleanup.overButton = null;
          // 清除全局变量中的按钮引用
          window.currentOverButton = null;
        }
        // 隐藏输入框
        if (getInputElement() && getInputElement().style.display == "block") {
          eraseOtherData();
          getInputElement().style.display = "none";
        }
        // 停止当前命令
        if (rlAppObj._rlMx.MxFun) {
          rlAppObj._rlMx.MxFun.stopRunCommand();
        }
      };

      try {
        var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
        const wallColor = getNonStructuralColor(Number(row.Mat));
        const points = []; // 存储所有点
        // 存储到全局变量，供输入框使用
        window.currentPartitionWallPoints = points;
        // 存放预览图的多段线id
        const previewPlineIds = [];
        // 创建预览多段线
        let previewId;
        const wallThick = Number(row.B);
        // 获取点位的函数
        const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
        let isFirstPoint = true;

        // 确保之前的按钮被完全清理
        await cleanupResources();

        // 创建新按钮
        const overButton = createOverButton();
        overButton.style.display = "none";
        cleanup.overButton = overButton;
        // 保存到全局变量
        window.currentOverButton = overButton;

        // 添加外部中断处理
        const handleInterrupt = () => {
          cleanupResources();
        };

        // 注册中断处理器
        window.addEventListener("commandInterrupt", handleInterrupt);
        let bGoOnDraw = false; // 是否继续绘制
        const allPartitionWalls =
          store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
        // 记录隔墙线
        const partitionWallLines = [];
        for (let i = 0; i < allPartitionWalls.length; i++) {
          partitionWallLines.push({
            stPt: allPartitionWalls[i].startPoint,
            edPt: allPartitionWalls[i].endPoint,
          });
        }
        const mxcad = MxCpp.getCurrentMxCAD();
        // 设置虚线
        mxcad.addLinetype("MyLineType", "6,-10");
        const auxiliaryLineId = mxcad.drawLine(0, 0, 0, -100);
        const auxiliaryLineObj = auxiliaryLineId.getMcDbEntity();
        auxiliaryLineObj.linetype = "MyLineType";
        auxiliaryLineObj.visible = false;

        while (true) {
          oneMessage.info(isFirstPoint ? "请点击第一个点" : "请点击下一个点");
          // 获取点击点
          const clickPoint = await new Promise((resolve) => {
            store.commit("cadModules/setSnapPoint", {
              snapPoint: null,
              needCatchSnap: true,
            });
            // 保存 resolve 函数，以便在结束按钮点击时使用
            window.currentResolve = resolve;

            let ptCapture = null; // 捕捉点
            // 设置回调函数
            const userDrawCallback = async (currentPoint) => {
              // 当第一次点击的时候，关闭正交模式，因为如果不关闭正交，第一个点可能会被挪到一个正交的位置上
              if (!isFirstPoint) {
                // 打开正交模式
                fixOrthogonal(true);
              } else {
                // 关闭正交模式
                fixOrthogonal(false);
              }
              if (getClickOverButtonType()) {
                getPoint.clearLastInputPoint();
                store.commit("drawModules/setDrawPlay", false);
                // 销毁按钮
                eraseOtherData();
                destroyOverButton();
                await resolve(null);
                rlAppObj._rlMx.MxFun.stopRunCommand();
                // return; // 如果是结束按钮点击，直接返回
              }
              if (points.length > 0) {
                const basePt = points[points.length - 1];
                getPoint.setBasePt(new McGePoint3d(basePt.x, basePt.y, 0));
              }
              // 更新预览线
              if (points.length > 0) {
                const plineObj = previewId.getMcDbEntity();
                let clickPoint = new McGePoint3d(
                  currentPoint.x,
                  currentPoint.y,
                  0
                );
                const prevPoint = new McGePoint3d(
                  points[points.length - 1].x,
                  points[points.length - 1].y,
                  0
                );
                // 设置捕捉优化
                const snapPoint = enableSnapCorrection(clickPoint, prevPoint);
                clickPoint = snapPoint || clickPoint;

                const isOrthogonal = store.state.platBtns.isOrthogonal;
                // 当开启正交的时候,纠正偏移,正交有bug,没办法,只能来硬的了
                if (isOrthogonal) {
                  // 在需要判断方向的地方使用:
                  const direction = new THREE.Vector3()
                    .subVectors(prevPoint, clickPoint)
                    .normalize();
                  if (isMoreAlongX(direction)) {
                    // 更偏向于X轴的处理
                    clickPoint.y = prevPoint.y;
                    currentPoint.y = prevPoint.y;
                  } else {
                    // 更偏向于Y轴的处理
                    clickPoint.x = prevPoint.x;
                    currentPoint.x = prevPoint.x;
                  }
                }

                // 找平行线,且平行线的一点与当前鼠标位置距离小于100
                // 找辅助线
                let dMin = 999999;
                const vec = new THREE.Vector3()
                  .subVectors(clickPoint, prevPoint)
                  .normalize();
                let pt1 = null;
                let pt2 = null;
                const moveDistance = 800;
                for (let i = 0; i < partitionWallLines.length; i++) {
                  // 判断是否与当前线平行
                  if (
                    isParallel(
                      prevPoint,
                      clickPoint,
                      partitionWallLines[i].stPt,
                      partitionWallLines[i].edPt
                    )
                  ) {
                    const vecLine1 = new THREE.Vector3()
                      .subVectors(
                        partitionWallLines[i].stPt,
                        partitionWallLines[i].edPt
                      )
                      .normalize();
                    const vecLine2 = new THREE.Vector3(
                      -vecLine1.x,
                      -vecLine1.y,
                      0
                    );
                    // 计算当前线到辅助线的距离
                    const line = new McDbLine();
                    line.startPoint = MovePt(
                      partitionWallLines[i].stPt,
                      vecLine1,
                      moveDistance
                    );
                    line.endPoint = MovePt(
                      partitionWallLines[i].edPt,
                      vecLine2,
                      moveDistance
                    );
                    // 获取最近点
                    const closestPoint = line.getClosestPointTo(clickPoint).val;
                    // 获取最近点与当前线的方向向量
                    const vecMove = new THREE.Vector3()
                      .subVectors(clickPoint, closestPoint)
                      .normalize();
                    // 获取最近点
                    const NearPt =
                      closestPoint.distanceTo(partitionWallLines[i].stPt) <
                      closestPoint.distanceTo(partitionWallLines[i].edPt)
                        ? partitionWallLines[i].stPt
                        : partitionWallLines[i].edPt;
                    // 获取最近点与当前线的方向向量
                    const vecTemp1 = new THREE.Vector3()
                      .subVectors(NearPt, closestPoint)
                      .normalize();
                    // 判断是否垂直
                    if (isPerpendicular(vecTemp1, vecMove)) {
                      // 判断是否相等
                      if (isPointEqual(vecTemp1, vec)) {
                        const d = closestPoint.distanceTo(NearPt);
                        if (d < dMin) {
                          dMin = d;
                          pt1 = NearPt;
                          pt2 = MovePt(
                            pt1,
                            vecMove,
                            closestPoint.distanceTo(clickPoint)
                          );
                        }
                      }
                    }
                  }
                }
                if (pt1 && pt2) {
                  ptCapture = pt2;
                  auxiliaryLineObj.startPoint = pt1;
                  auxiliaryLineObj.endPoint = pt2;
                  drawSnapIcon(new THREE.Vector3(pt2.x, pt2.y, 0), 1); // 绘制捕捉框

                  auxiliaryLineObj.visible = true;
                } else {
                  auxiliaryLineObj.visible = false;
                }
                const RectPoints = getRectPoints(
                  prevPoint,
                  clickPoint,
                  wallThick
                );
                for (let i = 0; i < RectPoints.length; i++) {
                  plineObj.setPointAt(i, RectPoints[i]);
                }
              }
            };

            // 保存回调函数到全局变量
            window.currentSetUserDrawCallback = userDrawCallback;

            // 设置用户绘制回调
            getPoint.setUserDraw(userDrawCallback);

            getPoint.setInputToucheType(points.length === 0 ? 1 : 2);
            getPoint.go(async (status) => {
              if (status === 0) {
                if (overButton.style.display == "none") {
                  overButton.style.display = "block";
                }
                setOverButtonPosition(getPoint.value().x, getPoint.value().y);
                // 绘制俯视图
                let clickPoint = new McGePoint3d(
                  getPoint.value().x,
                  getPoint.value().y,
                  0
                );
                // 设置捕捉优化
                clickPoint = getPoint.value();
                const snapPoint = enableSnapCorrection(
                  clickPoint,
                  null,
                  false,
                  100
                );
                clickPoint = snapPoint || clickPoint;
                let prevPoint = new McGePoint3d(clickPoint.x, clickPoint.y, 0);
                // 如果当前不是第一个点，则取上一个点
                let bSetInputEnt = false;
                if (!isFirstPoint) {
                  prevPoint = new McGePoint3d(
                    points[points.length - 1].x,
                    points[points.length - 1].y,
                    0
                  );
                  bSetInputEnt = true;
                } else isFirstPoint = false;
                // 判断捕捉点是否为空
                if (ptCapture && clickPoint.distanceTo(ptCapture) <= 100) {
                  clickPoint = ptCapture;
                  ptCapture = null;
                }
                points.push(clickPoint);
                const tempPolyLine = new McDbPolyline();
                // 获取矩形点集
                const RectPoints = getRectPoints(
                  prevPoint,
                  clickPoint,
                  wallThick
                );
                // 绘制俯视图
                RectPoints.forEach((item) => {
                  tempPolyLine.addVertexAt(item);
                });
                tempPolyLine.isClosed = true;
                tempPolyLine.trueColor = new McCmColor(
                  wallColor.r,
                  wallColor.g,
                  wallColor.b
                );
                previewId = rlAppObj.mxcadObject.drawEntity(tempPolyLine);
                if (bSetInputEnt && previewPlineIds.length >= 1) {
                  bGoOnDraw = true;
                  // 隔墙布置
                  const tempPoints = [];
                  tempPoints.push(prevPoint);
                  tempPoints.push(clickPoint);
                  // 处理与已有的隔墙相交
                  const groupPoints = await handlePartitionWallIntersection(
                    tempPoints
                  );
                  // 绘制隔墙
                  let lastPartitionWallObj = null;
                  let lastStartPoint = null;
                  let lastEndPoint = null;
                  for (let i = 0; i < groupPoints.length; i++) {
                    const otherData = {
                      startPoint: {
                        x: groupPoints[i].startPoint.x,
                        y: groupPoints[i].startPoint.y,
                        z: 0,
                      },
                      endPoint: {
                        x: groupPoints[i].endPoint.x,
                        y: groupPoints[i].endPoint.y,
                        z: 0,
                      },
                    };
                    // 如果起点与终点相等,则不绘制
                    if (
                      isPointEqual(
                        otherData.startPoint,
                        otherData.endPoint,
                        0.1
                      )
                    ) {
                      continue;
                    }
                    // 保存新的隔墙,用于找辅助线
                    partitionWallLines.push({
                      stPt: groupPoints[i].startPoint,
                      edPt: groupPoints[i].endPoint,
                    });
                    // 转字符串
                    const otherDataStr = JSON.stringify(otherData);
                    const rlPartitionWallObject = new rlPartitionWallData();
                    rlPartitionWallObject.initData({
                      m_sectParamData: {
                        Mat: Number(row.Mat), // 材质
                        Kind: Number(row.section_param), // 截面类型
                        B: Number(row.B), // 墙厚
                        Guid: row.Guid,
                      },
                      OtherData: otherDataStr,
                      Ecc: 0,
                      Mat: Number(row.Mat),
                      partitionWallHeight: Number(row.H),
                      LevelB: currFlrLevelB,
                      Color: wallColor,
                      Attribute: 0,
                      m_gridData: null,
                      LinkGuids: [],
                    });

                    rlPartitionWallObject.draw();
                    await addEntityToDrawing(rlPartitionWallObject, false);
                    if (i == groupPoints.length - 1) {
                      lastPartitionWallObj = rlPartitionWallObject;
                      lastStartPoint = groupPoints[i].startPoint;
                      lastEndPoint = groupPoints[i].endPoint;
                    }
                    // addObjs.push(rlPartitionWallObject.getDataBase());
                  }
                  if (lastStartPoint && lastEndPoint) {
                    eraseOtherData();
                    // 设置其他数据
                    setOtherData({
                      type: "partitionWall",
                      clickPoint: lastEndPoint,
                      prevPoint: lastStartPoint,
                      wallThick: wallThick,
                      partitionWallObj: lastPartitionWallObj,
                      vecMove: new THREE.Vector3()
                        .subVectors(lastEndPoint, lastStartPoint)
                        .normalize(),
                    });
                    // 添加输入框
                    let inputElement = getInputElement();
                    if (!inputElement) {
                      inputElement = createInputElement();
                    } else {
                      // inputElement.style.display = "block";
                      setContainerShow(true);
                    }

                    const midX = (lastEndPoint.x + lastStartPoint.x) / 2;
                    const midY = (lastEndPoint.y + lastStartPoint.y) / 2;
                    setInputElementPosition(
                      lastEndPoint.distanceTo(lastStartPoint).toFixed(0),
                      midX,
                      midY
                    );
                    const plineObj =
                      previewPlineIds[
                        previewPlineIds.length - 1
                      ].getMcDbEntity();
                    setCurrDataObj(plineObj);
                  }
                }
                previewPlineIds.push(previewId);
                resolve(getPoint.value());
              } else if (status == -1) {
                // 右键点击
                eraseOtherData();
                destroyOverButton();
                resolve(null);
              } else if (status == -2) {
                eraseOtherData();
                destroyOverButton();
                resolve(null);
                bGoOnDraw = false;
              }
            });
          });
          // 右键结束绘制
          if (!clickPoint) {
            if (points.length < 2) {
              oneMessage.warning("至少需要两个点");
              break;
            }
            getPoint.clearLastInputPoint();
            store.commit("drawModules/setDrawPlay", false);
            break;
          }

          // 当创建新的预览线时，将其添加到清理列表
          if (previewId) {
            cleanup.previewPlineIds.push(previewId);
          }
        }
        // 清除预览线
        previewPlineIds.forEach((id) => {
          id.erase();
        });
        auxiliaryLineId.erase();
        // 判断是否继续布置
        if (bGoOnDraw) {
          // 在绘制完成后清除全局变量
          window.currentPartitionWallPoints = null;
          // 将操作步骤下的所有数据更新到数据库中
          await saveDatabaseStore();
          // 更新显示
          await rlAppObj.rlMxDrawObject.updateDisplay();
          // 连续布置,隔墙不需要等待输入框输入距离,所以在这直接连续布置即可
          await create_partitionWall_ents(rl_stdFlr_id, row, drawType);
        }
        resolve();
      } catch (error) {
        cleanupResources();
        console.error("Error during free partition wall placement:", error);
        oneMessage.error("布置隔墙失败");
      } finally {
        // 确保在任何情况下都进行清理
        cleanupResources();
        // 移除中断处理器
        // window.removeEventListener("commandInterrupt", handleInterrupt);
        tryHideFullScreenLoading();
      }
    };

    // 调用 userSelect 并传递 set_partitionWall 回调
    set_partitionWall();
  });
};

// 根据网格布置隔墙
export const create_partitionWall_ents_byGrid = async (
  rl_stdFlr_id,
  row,
  drawType
) => {
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    // one; // Message.info("请框选需要的对象");
    var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
    const wallColor = getNonStructuralColor(Number(row.Mat));
    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
    // 绘制回调方法
    const set_partitionWall = async (ids) => {
      if (!ids || !ids.length) return;

      try {
        // 绘制步数
        store.commit("globalData/addRawStep");

        // 执行loading
        if (ids.length > 30) {
          showFullScreenLoading("正在布置墙..");
          // 确保 showFullScreenLoading 执行完毕
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        const addObjs = [];
        let eraseIds = [];
        let eraseObjs = [];
        for (const item of ids) {
          const mcObj = item.getMcDbEntity();
          if (mcObj) {
            const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
            const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型
            // 选隔墙，修改属性
            if (objClassName == "rlPartitionWallSeg") {
              const rlPartitionWallAssociation = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });

              if (rlPartitionWallAssociation) {
                await rlPartitionWallAssociation.saveEditRevokeData();

                rlPartitionWallAssociation.m_sectParamData.Mat = Number(
                  row.Mat
                );
                rlPartitionWallAssociation.m_sectParamData.B = Number(row.B);
                rlPartitionWallAssociation.m_sectParamData.Guid = row.Guid;
                rlPartitionWallAssociation.partitionWallHeight = Number(row.H);
                rlPartitionWallAssociation.Height = currFlrHeight;
                rlPartitionWallAssociation.LevelB = currFlrLevelB;
                rlPartitionWallAssociation.Mat = Number(row.Mat);
                rlPartitionWallAssociation.Ecc = 0;
                rlPartitionWallAssociation.Color = wallColor;
                // 处理更新后重新布置不展示问题
                rlPartitionWallAssociation.isWasmGeted = false;
                await rlPartitionWallAssociation.updateThisObj(
                  rlPartitionWallAssociation
                );
              }
            } else if (objClassName == "rlGrid" || objClassName == "rlGridC") {
              // 选网格，新建隔墙
              let rlGridData = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              //当前网格有隔墙
              if (rlGridData.m_partitionWallId != null) continue;
              //校验网格是否重叠
              let checkResult = await checkGridOverlap(rlGridData, eraseObjs);
              //完全重叠,删除网格
              if (checkResult.isOverlap) {
                eraseIds.push(rlGridData.Guid);
                eraseObjs.push(rlGridData);
                continue;
              }
              //部分重叠,打断网格
              if (checkResult.isLineInsert) {
                item.erase();
                if (checkResult.newGrid.length > 0) {
                  ids.push(...checkResult.newGrid);
                }
                //重新打开网格
                rlGridData = getEntityData({
                  Guid: rlGridData.Guid,
                  classTypeName: objClassName,
                });
                if (!rlGridData) {
                  continue;
                }
              }
              if (!rlGridData) {
                console.warn("当前选择对象为空");
                continue;
              }
              if (rlGridData.m_wallId) {
                continue;
              }
              const allPartitionWalls =
                store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
              // 当前网格上有隔墙,只是这个隔墙不与网格关联,避免用自由绘制的时候沿着网格绘制隔墙
              let hasPartitionWall = false;
              for (const item of allPartitionWalls) {
                if (item.m_gridData != null) continue;
                if (
                  (item.startPoint.distanceTo(
                    new McGePoint3d(
                      rlGridData.m_stJoint.m_pt[0],
                      rlGridData.m_stJoint.m_pt[1],
                      0
                    )
                  ) < 1 &&
                    item.endPoint.distanceTo(
                      new McGePoint3d(
                        rlGridData.m_edJoint.m_pt[0],
                        rlGridData.m_edJoint.m_pt[1],
                        0
                      )
                    ) < 1) ||
                  (item.startPoint.distanceTo(
                    new McGePoint3d(
                      rlGridData.m_edJoint.m_pt[0],
                      rlGridData.m_edJoint.m_pt[1],
                      0
                    )
                  ) < 1 &&
                    item.endPoint.distanceTo(
                      new McGePoint3d(
                        rlGridData.m_stJoint.m_pt[0],
                        rlGridData.m_stJoint.m_pt[1],
                        0
                      )
                    ) < 1)
                ) {
                  hasPartitionWall = true;
                  break;
                }
              }
              console.log("hasPartitionWall", hasPartitionWall);
              if (hasPartitionWall) {
                console.log("当前网格上有隔墙,只是这个隔墙不与网格关联");
                continue;
              }
              // 如果是无效网格，不需处理
              if (
                Math.abs(
                  rlGridData.m_stJoint.m_pt[0] - rlGridData.m_edJoint.m_pt[0]
                ) < 1 &&
                Math.abs(
                  rlGridData.m_stJoint.m_pt[1] - rlGridData.m_edJoint.m_pt[1]
                ) < 1
              ) {
                continue;
              }
              // 打断不与网格关联的隔墙
              const tempPoints = [];
              tempPoints.push(
                new McGePoint3d(
                  rlGridData.m_stJoint.m_pt[0],
                  rlGridData.m_stJoint.m_pt[1],
                  0
                )
              );
              tempPoints.push(
                new McGePoint3d(
                  rlGridData.m_edJoint.m_pt[0],
                  rlGridData.m_edJoint.m_pt[1],
                  0
                )
              );
              // 打断不与网格关联的隔墙
              await handlePartitionWallIntersection(tempPoints);
              let { roomNames, roomNameEnts } = get_Ent_RoomName([
                rlGridData.Guid,
              ]);
              const rlPartitionWallObject = new rlPartitionWallData();
              rlPartitionWallObject.initData({
                m_sectParamData: {
                  Mat: Number(row.Mat), // 材质
                  Kind: Number(row.section_param), // 截面类型
                  B: Number(row.B), // 墙厚
                  Guid: row.Guid,
                },
                Ecc: 0,
                Mat: Number(row.Mat),
                partitionWallHeight: Number(row.H),
                LevelB: currFlrLevelB,
                m_gridData: rlGridData,
                Color: wallColor,
                Attribute: 0,
                LinkGuids: [],
                useFunctionNames: roomNames,
              });

              rlPartitionWallObject.draw();
              await addEntityToDrawing(rlPartitionWallObject, false);
              // console.log("rlPartitionWallObject", rlPartitionWallObject);

              addObjs.push(rlPartitionWallObject.getDataBase());
              // 将隔墙和房间关联
              for (let w = 0; w < roomNameEnts.length; w++) {
                roomNameEnts[w].saveEditRevokeData();
                roomNameEnts[w].allEntGuids.partitionWallGuids.push(
                  rlPartitionWallObject.Guid
                );
                roomNameEnts[w].updateThisObj(roomNameEnts[w]);
              }
            }
          }
        }
        if (eraseIds.length > 0) {
          for (const item of eraseIds) {
            const rlGridData = getEntityData({
              Guid: item,
              classTypeName: "rlGrid",
            });
            if (rlGridData) {
              rlGridData.erase();
            }
          }
        }
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
        // 更新显示
        await rlAppObj.rlMxDrawObject.updateDisplay();
        // 隐藏 loading
        tryHideFullScreenLoading();
        // 连续布置,隔墙不需要等待输入框输入距离,所以在这直接连续布置即可
        // await create_partitionWall_ents(rl_stdFlr_id, row, drawType);
        resolve();
      } catch (error) {
        console.error("Error during set_partitionWall operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };

    // 调用 userSelect 并传递 set_partitionWall 回调
    userSelect(set_partitionWall);
  });
};

// 处理隔墙与已有的隔墙相交
export const handlePartitionWallIntersection = async (points, skipEnt) => {
  // 获取隔墙数据
  const rlPartitionWallGroup =
    store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];

  // 创建空间索引树
  const tree = new RBush();
  const wallDataItems = [];

  // 收集所有隔墙数据并构建空间索引
  for (let i = 0; i < rlPartitionWallGroup.length; i++) {
    const rlPartitionWall = rlPartitionWallGroup[i];
    if (
      !rlPartitionWall.index2dData ||
      !rlPartitionWall.startPoint ||
      !rlPartitionWall.endPoint ||
      (skipEnt && skipEnt.includes(rlPartitionWall.Guid))
    ) {
      continue;
    }

    // 创建包围盒并记录隔墙信息
    const minX = Math.min(
      rlPartitionWall.startPoint.x,
      rlPartitionWall.endPoint.x
    );
    const minY = Math.min(
      rlPartitionWall.startPoint.y,
      rlPartitionWall.endPoint.y
    );
    const maxX = Math.max(
      rlPartitionWall.startPoint.x,
      rlPartitionWall.endPoint.x
    );
    const maxY = Math.max(
      rlPartitionWall.startPoint.y,
      rlPartitionWall.endPoint.y
    );

    const wallItem = {
      minX,
      minY,
      maxX,
      maxY,
      wallEnt: rlPartitionWall,
      startPoint: rlPartitionWall.startPoint,
      endPoint: rlPartitionWall.endPoint,
    };

    wallDataItems.push(wallItem);
  }

  // 批量加载到空间索引中
  tree.load(wallDataItems);

  // 预处理输入点集为线段
  const inputSegments = [];
  for (let i = 0; i < points.length - 1; i++) {
    const startPoint = new McGePoint3d(points[i].x, points[i].y, 0);
    const endPoint = new McGePoint3d(points[i + 1].x, points[i + 1].y, 0);
    inputSegments.push({
      startPoint,
      endPoint,
      id: i, // 用于跟踪原始线段
    });
  }

  // 存储处理后的线段结果
  const resultSegments = [...inputSegments];
  // 存储需要添加的新线段
  const newSegments = [];
  // 存储需要移除的线段索引
  const removeIndices = new Set();

  // 存储需要更新的原始墙体和需要新建的墙体
  const wallsToUpdate = [];
  const wallsToCreate = [];

  // 处理每个输入线段与现有墙体的交点
  for (let i = 0; i < inputSegments.length; i++) {
    const segment = inputSegments[i];
    const startPoint = segment.startPoint;
    const endPoint = segment.endPoint;

    // 计算当前线段的包围盒
    const minX = Math.min(startPoint.x, endPoint.x);
    const minY = Math.min(startPoint.y, endPoint.y);
    const maxX = Math.max(startPoint.x, endPoint.x);
    const maxY = Math.max(startPoint.y, endPoint.y);

    // 使用空间索引查找可能相交的墙体
    const possibleIntersects = tree.search({
      minX,
      minY,
      maxX,
      maxY,
    });

    // 存储当前线段的所有交点
    const intersections = [];

    // 检查与每个可能相交的墙体
    for (const wallData of possibleIntersects) {
      const wallStartPoint = wallData.startPoint;
      const wallEndPoint = wallData.endPoint;

      // 如果线段的端点与墙体的端点重合，则跳过
      if (
        isPointEqual(startPoint, wallStartPoint, 0.1) ||
        isPointEqual(startPoint, wallEndPoint, 0.1) ||
        isPointEqual(endPoint, wallStartPoint, 0.1) ||
        isPointEqual(endPoint, wallEndPoint, 0.1)
      ) {
        continue;
      }

      // 计算相交
      const res = lineInsection(
        startPoint,
        endPoint,
        wallStartPoint,
        wallEndPoint,
        false
      );

      if (res.isIntersected) {
        const intersectPt = new McGePoint3d(
          res.intersectionPoint.x,
          res.intersectionPoint.y,
          0
        );

        // 如果交点是墙体的端点，则跳过（无需分割墙体）
        if (
          isPointEqual(wallStartPoint, intersectPt, 0.1) ||
          isPointEqual(wallEndPoint, intersectPt, 0.1)
        ) {
          continue;
        }

        // 如果交点是当前线段的端点，不需要分割线段，但仍需分割墙体
        if (
          !isPointEqual(startPoint, intersectPt, 0.1) &&
          !isPointEqual(endPoint, intersectPt, 0.1)
        ) {
          // 添加交点信息到数组，稍后一次性处理
          intersections.push({
            point: intersectPt,
            wallData,
          });
        } else {
          // 仅需分割墙体
          const wallToSplit = {
            wallData,
            intersectPt,
          };

          // 记录要分割的墙体
          const existingWallIndex = wallsToUpdate.findIndex(
            (item) => item.wallData === wallData
          );

          if (existingWallIndex === -1) {
            wallsToUpdate.push(wallToSplit);
          }
        }
      }
    }

    // 按照与起点的距离排序交点
    if (intersections.length > 0) {
      intersections.sort((a, b) => {
        const distA =
          Math.pow(a.point.x - startPoint.x, 2) +
          Math.pow(a.point.y - startPoint.y, 2);
        const distB =
          Math.pow(b.point.x - startPoint.x, 2) +
          Math.pow(b.point.y - startPoint.y, 2);
        return distA - distB;
      });

      // 标记当前线段为需要移除
      removeIndices.add(i);

      // 创建分段的线段
      let lastPoint = startPoint;
      for (const intersection of intersections) {
        newSegments.push({
          startPoint: lastPoint,
          endPoint: intersection.point,
          id: segment.id,
        });

        lastPoint = intersection.point;

        // 记录需要分割的墙体
        const wallToSplit = {
          wallData: intersection.wallData,
          intersectPt: intersection.point,
        };

        const existingWallIndex = wallsToUpdate.findIndex(
          (item) => item.wallData === intersection.wallData
        );

        if (existingWallIndex === -1) {
          wallsToUpdate.push(wallToSplit);
        }
      }

      // 添加最后一段
      newSegments.push({
        startPoint: lastPoint,
        endPoint,
        id: segment.id,
      });
    }
  }

  // 从结果中移除要替换的线段
  for (const index of Array.from(removeIndices).sort((a, b) => b - a)) {
    resultSegments.splice(index, 1);
  }

  // 添加新的分段线段
  resultSegments.push(...newSegments);

  // 批量处理墙体更新
  for (const { wallData, intersectPt } of wallsToUpdate) {
    const wallEnt = wallData.wallEnt;
    const startPoint = wallData.startPoint;
    const endPoint = wallData.endPoint;

    // 区分左右和上下
    const isLeft = startPoint.x < endPoint.x;
    const isDown = startPoint.y < endPoint.y;

    // 准备分割数据
    const startPoint1 = startPoint;
    const endPoint1 = intersectPt;
    const startPoint2 = intersectPt;
    const endPoint2 = endPoint;

    let originalWallStartPoint, originalWallEndPoint;
    let newWallStartPoint, newWallEndPoint;

    if (isLeft || isDown) {
      originalWallStartPoint = startPoint1;
      originalWallEndPoint = endPoint1;
      newWallStartPoint = startPoint2;
      newWallEndPoint = endPoint2;
    } else {
      originalWallStartPoint = startPoint2;
      originalWallEndPoint = endPoint2;
      newWallStartPoint = startPoint1;
      newWallEndPoint = endPoint1;
    }

    // 记录更新现有墙体的数据
    wallsToCreate.push({
      originalWall: wallEnt,
      originalStart: originalWallStartPoint,
      originalEnd: originalWallEndPoint,
      newStart: newWallStartPoint,
      newEnd: newWallEndPoint,
    });
  }

  // 批量执行墙体的更新和创建
  for (const wallChange of wallsToCreate) {
    const { originalWall, originalStart, originalEnd, newStart, newEnd } =
      wallChange;

    // 更新原墙体
    originalWall.saveEditRevokeData();

    // 处理OtherData
    let otherData = originalWall.OtherData;
    if (typeof otherData === "string") {
      otherData = JSON.parse(otherData);
    }

    otherData.startPoint.x = originalStart.x;
    otherData.startPoint.y = originalStart.y;
    otherData.endPoint.x = originalEnd.x;
    otherData.endPoint.y = originalEnd.y;
    otherData = JSON.stringify(otherData);

    if (originalWall.m_gridData) {
      if (originalWall.m_gridData.m_partitionWallId) {
        originalWall.m_gridData.m_partitionWallId = null;
      }
      originalWall.m_gridData = null;
    }

    originalWall.OtherData = otherData;
    originalWall.isWasmGeted = false;
    originalWall.startPoint = originalStart;
    originalWall.endPoint = originalEnd;

    originalWall.updateThisObj(originalWall);

    // 创建新墙体
    const newWall = originalWall.myClone();
    newWall.startPoint = newStart;
    newWall.endPoint = newEnd;
    newWall.LinkGuids = [];
    newWall.draw();
    await addEntityToDrawing(newWall, false);
  }

  return resultSegments;
};

// 创建悬挑板--新
export const create_cantiSlab_ents = async (rl_stdFlr_id, row) => {
  if (!row || rl_stdFlr_id == -999) return;
  if (row.tableRow.Width == 0) {
    await create_cantiSlab_ents_sameLength(rl_stdFlr_id, row);
  } else {
    await create_cantiSlab_ents_otherLength(rl_stdFlr_id, row);
  }
};

// 创建与网格同长的悬挑板
export const create_cantiSlab_ents_sameLength = async (rl_stdFlr_id, row) => {
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    const set_cantiSlab = async (ids) => {
      try {
        if (!ids || !ids.length) return;
        // 拿到对应标准层
        var rlBuilding = store.state.cadModules.rlBuilding;
        var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
        var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
        const rlLayer = await getRlLayer();
        let cantiSlabColor = rlLayer.filter(
          (item) => item.Type == "rlCantiSlab"
        );
        if (cantiSlabColor && cantiSlabColor.length > 0)
          cantiSlabColor = cantiSlabColor[0].Color;
        // 绘制步数
        store.commit("globalData/setCanAddRawStep", true);
        // 执行loading
        if (ids.length > 10) {
          showFullScreenLoading("正在布置板..");
          // 确保 showFullScreenLoading 执行完毕
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        // 获取所有实体
        const gridData = store.state.rlEntData.totalEntityData["rlGrid"];
        let drawCantiSlabGridGroup = []; // 记录可以绘制悬挑板的网格

        // 预先创建需要重复使用的对象
        const vecZ = new THREE.Vector3(0, 0, 1);
        const selectedGridGuids = new Set(); // 使用Set存储已选网格的Guid，提高查找效率

        // 收集选中的网格Guid
        ids.forEach((item) => {
          const mcObj = item.getMcDbEntity();
          if (mcObj && mcObj.getxDataString("classTypeName").val === "rlGrid") {
            selectedGridGuids.add(mcObj.getxDataString("Guid").val);
          }
        });

        // 批量处理，每次处理一部分数据，避免UI阻塞
        const batchSize = 10;
        const processBatch = async (startIndex) => {
          const endIndex = Math.min(startIndex + batchSize, ids.length);
          for (let i = startIndex; i < endIndex; i++) {
            const item = ids[i];
            const mcObj = item.getMcDbEntity();
            if (!mcObj) continue;

            const objGuid = mcObj.getxDataString("Guid").val;
            const objClassName = mcObj.getxDataString("classTypeName").val;
            if (objClassName !== "rlGrid") continue;

            const selectObj = getEntityData({
              Guid: objGuid,
              classTypeName: objClassName,
            });

            if (!selectObj || selectObj.m_slabIds.length !== 1) continue;

            // 缓存计算结果
            const startPoint = new McGePoint3d(...selectObj.m_stJoint.m_pt);
            const endPoint = new McGePoint3d(...selectObj.m_edJoint.m_pt);
            const midPoint = new McGePoint3d(
              (startPoint.x + endPoint.x) / 2,
              (startPoint.y + endPoint.y) / 2,
              0
            );

            // 直接计算方向向量
            const direction = new THREE.Vector3()
              .subVectors(endPoint, startPoint)
              .normalize();
            const crossDirection = new THREE.Vector3()
              .crossVectors(direction, vecZ)
              .normalize();
            const negateCrossDirection = new THREE.Vector3(
              -crossDirection.x,
              -crossDirection.y,
              -crossDirection.z
            );

            const line1Pt = MovePt(midPoint, crossDirection, 30000);
            const line2Pt = MovePt(midPoint, negateCrossDirection, 30000);

            let isLine1Intersect = false;
            let isLine2Intersect = false;

            // 使用some方法提前结束循环
            gridData.some((item1) => {
              if (objGuid === item1.Guid) return false;
              // if (item1.m_slabIds.length == 0) return false;
              if (item1.m_slabIds.length > 0) {
                let isNear = false;
                for (const slabId of item1.m_slabIds) {
                  let slab1 = getEntityData({
                    Guid: slabId,
                    classTypeName: "rlSlab",
                  });
                  if (slab1) {
                    let gridsGuid = slab1.GridsGuid.split(",");
                    if (gridsGuid.includes(objGuid)) {
                      isNear = true;
                      break;
                    }
                  }
                }
                if (!isNear) return false;
              } else return false;
              const gridStPt = new McGePoint3d(...item1.m_stJoint.m_pt);
              const gridEdPt = new McGePoint3d(...item1.m_edJoint.m_pt);

              // 只在必要时计算相交
              if (!isLine1Intersect) {
                const res1 = lineInsection(
                  midPoint,
                  line1Pt,
                  gridStPt,
                  gridEdPt,
                  false
                );
                if (res1 && res1.isIntersected) isLine1Intersect = true;
              }

              if (!isLine2Intersect) {
                const res2 = lineInsection(
                  midPoint,
                  line2Pt,
                  gridStPt,
                  gridEdPt,
                  false
                );
                if (res2 && res2.isIntersected) isLine2Intersect = true;
              }

              // 如果两个方向都已找到相交点，提前退出循环
              return isLine1Intersect && isLine2Intersect;
            });

            // 根据相交结果添加到悬挑板组
            if (!isLine1Intersect) {
              drawCantiSlabGridGroup.push({
                gridData: selectObj,
                vec: crossDirection,
              });
            } else if (!isLine2Intersect) {
              drawCantiSlabGridGroup.push({
                gridData: selectObj,
                vec: negateCrossDirection,
              });
            }
          }

          // 如果还有数据需要处理，继续下一批
          if (endIndex < ids.length) {
            // 使用requestAnimationFrame或setTimeout避免阻塞UI
            await new Promise((resolve) => setTimeout(resolve, 0));
            return processBatch(endIndex);
          }
        };

        // 开始批量处理
        if (ids.length > 0) {
          await processBatch(0);
        }

        // 绘制悬挑板
        for (const item of drawCantiSlabGridGroup) {
          const { gridData, vec } = item;
          let startPt = new McGePoint3d(...gridData.m_stJoint.m_pt);
          let endPt = new McGePoint3d(...gridData.m_edJoint.m_pt);
          let slabPoints = calculateSlabPoints(
            startPt,
            endPt,
            vec,
            row.tableRow.Length
          );
          if (slabPoints.length <= 0) continue;
          let createCantiSlab = null;
          if (gridData.m_cantiSlabId) {
            createCantiSlab = getEntityData({
              Guid: gridData.m_cantiSlabId,
              classTypeName: "rlCantiSlab",
            });
            if (createCantiSlab) {
              createCantiSlab.saveEditRevokeData();
              createCantiSlab.cantiSlabPoints = slabPoints;
              createCantiSlab.Thickness = row.tableRow.Thick;
              createCantiSlab.m_sectParamData = row.tableRow;
              createCantiSlab.updateThisObj(createCantiSlab);
            }
          } else {
            let vec = new THREE.Vector3()
              .subVectors(slabPoints[1], slabPoints[0])
              .normalize();
            let { oneVec } = calculate_cantiSlab_dr_params(gridData);
            let dr = isPointEqual(vec, oneVec) ? 1 : -1;
            createCantiSlab = new rlCantiSlabData();
            createCantiSlab.initData({
              m_sectParamData: row.tableRow,
              cantiSlabPoints: slabPoints,
              Color: cantiSlabColor,
              m_gridData: gridData,
              Thickness: row.tableRow.Thick,
              LevelB: currFlrLevelB,
              Height: currFlrHeight,
              m_dr: dr,
              m_ec: 0,
              Attribute: 2,
            });
            createCantiSlab.draw();
            await addEntityToDrawing(createCantiSlab, false);
          }
        }
        // 更新显示
        rlAppObj.rlMxDrawObject.updateDisplay();
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
      } catch (error) {
        console.error("Error during set_cantiSlab operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };
    userSelect(set_cantiSlab);
  });
};

//创建于网格不同长的悬挑板
export const create_cantiSlab_ents_otherLength = async (rl_stdFlr_id, row) => {
  // 保存模型对象的原始位置
  const originalPoint = new McGePoint3d(0, 0, 0);
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    const { tableRow } = row;
    // 获取所有实体
    const gridData = store.state.rlEntData.totalEntityData["rlGrid"];
    const rlLayer = await getRlLayer();
    let cantiSlabColor = rlLayer.filter((item) => item.Type == "rlCantiSlab");
    if (cantiSlabColor && cantiSlabColor.length > 0)
      cantiSlabColor = cantiSlabColor[0].Color;
    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
    var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
    // 创建墙关联缓存，避免重复调用 getEntityData
    const cantiSlabAssociationCache = new Map();

    // 构建缓存，但不在 item 上添加属性
    for (const item of gridData) {
      if (item.m_cantiSlabId) {
        const rlCantiSlabAssociation = getEntityData({
          Guid: item.m_cantiSlabId,
          classTypeName: "rlCantiSlab",
        });
        if (rlCantiSlabAssociation) {
          cantiSlabAssociationCache.set(
            item.m_cantiSlabId,
            rlCantiSlabAssociation
          );
        }
      }
    }

    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = new McGePoint3d(0, 0, 0);

    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });
    const mxcad = MxCpp.getCurrentMxCAD();
    //虚线样式
    mxcad.addLinetype("MyLineType", "6,-10");

    mxcad.addDimStyle(
      "MyDimStyle2",
      "41,0.18,141,0.09,140,0,40,200",
      "77,1,271,3,73,1",
      "",
      ""
    );

    // 设置第一个点位置
    const polyline = new McDbPolyline();
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    const polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
    const PolylineObj = polylineMcDb.getMcDbEntity();
    PolylineObj.linetype = "MyLineType";
    PolylineObj.visible = false;
    let CurrentGridGuid = ""; // 记录当前网格guid
    let beforeAtGridPt = new McGePoint3d(); // 记录上一次在网格上的点,用于计算俯视图移动距离

    mxcad.drawDimStyle = "MyDimStyle2";
    const mDimensionId = mxcad.drawDimAligned(
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y
    );
    const mDimensionObj = mDimensionId.getMcDbEntity();
    // 设置颜色
    mDimensionObj.trueColor = new McCmColor(255, 0, 0);

    // 添加输入框
    let inputElement = getInputElement();
    if (!inputElement) {
      inputElement = createInputElement(mDimensionObj);
    } else {
      setCurrDataObj(mDimensionObj);
    }
    setContainerShow(false);
    let rlGridItem; // 鼠标最后停留的网格
    let vec = null;
    // 第一次点击鼠标
    getPoint.setInputToucheType(1);
    getPoint.go(async (status1) => {
      PolylineObj.visible = true;
      getPoint.setUserDraw((currentPoint) => {
        const SortGridArray = [];
        // 获取鼠标位置
        // 设置捕捉优化
        const snapPointTemp = enableSnapCorrection(currentPoint);
        pt1 = new McGePoint3d(
          snapPointTemp.x,
          snapPointTemp.y,
          snapPointTemp.z
        );

        for (const item of gridData) {
          if (item.m_slabIds.length != 1) continue;
          const ptClose = item.mcDbGrid.getClosestPointTo(pt1);
          const dDist = ptClose.val.distanceTo(pt1);
          SortGridArray.push({
            dToGrid: dDist, // 鼠标到线的最近点的距离
            NearPt: ptClose.val, // 鼠标到线的最近点
            gridIt: item, // 轴线数据
          });
        }

        let moveX = 0; // 俯视图移动X
        let moveY = 0; // 俯视图移动Y
        if (Array.isArray(SortGridArray) && SortGridArray.length > 0) {
          // 按距离排序
          SortGridArray.sort((a, b) => a.dToGrid - b.dToGrid);
          const NearGrid = SortGridArray[0];
          rlGridItem = NearGrid.gridIt;
          let startPt = new McGePoint3d(...rlGridItem.m_stJoint.m_pt);
          let endPt = new McGePoint3d(...rlGridItem.m_edJoint.m_pt);
          // 缓存计算结果
          const midPoint = new McGePoint3d(
            (startPt.x + endPt.x) / 2,
            (startPt.y + endPt.y) / 2,
            0
          );

          // 直接计算方向向量
          const direction = new THREE.Vector3()
            .subVectors(endPt, startPt)
            .normalize();
          const vecZ = new THREE.Vector3(0, 0, 1);
          const crossDirection = new THREE.Vector3()
            .crossVectors(direction, vecZ)
            .normalize();
          const negateCrossDirection = new THREE.Vector3(
            -crossDirection.x,
            -crossDirection.y,
            -crossDirection.z
          );

          const line1Pt = MovePt(midPoint, crossDirection, 30000);
          const line2Pt = MovePt(midPoint, negateCrossDirection, 30000);

          let isLine1Intersect = false;
          let isLine2Intersect = false;

          // 使用some方法提前结束循环
          gridData.some((item1) => {
            if (rlGridItem.Guid === item1.Guid) return false;
            if (item1.m_slabIds.length == 0) return false;

            const gridStPt = new McGePoint3d(...item1.m_stJoint.m_pt);
            const gridEdPt = new McGePoint3d(...item1.m_edJoint.m_pt);

            // 只在必要时计算相交
            if (!isLine1Intersect) {
              const res1 = lineInsection(
                midPoint,
                line1Pt,
                gridStPt,
                gridEdPt,
                false
              );
              if (res1 && res1.isIntersected) {
                if (item1.m_slabIds.length > 0) {
                  let isNear = false;
                  for (const slabId of item1.m_slabIds) {
                    let slab1 = getEntityData({
                      Guid: slabId,
                      classTypeName: "rlSlab",
                    });
                    if (slab1) {
                      let gridsGuid = slab1.GridsGuid.split(",");
                      if (gridsGuid.includes(rlGridItem.Guid)) {
                        isNear = true;
                        break;
                      }
                    }
                  }
                  if (!isNear) return false;
                } else return false;
                isLine1Intersect = true;
              }
            }

            if (!isLine2Intersect) {
              const res2 = lineInsection(
                midPoint,
                line2Pt,
                gridStPt,
                gridEdPt,
                false
              );
              if (res2 && res2.isIntersected) {
                if (item1.m_slabIds.length > 0) {
                  let isNear = false;
                  for (const slabId of item1.m_slabIds) {
                    let slab1 = getEntityData({
                      Guid: slabId,
                      classTypeName: "rlSlab",
                    });
                    if (slab1) {
                      let gridsGuid = slab1.GridsGuid.split(",");
                      if (gridsGuid.includes(rlGridItem.Guid)) {
                        isNear = true;
                        break;
                      }
                    }
                  }
                  if (!isNear) return false;
                } else return false;
                isLine2Intersect = true;
              }
            }

            // 如果两个方向都已找到相交点，提前退出循环
            return isLine1Intersect && isLine2Intersect;
          });
          // 根据相交结果添加到悬挑板组
          if (!isLine1Intersect) {
            vec = crossDirection;
          } else if (!isLine2Intersect) {
            vec = negateCrossDirection;
          } else {
            vec = null;
          }
          if (vec) {
            //显示输入框
            setContainerShow(true);
            mDimensionObj.visible = true; // 显示标注
            PolylineObj.visible = true; // 显示预览多段线
            const negateDirection = new THREE.Vector3(
              -direction.x,
              -direction.y,
              -direction.z
            ); // 方向取反
            let atGridPt = NearGrid.NearPt; // 鼠标最近的网格点
            if (
              CurrentGridGuid === "" ||
              (CurrentGridGuid !== "" &&
                CurrentGridGuid !== NearGrid.gridIt.Guid)
            ) {
              CurrentGridGuid = NearGrid.gridIt.Guid;
              beforeAtGridPt = atGridPt;
              // 改变预览多段线的形状

              let NewPt = MovePt(atGridPt, direction, tableRow.Width / 2);
              PolylineObj.setPointAt(0, NewPt);
              NewPt = MovePt(NewPt, vec, tableRow.Length);
              PolylineObj.setPointAt(1, NewPt);
              NewPt = MovePt(NewPt, negateDirection, tableRow.Width);
              PolylineObj.setPointAt(2, NewPt);
              NewPt = MovePt(atGridPt, negateDirection, tableRow.Width / 2);
              PolylineObj.setPointAt(3, NewPt);
              NewPt = MovePt(atGridPt, direction, tableRow.Width / 2);
              PolylineObj.setPointAt(4, NewPt);
            } else {
              // 已存在俯视轮廓，计算移动距离
              moveX = atGridPt.x - beforeAtGridPt.x;
              moveY = atGridPt.y - beforeAtGridPt.y;
              beforeAtGridPt = atGridPt;
            }
            // inputElement.style.display = "block"; // 显示输入框
            setContainerShow(true);
            mDimensionObj.visible = true; // 显示标注
            // 计算标注点位
            let gridStPt = startPt;

            let ptTmp = MovePt(atGridPt, negateDirection, tableRow.Width / 2);
            let gridLength = startPt.distanceTo(endPt);
            let dist = ptTmp.distanceTo(gridStPt);
            if (dist > gridLength / 2) {
              gridStPt = endPt;
              ptTmp = MovePt(atGridPt, direction, tableRow.Width / 2);
            }
            mDimensionObj.xLine1Point = gridStPt;
            mDimensionObj.xLine2Point = ptTmp;
            gridStPt = MovePt(
              gridStPt,
              negateCrossDirection,
              tableRow.Length / 2 + 100
            );
            ptTmp = MovePt(
              ptTmp,
              negateCrossDirection,
              tableRow.Length / 2 + 100
            );

            const midX = (gridStPt.x + ptTmp.x) / 2;
            const midY = (gridStPt.y + ptTmp.y) / 2;
            mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

            setInputElementPosition(
              ptTmp.distanceTo(gridStPt).toFixed(0),
              midX,
              midY
            );
          } else {
            // 没有方向向量，隐藏输入框
            mDimensionObj.visible = false; // 隐藏标注
            setContainerShow(false);
            PolylineObj.visible = false; // 隐藏预览多段线
          }
        } else {
          vec = null;
          rlGridItem = null;
          setContainerShow(false);
          mDimensionObj.visible = false; // 隐藏标注
          PolylineObj.visible = false; // 隐藏预览多段线
          CurrentGridGuid = "";
          PolylineObj.setPointAt(0, new McGePoint3d(pt1.x, pt1.y, pt1.z));
          PolylineObj.setPointAt(1, new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
          PolylineObj.setPointAt(
            2,
            new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z)
          );
          PolylineObj.setPointAt(3, new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
          PolylineObj.setPointAt(4, new McGePoint3d(pt1.x, pt1.y, pt1.z));
        }
        // 移动俯视图
        PolylineObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + moveX, pt1.y + moveY, pt1.z)
        );
      });

      //第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        if (status2 == 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

          if (rlGridItem && vec) {
            const points = [];
            for (let u = 0; u < PolylineObj.numVerts(); u++) {
              points.push(PolylineObj.getPointAt(u).val);
            }
            //删除最后一个点
            points.pop();
            let createCantiSlab = null;
            if (rlGridItem.m_cantiSlabId) {
              createCantiSlab = getEntityData({
                Guid: rlGridItem.m_cantiSlabId,
                classTypeName: "rlCantiSlab",
              });
              if (createCantiSlab) {
                let ec = 0;
                let { leftPt, rightPt } = calculate_cantiSlab_dr_params(
                  createCantiSlab.m_gridData
                );
                let dist = getInptNum();
                let pt0 = points[0];
                let pt3 = points[3];
                let dist1 = pt0.distanceTo(leftPt);
                let dist2 = pt0.distanceTo(rightPt);
                let dist3 = pt3.distanceTo(leftPt);
                let dist4 = pt3.distanceTo(rightPt);
                //中间
                if (
                  (Math.abs(dist1 - dist) < 1 || Math.abs(dist3 - dist) < 1) &&
                  (Math.abs(dist2 - dist) < 1 || Math.abs(dist4 - dist) < 1)
                ) {
                  ec = 0;
                } else if (
                  Math.abs(dist1 - dist) < 1 ||
                  Math.abs(dist3 - dist) < 1
                ) {
                  ec = dist == 0 ? 1 : dist;
                } else if (
                  Math.abs(dist2 - dist) < 1 ||
                  Math.abs(dist4 - dist) < 1
                ) {
                  ec = dist == 0 ? -1 : -dist;
                }
                createCantiSlab.saveEditRevokeData();
                createCantiSlab.cantiSlabPoints = points;
                createCantiSlab.Thickness = tableRow.Thick;
                createCantiSlab.m_sectParamData = tableRow;
                createCantiSlab.m_ec = ec;
                createCantiSlab.updateThisObj(createCantiSlab);
              }
            } else {
              let vec = new THREE.Vector3()
                .subVectors(points[1], points[0])
                .normalize();
              let { oneVec, leftPt, rightPt } =
                calculate_cantiSlab_dr_params(rlGridItem);
              let dr = isPointEqual(vec, oneVec) ? 1 : -1;
              let pt0 = points[0];
              let pt3 = points[3];
              let dist = getInptNum();
              let ec = 0;
              let dist1 = pt0.distanceTo(leftPt);
              let dist2 = pt0.distanceTo(rightPt);
              let dist3 = pt3.distanceTo(leftPt);
              let dist4 = pt3.distanceTo(rightPt);
              //中间
              if (
                (Math.abs(dist1 - dist) < 1 || Math.abs(dist3 - dist) < 1) &&
                (Math.abs(dist2 - dist) < 1 || Math.abs(dist4 - dist) < 1)
              ) {
                ec = 0;
              } else if (
                Math.abs(dist1 - dist) < 1 ||
                Math.abs(dist3 - dist) < 1
              ) {
                ec = dist == 0 ? 1 : dist;
              } else if (
                Math.abs(dist2 - dist) < 1 ||
                Math.abs(dist4 - dist) < 1
              ) {
                ec = dist == 0 ? -1 : -dist;
              }
              console.log("ec", ec);

              createCantiSlab = new rlCantiSlabData();
              createCantiSlab.initData({
                m_sectParamData: tableRow,
                cantiSlabPoints: points,
                Color: cantiSlabColor,
                m_gridData: rlGridItem,
                Thickness: tableRow.Thick,
                LevelB: currFlrLevelB,
                Height: currFlrHeight,
                m_dr: dr,
                m_ec: ec,
                Attribute: 2,
              });
              createCantiSlab.draw();
              await addEntityToDrawing(createCantiSlab, false);
            }
            if (createCantiSlab) {
              oneMessage.info("请确认布置距离");
              setCurrDataObj(createCantiSlab);
              setOtherData({
                tableRow: tableRow,
                points: points,
                isCreatingNew: true, // 悬挑板是否是新创建的
              });
              // 更新显示
              rlAppObj.rlMxDrawObject.updateDisplay();
              // 将操作步骤下的所有数据更新到数据库中
              await saveDatabaseStore();
            }
            // 保存moduleForm到otherData中，用于后续重复布置
          } else {
            // 调用中断事件
            window.dispatchEvent(new Event("commandendDrawModules"));
          }
          //更新
          // 清理操作
          polylineMcDb.erase();
          mDimensionObj.erase();
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
          resolve();
        } else {
          // 清理操作
          setContainerShow(false);
          polylineMcDb.erase();
          mDimensionObj.erase();
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
          resolve();
        }
      });
    });
  });
};

//计算悬挑板的点集
export const calculateSlabPoints = (startPoint, endPoint, vec, length) => {
  const points = [];
  if (!startPoint || !endPoint || !length) return [];
  points.push(startPoint);
  points.push(MovePt(startPoint, vec, length));
  points.push(MovePt(endPoint, vec, length));
  points.push(endPoint);
  return points;
};

// 创建悬挑板--弃用
export const create_cantiSlab_ents_old = async (rl_stdFlr_id, row) => {
  if (!row || rl_stdFlr_id == -999) return;
  if (row.tableRow.Width == 0) {
    await create_cantiSlab_ents_sameLength_old(rl_stdFlr_id, row);
  } else {
    await create_cantiSlab_ents_otherLength_old(rl_stdFlr_id, row);
  }
};

//创建与网格不同长的悬挑板
export const create_cantiSlab_ents_otherLength_old = async (
  rl_stdFlr_id,
  row
) => {
  // 保存模型对象的原始位置
  const originalPoint = new McGePoint3d(0, 0, 0);
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    const { tableRow } = row;
    // 获取所有实体
    const gridData = store.state.rlEntData.totalEntityData["rlGrid"];

    // 创建墙关联缓存，避免重复调用 getEntityData
    const cantiSlabAssociationCache = new Map();

    // 构建缓存，但不在 item 上添加属性
    for (const item of gridData) {
      if (item.m_cantiSlabId) {
        const rlCantiSlabAssociation = getEntityData({
          Guid: item.m_cantiSlabId,
          classTypeName: "rlCantiSlab",
        });
        if (rlCantiSlabAssociation) {
          cantiSlabAssociationCache.set(
            item.m_cantiSlabId,
            rlCantiSlabAssociation
          );
        }
      }
    }

    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = new McGePoint3d(0, 0, 0);

    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });
    const mxcad = MxCpp.getCurrentMxCAD();
    //虚线样式
    mxcad.addLinetype("MyLineType", "6,-10");

    mxcad.addDimStyle(
      "MyDimStyle2",
      "41,0.18,141,0.09,140,0,40,200",
      "77,1,271,3,73,1",
      "",
      ""
    );

    // 设置第一个点位置
    const polyline = new McDbPolyline();
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    const polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
    const PolylineObj = polylineMcDb.getMcDbEntity();
    PolylineObj.linetype = "MyLineType";
    PolylineObj.visible = false;
    let CurrentGridGuid = ""; // 记录当前网格guid
    let beforeAtGridPt = new McGePoint3d(); // 记录上一次在网格上的点,用于计算俯视图移动距离

    mxcad.drawDimStyle = "MyDimStyle2";
    const mDimensionId = mxcad.drawDimAligned(
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y
    );
    const mDimensionObj = mDimensionId.getMcDbEntity();
    // 设置颜色
    mDimensionObj.trueColor = new McCmColor(255, 0, 0);

    // 添加输入框
    let inputElement = getInputElement();
    if (!inputElement) {
      inputElement = createInputElement(mDimensionObj);
    } else {
      setCurrDataObj(mDimensionObj);
    }
    setContainerShow(false);
    let rlGridItem; // 鼠标最后停留的网格

    // 第一次点击鼠标
    getPoint.setInputToucheType(1);
    getPoint.go(async (status1) => {
      PolylineObj.visible = true;
      getPoint.setUserDraw((currentPoint) => {
        const SortGridArray = [];
        // 获取鼠标位置
        pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

        // 判断鼠标是否在墙内
        for (const item of gridData) {
          if (!item.m_cantiSlabId) {
            const ptClose = item.mcDbGrid.getClosestPointTo(pt1);
            const dDist = ptClose.val.distanceTo(pt1);
            SortGridArray.push({
              dToGrid: dDist, // 鼠标到线的最近点的距离
              NearPt: ptClose.val, // 鼠标到线的最近点
              gridIt: item, // 轴线数据
            });
          }
        }

        let moveX = 0; // 俯视图移动X
        let moveY = 0; // 俯视图移动Y
        if (Array.isArray(SortGridArray) && SortGridArray.length > 0) {
          // 按距离排序
          SortGridArray.sort((a, b) => a.dToGrid - b.dToGrid);
          const NearGrid = SortGridArray[0];
          rlGridItem = NearGrid.gridIt;

          let startPt = new McGePoint3d(...NearGrid.gridIt.m_stJoint.m_pt);
          let endPt = new McGePoint3d(...NearGrid.gridIt.m_edJoint.m_pt);
          // 如果起点到终点的方向向左或者向下，则交换起点和终点
          if (startPt.x > endPt.x || startPt.y > endPt.y) {
            const tmp = startPt;
            startPt = endPt;
            endPt = tmp;
          }
          const direction = new THREE.Vector3()
            .subVectors(endPt, startPt)
            .normalize();

          // if (direction.x < 0 || direction.y < 0) {
          //   // 起末点互换
          //   [startPt, endPt] = [endPt, startPt];
          //   direction = new THREE.Vector3()
          //     .subVectors(endPt, startPt)
          //     .normalize();
          // }

          const negateDirection = new THREE.Vector3(
            -direction.x,
            -direction.y,
            -direction.z
          ); // 方向取反
          const crossDirection = new THREE.Vector3();
          const vecZ = new THREE.Vector3(0, 0, 1);
          crossDirection.crossVectors(direction, vecZ).normalize();
          const negateCrossDirection = new THREE.Vector3(
            -crossDirection.x,
            -crossDirection.y,
            -crossDirection.z
          ); // 方向取反
          const atGridPt = NearGrid.NearPt; // 鼠标最近的网格点
          if (
            CurrentGridGuid === "" ||
            (CurrentGridGuid !== "" && CurrentGridGuid !== NearGrid.gridIt.Guid)
          ) {
            CurrentGridGuid = NearGrid.gridIt.Guid;
            beforeAtGridPt = atGridPt;
            // 改变预览多段线的形状

            let NewPt = MovePt(atGridPt, direction, tableRow.Width / 2);
            PolylineObj.setPointAt(0, NewPt);

            NewPt = MovePt(NewPt, crossDirection, tableRow.Length);
            PolylineObj.setPointAt(1, NewPt);

            NewPt = MovePt(NewPt, negateDirection, tableRow.Width);
            PolylineObj.setPointAt(2, NewPt);
            NewPt = MovePt(atGridPt, negateDirection, tableRow.Width / 2);
            PolylineObj.setPointAt(3, NewPt);
            NewPt = MovePt(atGridPt, direction, tableRow.Width / 2);
            PolylineObj.setPointAt(4, NewPt);
          } else {
            // 已存在俯视轮廓，计算移动距离
            moveX = atGridPt.x - beforeAtGridPt.x;
            moveY = atGridPt.y - beforeAtGridPt.y;
            beforeAtGridPt = atGridPt;
          }
          // inputElement.style.display = "block"; // 显示输入框
          setContainerShow(true);
          mDimensionObj.visible = true; // 显示标注
          // 计算标注点位
          let gridStPt = startPt;

          let ptTmp = MovePt(atGridPt, negateDirection, tableRow.Width / 2);
          let gridLength = startPt.distanceTo(endPt);
          let dist = ptTmp.distanceTo(gridStPt);
          if (dist > gridLength / 2) {
            gridStPt = endPt;
            ptTmp = MovePt(atGridPt, direction, tableRow.Width / 2);
          }
          mDimensionObj.xLine1Point = gridStPt;
          mDimensionObj.xLine2Point = ptTmp;
          gridStPt = MovePt(
            gridStPt,
            negateCrossDirection,
            tableRow.Length / 2 + 100
          );
          ptTmp = MovePt(
            ptTmp,
            negateCrossDirection,
            tableRow.Length / 2 + 100
          );

          const midX = (gridStPt.x + ptTmp.x) / 2;
          const midY = (gridStPt.y + ptTmp.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

          setInputElementPosition(
            ptTmp.distanceTo(gridStPt).toFixed(0),
            midX,
            midY
          );
        } else {
          rlGridItem = null;
          // inputElement.style.display = "none"; // 隐藏输入框
          setContainerShow(false);
          mDimensionObj.visible = false; // 隐藏标注
          CurrentGridGuid = "";
          PolylineObj.setPointAt(0, new McGePoint3d(pt1.x, pt1.y, pt1.z));
          PolylineObj.setPointAt(1, new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
          PolylineObj.setPointAt(
            2,
            new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z)
          );
          PolylineObj.setPointAt(3, new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
          PolylineObj.setPointAt(4, new McGePoint3d(pt1.x, pt1.y, pt1.z));
        }
        // 移动俯视图
        PolylineObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + moveX, pt1.y + moveY, pt1.z)
        );
      });

      //第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        if (status2 == 0) {
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
          if (rlGridItem) {
            oneMessage.info("请确认布置距离");
            setCurrDataObj(PolylineObj);
            // 保存moduleForm到otherData中，用于后续重复布置
            setOtherData({
              tableRow,
              isCreatingNew: true,
              type: "cantiSlab",
              gridData: rlGridItem,
              polylineObj: PolylineObj,
            });
          } else {
            // 调用中断事件
            window.dispatchEvent(new Event("commandendDrawModules"));
          }
          // 清理操作
          polylineMcDb.erase();
          mDimensionObj.erase();
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
          resolve();
        } else {
          // 清理操作
          inputElement.style.display = "none"; // 隐藏输入框
          polylineMcDb.erase();
          mDimensionObj.erase();
          window.canvas
            .getContext("2d")
            .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
          resolve();
        }
      });
    });
  });
};

//创建于网格同长的悬挑板
export const create_cantiSlab_ents_sameLength_old = async (
  rl_stdFlr_id,
  row
) => {
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    let selectVecStartPoint = null;
    let selectVecEndPoint = null;
    setCantiSlabSectData(row.tableRow);
    const set_cantiSlab = async (ids) => {
      try {
        if (!ids || !ids.length) return;

        // 绘制步数
        store.commit("globalData/setCanAddRawStep", true);
        // 执行loading
        if (ids.length > 10) {
          showFullScreenLoading("正在布置板..");
          // 确保 showFullScreenLoading 执行完毕
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        let vecMaxLengthGridGroup = [];
        let gridDataRecord = []; // 记录网格的guid
        ids.forEach((item) => {
          const mcObj = item.getMcDbEntity();
          if (mcObj) {
            const objGuid = mcObj.getxDataString("Guid").val;
            const objClassName = mcObj.getxDataString("classTypeName").val;
            if (objClassName == "rlGrid") {
              const selectObj = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              if (selectObj) {
                let startPoint = new McGePoint3d(...selectObj.m_stJoint.m_pt);
                let endPoint = new McGePoint3d(...selectObj.m_edJoint.m_pt);
                let isFind = false;
                if (selectVecStartPoint && selectVecEndPoint) {
                  if (
                    isParallel(
                      selectVecStartPoint,
                      selectVecEndPoint,
                      startPoint,
                      endPoint
                    )
                  ) {
                    gridDataRecord.push(selectObj);
                  }
                } else {
                  for (let i = 0; i < vecMaxLengthGridGroup.length; i++) {
                    if (
                      isParallel(
                        vecMaxLengthGridGroup[i].startPoint,
                        vecMaxLengthGridGroup[i].endPoint,
                        startPoint,
                        endPoint
                      )
                    ) {
                      vecMaxLengthGridGroup[i].grids.push(selectObj);
                      vecMaxLengthGridGroup[i].length++;
                      isFind = true;
                      break;
                    }
                  }
                  if (!isFind) {
                    vecMaxLengthGridGroup.push({
                      startPoint,
                      endPoint,
                      grids: [selectObj],
                      length: 1,
                    });
                  }
                }
              }
            }

            // if (selectObj?.m_cantiSlabId) {
            //   gridDataRecord.push(selectObj);
            // }
          }
        });
        if (vecMaxLengthGridGroup.length > 0) {
          vecMaxLengthGridGroup.sort((a, b) => b.length - a.length);
          gridDataRecord = vecMaxLengthGridGroup[0].grids; // 记录网格的guid
          selectVecStartPoint = vecMaxLengthGridGroup[0].startPoint;
          selectVecEndPoint = vecMaxLengthGridGroup[0].endPoint;
        }
        // 如果存在网格，则创建悬挑板
        console.log("gridDataRecord", gridDataRecord);
        if (gridDataRecord.length > 0) {
          let beforeGridDataRecord = getGridDataRecord();
          for (let k = 0; k < gridDataRecord.length; k++) {
            let index = beforeGridDataRecord.findIndex(
              (item) => item.Guid === gridDataRecord[k].Guid
            );
            if (index !== -1) {
              //删除高亮
              clearEntityHighlight(beforeGridDataRecord[index].highlightObj);
              beforeGridDataRecord.splice(index, 1);
            } else {
              //创建线段,做高亮
              const finObj = gridDataRecord[k].mcDbId.getMcDbEntity();
              console.log("finObj", finObj);

              createHighlightEffect(finObj);
              beforeGridDataRecord.push({
                highlightObj: finObj,
                gridData: gridDataRecord[k],
                Guid: gridDataRecord[k].Guid,
                isSame: true,
              });
            }
          }
          if (!getDirectionButtonIsCreate()) {
            createDirectionButton();
          }
          console.log("beforeGridDataRecord", beforeGridDataRecord);
          if (beforeGridDataRecord.length == 0) {
            selectVecStartPoint = null;
            selectVecEndPoint = null;
          }
          setGridDataRecord(beforeGridDataRecord);
        }
      } catch (error) {
        console.error("Error during set_cantiSlab operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };
    userSelect(set_cantiSlab);
  });
};

//计算悬挑板的dr参数
export const calculate_cantiSlab_dr_params = (gridData) => {
  let startPoint = new McGePoint3d(...gridData.m_stJoint.m_pt);
  let endPoint = new McGePoint3d(...gridData.m_edJoint.m_pt);
  let vecYpt1 = new McGePoint3d(0, 1000, 0);
  let vecYpt2 = new McGePoint3d(0, -1000, 0);
  let ptOne = null;
  let ptTwo = null;
  if (isParallel(startPoint, endPoint, vecYpt1, vecYpt2)) {
    ptOne = startPoint.y < endPoint.y ? startPoint : endPoint;
    ptTwo = startPoint.y < endPoint.y ? endPoint : startPoint;
  } else {
    ptOne = startPoint.x < endPoint.x ? startPoint : endPoint;
    ptTwo = startPoint.x < endPoint.x ? endPoint : startPoint;
  }
  let vec = new THREE.Vector3().subVectors(ptOne, ptTwo).normalize();
  const vecZ = new THREE.Vector3(0, 0, 1);
  const crossDirection = new THREE.Vector3()
    .crossVectors(vec, vecZ)
    .normalize();
  const negateCrossDirection = new THREE.Vector3(
    -crossDirection.x,
    -crossDirection.y,
    -crossDirection.z
  );
  return {
    oneVec: crossDirection,
    twoVec: negateCrossDirection,
    leftPt: ptOne,
    rightPt: ptTwo,
  };
};
// 创建楼板
export const create_slab_ents = async (
  rl_stdFlr_id,
  rlModules,
  row,
  offset
) => {
  return new Promise(async (resolve, reject) => {
    if (!row || rl_stdFlr_id == -999) return;
    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
    var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;

    const rlSlabGroup = store.state.rlEntData.totalEntityData["rlSlab"];
    // Message.info("请框选需要的对象");
    // 显示 loading
    // let el = document.querySelector(".MD_PG");
    const set_slab = async (ids) => {
      const rlLineGridGroup = [];

      if (!ids || !ids.length) return;

      try {
        const rlLayer = await getRlLayer();
        let slabColor1 = rlLayer.filter((item) => item.Type == "rlSlabSeg");
        if (slabColor1) slabColor1 = slabColor1[0].Color;
        // let slabColor2 = rlLayer.filter((item) => item.Type == "rlSlabSeg");
        // if (slabColor2) slabColor2 = slabColor2[0].Color;
        // 深拷贝出一个颜色，直接赋值得到的是引用
        let slabColor = JSON.parse(
          JSON.stringify(rlLayer.filter((item) => item.Type == "rlSlabSeg"))
        );
        if (slabColor) slabColor = slabColor[0].Color;
        // slabColor.r = 255;
        // slabColor.g = 0;
        // slabColor.b = 0;
        //
        //

        // 绘制步数
        store.commit("globalData/setCanAddRawStep", true);
        // 执行loading
        if (ids.length > 10) {
          showFullScreenLoading("正在布置板..");
          // 确保 showFullScreenLoading 执行完毕
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        const gridDataRecord = {}; // 记录网格的guid

        ids.forEach((item) => {
          const mcObj = item.getMcDbEntity();
          if (mcObj) {
            const objGuid = mcObj.getxDataString("Guid").val;
            const objClassName = mcObj.getxDataString("classTypeName").val;

            if (objClassName == "rlGrid") {
              const selectObj = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              if (selectObj?.m_beamId || selectObj?.m_wallId) {
                rlLineGridGroup.push(selectObj);
                gridDataRecord[selectObj.Guid] = selectObj;
              }
            }
          }
        });

        if (rl_stdFlr_id == -999) {
          return;
        }

        const girdData = rlLineGridGroup.map((item) => {
          const isArc =
            item.m_centerJoint || (item.m_Axis && item.m_Axis.IsMainAxis < 0);
          if (isArc) {
            const stPoint = new McGePoint3d(...item.m_stJoint.m_pt);
            const edPoint = new McGePoint3d(...item.m_edJoint.m_pt);
            const centerPoint = new McGePoint3d(
              item.centerPoint[0],
              item.centerPoint[1],
              0
            );
            const dRadius = item.mcDbGrid.radius;
            const points = getArcPoints(stPoint, edPoint, centerPoint, dRadius);
            const pointsStr = points
              .map((item) => `${item.x},${item.y},0`)
              .join(",");
            return `${item.Guid}:[${pointsStr}],`;
          } else {
            return `${item.Guid}:[${[
              ...item.m_stJoint.m_pt,
              ...item.m_edJoint.m_pt,
            ]}],`;
          }
        });
        let data = "";
        girdData.forEach((item) => (data += item));

        // 获取楼板绘制数据
        const createSlab = new CreateSlab();
        const res = createSlab.getSlabJsonData(data);

        if (!res) return;
        const model = JSON.parse(res)?.Slab;
        const modelKeys = Object.keys(model);
        const modelData = Object.values(model).flat();

        // 把原楼板存进Map,方便后续查找,键为楼板2维点集的和,值为楼板对象
        const mapOldSlab = new Map();
        for (let i = 0; i < rlSlabGroup.length; i++) {
          const Old2dUpView = rlSlabGroup[i].index2dData;
          const OldSlabTotalPoints = [0, 0, 0];
          // 旧楼板2维点集
          for (let index = 0; index < Old2dUpView.length - 2; index += 3) {
            OldSlabTotalPoints[0] += Math.floor(Old2dUpView[index]);
            OldSlabTotalPoints[1] += Math.floor(Old2dUpView[index + 1]);
          }
          // OldSlabTotalPoints.sort((a, b) => a - b);
          // //判断mapOldSlab是否存在OldSlabTotalPoints
          // if (mapOldSlab.has(OldSlabTotalPoints.join(","))) {
          //   continue;
          // }
          mapOldSlab.set(OldSlabTotalPoints.join(","), rlSlabGroup[i]);
        }
        // console.log("mapOldSlab", mapOldSlab);

        for (let index = 0; index < modelData.length; index++) {
          const item = modelData[index];
          if (!modelKeys[index]) continue;

          // 判断当前新增楼板在当前楼层中是否有一模一样的重叠楼板,如果有则不布置新的楼板,且更新板厚
          // 判断是否重叠

          // 新板的2维点集的总和
          const NewSlabTotalPoints = [0, 0, 0];
          const New2dUpView = item["2DUpView"];
          for (let index = 0; index < New2dUpView.length - 2; index += 3) {
            NewSlabTotalPoints[0] += Math.floor(New2dUpView[index]);
            NewSlabTotalPoints[1] += Math.floor(New2dUpView[index + 1]);
          }
          // console.log("NewSlabTotalPoints", NewSlabTotalPoints);
          // NewSlabTotalPoints.sort((a, b) => a - b);
          const key = NewSlabTotalPoints.join(",");
          // console.log("key", key);
          // 如果存在重叠楼板,则更新板厚
          if (mapOldSlab.has(key)) {
            // console.log("修改板厚");
            const OldSlab = mapOldSlab.get(key);
            // 检测删除同类构件
            OldSlab.saveEditRevokeData();
            if (OldSlab.m_sectParamData.Guid != row.Guid) {
              const isMain = await checkDeleteHomogeneousMember(
                "rlSlab",
                OldSlab
              );
              if (isMain == false) {
                OldSlab.m_RelationGuid = null;
              }
              OldSlab.m_sectParamData.Guid = row.Guid;
            }
            // 更新板厚
            OldSlab.m_sectParamData.Thickness = Number(row.T);
            OldSlab.Thickness = Number(row.T);
            OldSlab.isWasmGeted = false;
            OldSlab.cc = offset;
            OldSlab.updateThisObj(OldSlab);
            continue;
          }

          // //判断此位置是否已存在楼板
          // let resSlabObj = [];
          // if (rlSlabGroup && rlSlabGroup.length > 0) {
          //   for (let i = 0; i < rlSlabGroup.length; i++) {
          //     let slabObj = rlSlabGroup[i];
          //     if (!slabObj || !slabObj.GridsID) continue;

          //     // 判断楼板是否在当前楼板范围内
          //     let GridsID = slabObj.GridsID.split(",");
          //     let modelKeysItem = modelKeys[index].split(",");
          //     let sameGridsID = GridsID.filter((item) =>
          //       modelKeysItem.includes(item)
          //     );
          //     // 如果楼板在当前楼板范围内，则将楼板添加到resSlabObj中
          //     if (sameGridsID && sameGridsID.length > 2) {
          //       resSlabObj.push(slabObj);
          //     }
          //   }
          // }
          // // 删除重复的楼板
          // for (let i = 0; i < resSlabObj.length; i++) {
          //   const item = resSlabObj[i];
          //   if (item) {
          //     rlSlabGroup = rlSlabGroup.filter(
          //       (item) => item.Guid != item.Guid
          //     );
          //     await item.erase();
          //   }
          // }
          // if (resSlabObj) await resSlabObj.erase();

          // 剔除重复的guid
          let gridsGuid = modelKeys[index].split(",");
          // 剔除重复的guid
          gridsGuid = [...new Set(gridsGuid)];
          let { roomNames, roomNameEnts } = get_Ent_RoomName(gridsGuid);
          gridsGuid = gridsGuid.join(",");

          const rlSlabObject = new rlSlabData();
          rlSlabObject.points = item.Points;
          rlSlabObject.index2dData = item["2DUpView"];
          rlSlabObject.member = true;
          rlSlabObject.GridsGuid = gridsGuid;
          rlSlabObject.VertexX = "";
          rlSlabObject.VertexY = "";
          rlSlabObject.VertexZ = "";
          for (let index = 0; index < item["2DUpView"].length - 2; index += 3) {
            rlSlabObject.VertexX += item["2DUpView"][index] + ",";
          }
          for (let index = 1; index < item["2DUpView"].length; index += 3) {
            rlSlabObject.VertexY += item["2DUpView"][index] + ",";
          }
          for (let index = 2; index < item["2DUpView"].length; index += 3) {
            rlSlabObject.VertexZ += item["2DUpView"][index] + ",";
          }

          rlSlabObject.Color = slabColor;
          var slabSectData = new rlSlabModelSectData();
          slabSectData.Guid = row.Guid;
          slabSectData.Mat = row.material;
          slabSectData.Thickness = Number(row.T);

          rlSlabObject.LevelB = currFlrLevelB;
          rlSlabObject.Height = currFlrHeight;
          rlSlabObject.Attribute = 2;
          rlSlabObject.m_sectParamData = slabSectData;
          rlSlabObject.Thickness = Number(row.T);
          rlSlabObject.cc = offset;
          rlSlabObject.useFunctionNames = roomNames;
          rlSlabObject.draw();
          await addEntityToDrawing(rlSlabObject, false);
          // 将楼板和房间关联
          for (let w = 0; w < roomNameEnts.length; w++) {
            roomNameEnts[w].saveEditRevokeData();
            roomNameEnts[w].allEntGuids.slabGuids.push(rlSlabObject.Guid);
            roomNameEnts[w].updateThisObj(roomNameEnts[w]);
          }
          //

          // 将楼板和网格关联
          const gridGuidsArray = gridsGuid.split(",");
          if (gridGuidsArray.length > 0) {
            gridGuidsArray.forEach((guidTmp) => {
              if (gridDataRecord[guidTmp]) {
                gridDataRecord[guidTmp].m_slabIds.push(rlSlabObject.Guid);
                rlSlabObject.gridsObjs.push(gridDataRecord[guidTmp]);
              }
            });
          }
        }

        // 更新显示
        rlAppObj.rlMxDrawObject.updateDisplay();
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
      } catch (error) {
        console.error("Error during set_slab operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };

    // 调用 userSelect 并传递 set_slab 回调
    userSelect(set_slab);
  });
};

// 创建次梁
export const create_subBeam_ents = async (rl_stdFlr_id, moduleForm) => {
  return new Promise(async (resFn, rejFn) => {
    if (!moduleForm) return;
    const { parameter, tableRow } = moduleForm;
    const isPcMode = store.state.app.isPcMode;
    const getPoint = async (isAssist) => {
      return new Promise((resolve, reject) => {
        const getPointInstance = new rlAppObj._rlMx.MrxDbgUiPrPoint();
        getPointInstance.go((status) => {
          if (status !== 0) {
            reject("已取消绘制");
            return;
          } else {
            isAssist ? resolve() : resolve(getPointInstance.value());
          }
        });
      });
    };
    try {
      let pt1, pt2;
      if (rl_stdFlr_id === -999) return;
      // 拿到对应标准层
      var rlBuilding = store.state.cadModules.rlBuilding;
      var currFlrHeight = rlBuilding.Height ?? 3000; // 当前楼层的高度
      var currFlrLevelB = 0; // rlBuilding.LevelB ?? 0;
      // 获取起点和终点
      // 获取起点和终点
      if (isPcMode) {
        pt1 = await getPoint();
        // 在PC模式下只需要获取一次点
        pt2 = await getPoint();
      } else {
        // 在移动端模式下需要获取两次点
        await getPoint(true); // 重新获取起点
        pt1 = await getPoint(); // 重新获取起点
        await getPoint(true);
        pt2 = await getPoint();
      }

      const rlLineGridGroup = rlAppObj.rlMxDatabase
        .getGroup("rlLineGridGroup")
        ?.getAll();
      if (!rlLineGridGroup) return;

      const isGridValid = async (grid, pt1, pt2) => {
        const pt1Tmp = grid.points[0];
        const pt2Tmp = grid.points[1];
        const bIsOn1 = ptOnLine(pt1, pt2, pt1Tmp);
        const bIsOn2 = ptOnLine(pt1, pt2, pt2Tmp);

        if (bIsOn1 >= 0 && bIsOn2 >= 0 && !grid.m_wallId && !grid.m_beamId) {
          const gridDatas = grid.m_Axis.m_gridIds;

          const isValidEntity = async (item) => {
            const objTmp = rlAppObj.rlMxDrawObject.getMxEntity(item);
            const pt1TmpData = objTmp.points[0];
            const pt2TmpData = objTmp.points[1];
            const bIsOn1 = ptOnLine(pt1, pt2, pt1TmpData);
            const bIsOn2 = ptOnLine(pt1, pt2, pt2TmpData);

            return bIsOn1 >= 0 &&
              bIsOn2 >= 0 &&
              !objTmp.m_wallId &&
              !objTmp.m_beamId
              ? objTmp.Guid
              : null;
          };

          const validEntities = await Promise.all(gridDatas.map(isValidEntity));
          const filteredEntities = validEntities.filter((entity) => entity);

          if (filteredEntities.length > 0) {
            return {
              grid,
              entities: filteredEntities.slice(0, 2),
            };
          }
        }
        return null;
      };

      // 绘制步数--优化次梁功能时详细测试
      store.commit("globalData/setCanAddRawStep", true);

      const validGrids = await Promise.all(
        rlLineGridGroup.map((grid) => isGridValid(grid, pt1, pt2))
      );
      const validSubBeams = validGrids.filter((grid) => grid);

      for (const { grid, entities } of validSubBeams) {
        const [grid1, grid2] = entities;
        const rlBeamObject = new rlSubBeamData();
        const m_sectParamData = new rlBeamModelSectData();
        rlBeamObject.initData({
          m_sectParamData: {
            Mat: tableRow.material,
            Kind: tableRow.section_param,
            Guid: tableRow.Guid,
            ShapeVal: `${tableRow.section_param},${tableRow.section
              .split("*")
              .join(",")},1,1`,
          },
          m_gridData1ID: grid1,
          m_gridData2ID: grid2,
          m_X1: pt1.x,
          m_Y1: pt1.y,
          m_Z1: pt1.z,
          m_X2: pt2.x,
          m_Y2: pt2.y,
          m_Z2: pt2.z,
          Height: currFlrHeight,
          LevelB: currFlrLevelB,
          Attribute: 1,
        });

        // m_sectParamData.Mat = tableRow.material;
        // m_sectParamData.Kind = tableRow.section_param;
        // m_sectParamData.Guid = tableRow.Guid;
        // m_sectParamData.ShapeVal = `${tableRow.section_param},${tableRow.section
        //   .split("*")
        //   .join(",")},1,1`;
        // rlBeamObject.m_sectParamData = m_sectParamData;
        // rlBeamObject.m_gridData1 = grid1;
        // rlBeamObject.m_gridData2 = grid2;
        // rlBeamObject.m_X1 = pt1.x;
        // rlBeamObject.m_Y1 = pt1.y;
        // rlBeamObject.m_Z1 = pt1.z;
        // rlBeamObject.m_X2 = pt2.x;
        // rlBeamObject.m_Y2 = pt2.y;
        // rlBeamObject.m_Z2 = pt2.z;
        // rlBeamObject.Height = 3000;
        // rlBeamObject.LevelB = 0;
        rlBeamObject.draw();
        await addEntityToDrawing(rlBeamObject, false);
      }

      rlAppObj.rlMxDrawObject.updateDisplay();
      resFn(validSubBeams.length > 0 ? 1 : 2);
      return true;
    } catch (error) {
      console.error("Error occurred:", error);
      rejFn(error);
      return false;
    }
  });
};

// 创建墙洞--弃用
export const create_wallHole_ents = async (moduleForm) => {
  if (!moduleForm) return;
  const { parameter, tableRow } = moduleForm;
  oneMessage.info("请点击屏幕拖动至墙中选择布置位置");

  // 保存模型对象的原始位置
  const originalPoint = new McGePoint3d(0, 0, 0);
  return new Promise(async (resolve) => {
    // 获取所有实体
    const gridData = store.state.rlEntData.totalEntityData["rlGrid"];

    // 创建墙关联缓存，避免重复调用 getEntityData
    const wallAssociationCache = new Map();

    // 构建缓存，但不在 item 上添加属性
    for (const item of gridData) {
      if (item.m_wallId) {
        const rlWallAssociation = getEntityData({
          Guid: item.m_wallId,
          classTypeName: "rlWallSeg",
        });
        if (rlWallAssociation) {
          wallAssociationCache.set(item.m_wallId, rlWallAssociation);
        }
      }
    }

    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = new McGePoint3d(0, 0, 0);

    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });

    // 设置第一个点位置
    const polyline = new McDbPolyline();
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    const polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
    let CurrentGridGuid = ""; // 记录当前网格guid
    let beforeAtGridPt = new McGePoint3d(); // 记录上一次在网格上的点,用于计算俯视图移动距离

    const mxcad = MxCpp.getCurrentMxCAD();
    // 创建一个新图层，并设置颜色为红色
    const redLayerId = mxcad.addLayer("LineLayer"); // 创建图层 "LineLayer"
    const redLayerObj = redLayerId.getMcDbEntity();

    mxcad.addDimStyle(
      "MyDimStyle2",
      "41,0.18,141,0.09,140,0,40,200",
      "77,1,271,3,73,1",
      "",
      ""
    );
    mxcad.drawDimStyle = "MyDimStyle2";
    const mDimensionId = mxcad.drawDimAligned(
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y
    );
    const mDimensionObj = mDimensionId.getMcDbEntity();
    // 设置颜色
    mDimensionObj.trueColor = new McCmColor(255, 0, 0);

    // 添加输入框
    let inputElement = getInputElement();
    if (!inputElement) {
      inputElement = createInputElement(mDimensionObj);
    } else {
      setCurrDataObj(mDimensionObj);
    }
    setContainerShow(false);
    let rlGridItem; // 鼠标最后停留的网格

    // 第一次点击鼠标
    getPoint.setInputToucheType(1);
    getPoint.go(async (status1) => {
      let girdEccPt;
      getPoint.setUserDraw((currentPoint) => {
        const SortGridArray = [];
        // 获取鼠标位置
        pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);

        // 判断鼠标是否在墙内
        for (const item of gridData) {
          if (item.m_wallId) {
            const rlWallAssociation = wallAssociationCache.get(item.m_wallId);
            if (!rlWallAssociation) continue;

            const ptClose = item.mcDbGrid.getClosestPointTo(pt1);
            const dDist = ptClose.val.distanceTo(pt1);

            if (rlWallAssociation.m_sectParamData.B / 2 > dDist) {
              SortGridArray.push({
                dToGrid: dDist, // 鼠标到线的最近点的距离
                NearPt: ptClose.val, // 鼠标到线的最近点
                gridIt: item, // 轴线数据
                wallThick: rlWallAssociation.m_sectParamData.B,
              });
            }
          }
        }

        const PolylineObj = polylineMcDb.getMcDbEntity();
        let moveX = 0; // 俯视图移动X
        let moveY = 0; // 俯视图移动Y
        if (Array.isArray(SortGridArray) && SortGridArray.length > 0) {
          // 按距离排序
          SortGridArray.sort((a, b) => a.dToGrid - b.dToGrid);
          const NearGrid = SortGridArray[0];
          rlGridItem = NearGrid.gridIt;

          let startPt = new McGePoint3d(...NearGrid.gridIt.m_stJoint.m_pt);
          let endPt = new McGePoint3d(...NearGrid.gridIt.m_edJoint.m_pt);
          // 如果起点到终点的方向向左或者向下，则交换起点和终点
          if (startPt.x > endPt.x || startPt.y > endPt.y) {
            const tmp = startPt;
            startPt = endPt;
            endPt = tmp;
          }
          const direction = new THREE.Vector3()
            .subVectors(endPt, startPt)
            .normalize();

          // if (direction.x < 0 || direction.y < 0) {
          //   // 起末点互换
          //   [startPt, endPt] = [endPt, startPt];
          //   direction = new THREE.Vector3()
          //     .subVectors(endPt, startPt)
          //     .normalize();
          // }

          const negateDirection = new THREE.Vector3(
            -direction.x,
            -direction.y,
            -direction.z
          ); // 方向取反
          const crossDirection = new THREE.Vector3();
          const vecZ = new THREE.Vector3(0, 0, 1);
          crossDirection.crossVectors(direction, vecZ).normalize();
          const negateCrossDirection = new THREE.Vector3(
            -crossDirection.x,
            -crossDirection.y,
            -crossDirection.z
          ); // 方向取反
          const atGridPt = NearGrid.NearPt; // 鼠标最近的网格点
          if (
            CurrentGridGuid === "" ||
            (CurrentGridGuid !== "" && CurrentGridGuid !== NearGrid.gridIt.Guid)
          ) {
            CurrentGridGuid = NearGrid.gridIt.Guid;
            beforeAtGridPt = atGridPt;
            // 改变预览多段线的形状

            let NewPt = MovePt(
              atGridPt,
              crossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, direction, tableRow.params.B / 2);
            PolylineObj.setPointAt(0, NewPt);

            NewPt = MovePt(
              atGridPt,
              negateCrossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, direction, tableRow.params.B / 2);
            PolylineObj.setPointAt(1, NewPt);

            NewPt = MovePt(
              atGridPt,
              negateCrossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, negateDirection, tableRow.params.B / 2);
            PolylineObj.setPointAt(2, NewPt);

            NewPt = MovePt(atGridPt, crossDirection, NearGrid.wallThick / 2);
            NewPt = MovePt(NewPt, negateDirection, tableRow.params.B / 2);
            PolylineObj.setPointAt(3, NewPt);

            NewPt = MovePt(atGridPt, crossDirection, NearGrid.wallThick / 2);
            NewPt = MovePt(NewPt, direction, tableRow.params.B / 2);
            PolylineObj.setPointAt(4, NewPt);
          } else {
            // 已存在俯视轮廓，计算移动距离
            moveX = atGridPt.x - beforeAtGridPt.x;
            moveY = atGridPt.y - beforeAtGridPt.y;
            beforeAtGridPt = atGridPt;
          }
          // inputElement.style.display = "block"; // 显示输入框
          setContainerShow(true);
          mDimensionObj.visible = true; // 显示标注
          // 计算标注点位
          let gridStPt = startPt;
          girdEccPt = startPt;

          let ptTmp = MovePt(atGridPt, negateDirection, tableRow.params.B / 2);
          mDimensionObj.xLine1Point = gridStPt;
          mDimensionObj.xLine2Point = ptTmp;
          gridStPt = MovePt(
            gridStPt,
            negateCrossDirection,
            NearGrid.wallThick / 2 + 100
          );
          ptTmp = MovePt(
            ptTmp,
            negateCrossDirection,
            NearGrid.wallThick / 2 + 100
          );

          const midX = (gridStPt.x + ptTmp.x) / 2;
          const midY = (gridStPt.y + ptTmp.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);

          setInputElementPosition(
            ptTmp.distanceTo(gridStPt).toFixed(0),
            midX,
            midY
          );
        } else {
          rlGridItem = null;
          // inputElement.style.display = "none"; // 隐藏输入框
          setContainerShow(false);
          mDimensionObj.visible = false; // 隐藏标注
          CurrentGridGuid = "";
          PolylineObj.setPointAt(0, new McGePoint3d(pt1.x, pt1.y, pt1.z));
          PolylineObj.setPointAt(1, new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
          PolylineObj.setPointAt(
            2,
            new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z)
          );
          PolylineObj.setPointAt(3, new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
          PolylineObj.setPointAt(4, new McGePoint3d(pt1.x, pt1.y, pt1.z));
        }
        // 移动俯视图
        PolylineObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + moveX, pt1.y + moveY, pt1.z)
        );
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        let wallHoleDataObj;
        if (rlGridItem) {
          try {
            const rlLayer = await getRlLayer();
            let wallHoleColor = rlLayer.filter(
              (rlGridItem) => rlGridItem.Type == "rlWallHole"
            );
            if (wallHoleColor && wallHoleColor.length > 0) {
              wallHoleColor = wallHoleColor[0].Color;
            }
            // 绘制步数
            store.commit("globalData/setCanAddRawStep", true);

            if (rlGridItem.m_wallId) {
              const rlWAllAssociation = wallAssociationCache.get(
                rlGridItem.m_wallId
              );
              if (rlWAllAssociation) {
                // 判断已存在墙洞
                const inputNum = getInptNum();
                let holeEcc = 1; // 1==居左，0==居中，-1==居右
                const gridLength = new THREE.Vector3(
                  ...rlGridItem.m_edJoint.m_pt
                ).distanceTo(new THREE.Vector3(...rlGridItem.m_stJoint.m_pt));

                if (inputNum <= 1) {
                  holeEcc = 1;
                } else if (inputNum + tableRow.params.B >= gridLength - 1) {
                  holeEcc = -1;
                } else if (
                  Math.abs(gridLength / 2 - inputNum - tableRow.params.B / 2) <
                  1
                ) {
                  holeEcc = 0;
                } else {
                  holeEcc = inputNum;
                }

                if (rlGridItem.m_wallHoleId) {
                  const rlWAllHoleAssociation = getEntityData({
                    Guid: rlGridItem.m_wallHoleId,
                    classTypeName: "rlWallHole",
                  });
                  if (rlWAllHoleAssociation) {
                    rlWAllAssociation.saveEditRevokeData();
                    rlWAllHoleAssociation.m_sectParamData.B = tableRow.params.B;
                    rlWAllHoleAssociation.m_sectParamData.H = tableRow.params.H;
                    rlWAllHoleAssociation.m_sectParamData.Guid = tableRow.Guid;
                    rlWAllHoleAssociation.Ecc = holeEcc;
                    rlWAllHoleAssociation.HDiff = Number(tableRow.elevation);
                    rlWAllHoleAssociation.isWasmGeted = false;
                    await rlWAllHoleAssociation.updateThisObj(
                      rlWAllHoleAssociation
                    );

                    wallHoleDataObj = rlWAllHoleAssociation;
                    // 保存moduleForm到otherData中，用于后续重复布置
                    setOtherData({ moduleForm, isCreatingNew: true });
                  }
                } else {
                  const rlWallHoleObject = new rlWallHoleData();

                  rlWallHoleObject.isWasmGeted = false;
                  rlWallHoleObject.initData({
                    m_sectParamData: {
                      Name: "",
                      B: tableRow.params.B,
                      H: tableRow.params.H,
                      Guid: tableRow.Guid,
                    },
                    m_wallEcc: Number(rlWAllAssociation.Ecc),
                    Ecc: holeEcc,
                    Color: wallHoleColor,
                    HDiff: Number(tableRow.elevation),
                    m_wallThick: Number(rlWAllAssociation.m_sectParamData.B),
                    m_gridData: rlGridItem,
                    LevelB: 0,
                  });
                  rlWallHoleObject.draw();
                  await addEntityToDrawing(rlWallHoleObject, false);
                  rlWAllAssociation.m_HoleId = rlWallHoleObject.Guid;
                  wallHoleDataObj = rlWallHoleObject;
                  // 保存moduleForm到otherData中，用于后续重复布置
                  setOtherData({ moduleForm, isCreatingNew: true });
                }
              }
            }
            // 将操作步骤下的所有数据更新到数据库中
            await saveDatabaseStore();
          } catch (error) {
            console.error("Error during operation:", error);
          } finally {
            // 隐藏加载
            tryHideFullScreenLoading();
          }
        }
        if (wallHoleDataObj) {
          oneMessage.info("请确认布置距离");
          setCurrDataObj(wallHoleDataObj);
          // 设置输入框位置和显示
          const gridSt = new THREE.Vector3(
            ...wallHoleDataObj.m_gridData.m_stJoint.m_pt
          );
          const gridEd = new THREE.Vector3(
            ...wallHoleDataObj.m_gridData.m_edJoint.m_pt
          );
          const direction = new THREE.Vector3()
            .subVectors(gridEd, gridSt)
            .normalize();
          const negateDirection = new THREE.Vector3(
            -direction.x,
            -direction.y,
            -direction.z
          );

          // 计算标注点的位置
          const vecZ = new THREE.Vector3(0, 0, 1);
          const crossDirection = new THREE.Vector3();
          crossDirection.crossVectors(direction, vecZ).normalize();
          const negateCrossDirection = new THREE.Vector3(
            -crossDirection.x,
            -crossDirection.y,
            -crossDirection.z
          );

          const gridLength = gridSt.distanceTo(gridEd);
          let ecc = wallHoleDataObj.Ecc;
          // //1==居左，0==居中，-1==居右
          if (ecc == -1) {
            ecc = gridLength - wallHoleDataObj.m_sectParamData.B;
          } else if (ecc == 0) {
            ecc = gridLength / 2 - wallHoleDataObj.m_sectParamData.B / 2;
          } else if (ecc == 1) {
            ecc = 0;
          }
          // 计算墙洞中心点
          const wallCenter = MovePt(gridSt, direction, ecc);

          // 计算标注线的起点和终点
          const dimStart = MovePt(
            gridSt,
            negateCrossDirection,
            wallHoleDataObj.m_wallThick / 2 + 100
          );
          const dimEnd = MovePt(
            wallCenter,
            negateCrossDirection,
            wallHoleDataObj.m_wallThick / 2 + 100
          );

          // 更新标注对象
          if (mDimensionObj) {
            mDimensionObj.xLine1Point = gridSt;
            mDimensionObj.xLine2Point = wallCenter;
            mDimensionObj.dimLinePoint = new McGePoint3d(
              (dimStart.x + dimEnd.x) / 2,
              (dimStart.y + dimEnd.y) / 2,
              0
            );
            mDimensionObj.visible = true;
          }

          // 设置输入框位置和显示
          setInputElementPosition(
            ecc.toFixed(0),
            (dimStart.x + dimEnd.x) / 2,
            (dimStart.y + dimEnd.y) / 2
          );
          setContainerShow(true);

          // 保存moduleForm到otherData中，用于后续重复布置
          setOtherData({ moduleForm, isCreatingNew: true });
        } else {
          // 调用中断事件
          window.dispatchEvent(new Event("commandendDrawModules"));
        }
        // 清理操作
        polylineMcDb.erase();
        mDimensionObj.erase();
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        resolve();
      });
    });
  });
};

//创建门窗-居中
export const create_doorsWindows_ents_center = async (
  rl_stdFlr_id,
  moduleForm
) => {
  const { parameter, tableRow } = moduleForm;
  return new Promise(async (resolve, reject) => {
    // 显示 loading
    // let el = document.querySelector(".MD_PG");
    // Message.info("请框选需要的对象");
    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = Number(rlBuilding.Height) ?? 3000; // 当前楼层的高度
    // 绘制回调方法
    const set_doorsWindows = async (ids) => {
      if (!ids || !ids.length) return;

      try {
        let doorsWindowsColor = getNonStructuralColor(Number(moduleForm.Mat));
        // 绘制步数
        store.commit("globalData/setCanAddRawStep", true);

        // 执行loading
        if (ids.length > 30) {
          showFullScreenLoading("正在布置门窗..");
          // 确保 showFullScreenLoading 执行完毕
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        let eraseIds = [];
        let eraseObjs = [];
        const addObjs = [];
        for (const item of ids) {
          const mcObj = item.getMcDbEntity();
          if (mcObj) {
            const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
            const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型

            if (objClassName == "rlGrid") {
              let rlGridData = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              //校验网格是否重叠
              let checkResult = await checkGridOverlap(rlGridData, eraseObjs);
              //完全重叠,删除网格
              if (checkResult.isOverlap) {
                eraseIds.push(rlGridData.Guid);
                eraseObjs.push(rlGridData);
                continue;
              }
              //部分重叠,打断网格
              if (checkResult.isLineInsert) {
                item.erase();
                if (checkResult.newGrid.length > 0) {
                  ids.push(...checkResult.newGrid);
                }
                //重新打开网格
                rlGridData = getEntityData({
                  Guid: rlGridData.Guid,
                  classTypeName: objClassName,
                });
                if (!rlGridData) {
                  continue;
                }
              }
              if (!rlGridData) {
                console.warn("当前选择对象为空");
                continue;
              }
              // 如果是无效网格，不需处理
              if (
                Math.abs(
                  rlGridData.m_stJoint.m_pt[0] - rlGridData.m_edJoint.m_pt[0]
                ) < 1 &&
                Math.abs(
                  rlGridData.m_stJoint.m_pt[1] - rlGridData.m_edJoint.m_pt[1]
                ) < 1
              ) {
                continue;
              }
              const tempOtherData = {
                startPoint: {
                  x: rlGridData.m_stJoint.m_pt[0],
                  y: rlGridData.m_stJoint.m_pt[1],
                  z: 0,
                },
                endPoint: {
                  x: rlGridData.m_edJoint.m_pt[0],
                  y: rlGridData.m_edJoint.m_pt[1],
                  z: 0,
                },
              };
              if (rlGridData.m_wallId) {
                let rlWallItem = getEntityData({
                  Guid: rlGridData.m_wallId,
                  classTypeName: "rlWallSeg",
                });
                if (rlWallItem && rlWallItem.m_HoleId) {
                  const rlWAllHoleAssociation = getEntityData({
                    Guid: rlWallItem.m_HoleId,
                    classTypeName: "rlWallHole",
                  });
                  if (rlWAllHoleAssociation) {
                    rlWAllHoleAssociation.saveEditRevokeData();
                    rlWAllHoleAssociation.m_sectParamData.B = tableRow.params.B;
                    rlWAllHoleAssociation.m_sectParamData.H = tableRow.params.H;
                    rlWAllHoleAssociation.m_sectParamData.Guid = tableRow.Guid;
                    rlWAllHoleAssociation.Ecc = 0;
                    rlWAllHoleAssociation.HDiff = Number(moduleForm.HDiff);
                    rlWAllHoleAssociation.isWasmGeted = false;
                    rlWAllHoleAssociation.Mat =
                      moduleForm.doorsType == 2 ? -1 : moduleForm.Mat;
                    rlWAllHoleAssociation.doorsWindowsType =
                      moduleForm.doorsType;
                    rlWAllHoleAssociation.Color = doorsWindowsColor;
                    rlWAllHoleAssociation.doorOpenType =
                      moduleForm.doorOpenType;
                    rlWAllHoleAssociation.updateThisObj(rlWAllHoleAssociation);
                  }
                } else {
                  const rlWallHoleObject = new rlWallHoleData();
                  rlWallHoleObject.isWasmGeted = false;
                  rlWallHoleObject.initData({
                    m_sectParamData: {
                      Name: "",
                      B: tableRow.params.B,
                      H: tableRow.params.H,
                      Guid: tableRow.Guid,
                    },
                    m_wallEcc: Number(rlWallItem.Ecc),
                    Ecc: 0,
                    Color: doorsWindowsColor,
                    HDiff: Number(moduleForm.HDiff),
                    m_wallThick: Number(rlWallItem.m_sectParamData.B),
                    m_gridData: rlWallItem.m_gridData,
                    LevelB: 0,
                    OtherData: JSON.stringify(tempOtherData),
                    Mat: moduleForm.doorsType == 2 ? -1 : moduleForm.Mat,
                    doorsWindowsType: moduleForm.doorsType,
                    doorOpenType: moduleForm.doorOpenType,
                    IsPartitionWall: 0,
                  });
                  rlWallHoleObject.draw();
                  await addEntityToDrawing(rlWallHoleObject, false);
                  rlWallItem.m_HoleId = rlWallHoleObject.Guid;
                }
                rlWallItem.drawBreakWall(); //打断墙
              }
            } else if (objClassName == "rlPartitionWallSeg") {
              let rlPartitionWallItem = getEntityData({
                Guid: objGuid,
                classTypeName: "rlPartitionWallSeg",
              });
              const tempOtherData = {
                startPoint: {
                  x: rlPartitionWallItem.startPoint.x,
                  y: rlPartitionWallItem.startPoint.y,
                  z: 0,
                },
                endPoint: {
                  x: rlPartitionWallItem.endPoint.x,
                  y: rlPartitionWallItem.endPoint.y,
                  z: 0,
                },
              };
              let hasHoleEccIs0 = false;
              if (
                rlPartitionWallItem &&
                rlPartitionWallItem.m_HoleIdArray.length > 0
              ) {
                for (const item of rlPartitionWallItem.m_HoleIdArray) {
                  const rlWAllHoleAssociation = getEntityData({
                    Guid: item,
                    classTypeName: "rlWallHole",
                  });
                  if (rlWAllHoleAssociation) {
                    if (rlWAllHoleAssociation.Ecc == 0) {
                      hasHoleEccIs0 = true;
                      rlWAllHoleAssociation.saveEditRevokeData();
                      rlWAllHoleAssociation.m_sectParamData.B =
                        tableRow.params.B;
                      rlWAllHoleAssociation.m_sectParamData.H =
                        tableRow.params.H;
                      rlWAllHoleAssociation.m_sectParamData.Guid =
                        tableRow.Guid;
                      rlWAllHoleAssociation.Ecc = 0;
                      rlWAllHoleAssociation.HDiff = Number(moduleForm.HDiff);
                      rlWAllHoleAssociation.isWasmGeted = false;
                      rlWAllHoleAssociation.Mat =
                        moduleForm.doorsType == 2 ? -1 : moduleForm.Mat;
                      rlWAllHoleAssociation.doorsWindowsType =
                        moduleForm.doorsType;
                      rlWAllHoleAssociation.Color = doorsWindowsColor;
                      rlWAllHoleAssociation.doorOpenType =
                        moduleForm.doorOpenType;
                      rlWAllHoleAssociation.updateThisObj(
                        rlWAllHoleAssociation
                      );
                      rlPartitionWallItem.drawBreakWall(); //打断墙
                      break;
                    }
                  }
                }
              }
              if (!hasHoleEccIs0) {
                const rlDoorsWindowsObject = new rlWallHoleData();
                rlDoorsWindowsObject.isWasmGeted = false;
                rlDoorsWindowsObject.initData({
                  m_sectParamData: {
                    Name: "",
                    B: tableRow.params.B,
                    H: tableRow.params.H,
                    Guid: tableRow.Guid,
                    Mat: moduleForm.doorsType == 2 ? -1 : moduleForm.Mat,
                  },
                  m_wallEcc: Number(rlPartitionWallItem.Ecc),
                  doorsWindowsType: moduleForm.doorsType,
                  Ecc: 0,
                  Color: doorsWindowsColor,
                  HDiff:
                    moduleForm.doorsType == 1 ? 0 : Number(moduleForm.HDiff),
                  Mat: moduleForm.doorsType == 2 ? -1 : moduleForm.Mat,
                  m_wallThick: Number(rlPartitionWallItem.m_sectParamData.B),
                  m_gridData: rlPartitionWallItem,
                  OtherData: JSON.stringify(tempOtherData),
                  LevelB: 0,
                  IsPartitionWall: 1,
                  doorOpenType: moduleForm.doorOpenType,
                });
                rlDoorsWindowsObject.draw();
                await addEntityToDrawing(rlDoorsWindowsObject, false);
                rlPartitionWallItem.drawBreakWall(); //打断墙
              }
            }
          }
        }
        if (eraseIds.length > 0) {
          for (const item of eraseIds) {
            const rlGridData = getEntityData({
              Guid: item,
              classTypeName: "rlGrid",
            });
            if (rlGridData) {
              rlGridData.erase();
            }
          }
        }
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
        // 更新显示
        await rlAppObj.rlMxDrawObject.updateDisplay();
      } catch (error) {
        console.error("Error during set_wall operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };

    // 调用 userSelect 并传递 set_doorsWindows 回调
    userSelect(set_doorsWindows);
  });
};

// 创建门窗-自由布置
export const create_doorsWindows_ents = async (rl_stdFlr_id, moduleForm) => {
  if (!moduleForm) return;
  const { parameter, tableRow } = moduleForm;
  oneMessage.info("请点击屏幕拖动至墙中选择布置位置");

  // 保存模型对象的原始位置
  const originalPoint = new McGePoint3d(0, 0, 0);
  return new Promise(async (resolve) => {
    // //是否正交模式
    // const isOrthogonal = store.state.platBtns.isOrthogonal;
    // if (isOrthogonal) {
    //   // 关闭正交模式
    //   fixOrthogonal(false);
    //   console.log("关闭");
    // }
    // 获取所有实体
    const PartitionWallData =
      store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];

    // 创建墙关联缓存，避免重复调用 getEntityData
    const wallAssociationCache = new Map();

    // 构建缓存，但不在 item 上添加属性
    for (const item of PartitionWallData) {
      wallAssociationCache.set(item.Guid, item);
    }
    // 获取所有实体
    const gridData = store.state.rlEntData.totalEntityData["rlGrid"];
    // 构建缓存，但不在 item 上添加属性
    for (const item of gridData) {
      if (item.m_wallId) {
        const rlWallAssociation = getEntityData({
          Guid: item.m_wallId,
          classTypeName: "rlWallSeg",
        });
        if (rlWallAssociation) {
          wallAssociationCache.set(item.m_wallId, rlWallAssociation);
        }
      }
    }
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = new McGePoint3d(0, 0, 0);

    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });

    // 设置第一个点位置
    const polyline = new McDbPolyline();
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    polyline.visible = false;
    const polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
    let partitionWallGuid = ""; // 记录当前隔墙guid
    let beforeAtGridPt = new McGePoint3d(); // 记录上一次在网格上的点,用于计算俯视图移动距离

    const mxcad = MxCpp.getCurrentMxCAD();
    // 创建一个新图层，并设置颜色为红色
    const redLayerId = mxcad.addLayer("LineLayer"); // 创建图层 "LineLayer"
    const redLayerObj = redLayerId.getMcDbEntity();

    mxcad.addDimStyle(
      "MyDimStyle2",
      "41,0.18,141,0.09,140,0,40,200",
      "77,1,271,3,73,1",
      "",
      ""
    );
    mxcad.drawDimStyle = "MyDimStyle2";
    const mDimensionId = mxcad.drawDimAligned(
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y
    );
    const mDimensionObj = mDimensionId.getMcDbEntity();
    // 设置颜色
    mDimensionObj.trueColor = new McCmColor(255, 0, 0);
    mDimensionObj.visible = false; // 初始隐藏，避免在(0,0,0)显示

    // 添加输入框
    let inputElement = getInputElement();
    if (!inputElement) {
      inputElement = createInputElement(mDimensionObj);
    } else {
      setCurrDataObj(mDimensionObj);
    }
    setContainerShow(false);
    let rlWallItem; // 鼠标最后停留的网格

    // 第一次点击鼠标
    getPoint.setInputToucheType(1);
    getPoint.go(async (status1) => {
      let girdEccPt;
      let doorwindowLength = 0;
      let totalLength = 0;
      getPoint.setUserDraw((currentPoint) => {
        const SortGridArray = [];
        // 获取鼠标位置
        pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);
        // 判断鼠标是否在墙内
        for (const item of wallAssociationCache) {
          let stPt = null;
          let edPt = null;

          if (item[1].classTypeName == "rlWallSeg") {
            stPt = new McGePoint3d(...item[1].m_gridData.m_stJoint.m_pt);
            edPt = new McGePoint3d(...item[1].m_gridData.m_edJoint.m_pt);
          } else if (item[1].classTypeName == "rlPartitionWallSeg") {
            stPt = item[1].startPoint;
            edPt = item[1].endPoint;
          }
          if (Array.isArray(item) && item.length >= 2 && stPt && edPt) {
            const polyline = new McDbPolyline();
            polyline.addVertexAt(stPt);
            polyline.addVertexAt(edPt);
            const ptClose = polyline.getClosestPointTo(pt1);
            const dDist = ptClose.val.distanceTo(pt1);
            if (item[1].m_sectParamData.B / 2 > dDist) {
              SortGridArray.push({
                dToGrid: dDist, // 鼠标到线的最近点的距离
                NearPt: ptClose.val, // 鼠标到线的最近点
                wallIt: item[1], // 轴线数据
                wallThick: item[1].m_sectParamData.B,
              });
            }
            polyline.erase();
          }
        }
        const PolylineObj = polylineMcDb.getMcDbEntity();
        PolylineObj.visible = true;
        let moveX = 0; // 俯视图移动X
        let moveY = 0; // 俯视图移动Y

        if (Array.isArray(SortGridArray) && SortGridArray.length > 0) {
          // 按距离排序
          SortGridArray.sort((a, b) => a.dToGrid - b.dToGrid);
          const NearGrid = SortGridArray[0];
          rlWallItem = NearGrid.wallIt;
          // 点位取整,避免浮点数精度问题
          let startPt = null;
          let endPt = null;
          if (NearGrid.wallIt.classTypeName == "rlWallSeg") {
            startPt = new McGePoint3d(
              ...NearGrid.wallIt.m_gridData.m_stJoint.m_pt
            );
            endPt = new McGePoint3d(
              ...NearGrid.wallIt.m_gridData.m_edJoint.m_pt
            );
          } else if (NearGrid.wallIt.classTypeName == "rlPartitionWallSeg") {
            startPt = new McGePoint3d(
              Math.floor(NearGrid.wallIt.startPoint.x),
              Math.floor(NearGrid.wallIt.startPoint.y),
              0
            );
            endPt = new McGePoint3d(
              Math.floor(NearGrid.wallIt.endPoint.x),
              Math.floor(NearGrid.wallIt.endPoint.y),
              0
            );
          }
          //

          let direction = new THREE.Vector3()
            .subVectors(endPt, startPt)
            .normalize();

          if (direction.x < 0 || direction.y < 0) {
            // 起末点互换
            [startPt, endPt] = [endPt, startPt];
            direction = new THREE.Vector3()
              .subVectors(endPt, startPt)
              .normalize();
          }

          const negateDirection = new THREE.Vector3(
            -direction.x,
            -direction.y,
            -direction.z
          ); // 方向取反
          const crossDirection = new THREE.Vector3();
          const vecZ = new THREE.Vector3(0, 0, 1);
          crossDirection.crossVectors(direction, vecZ).normalize();
          const negateCrossDirection = new THREE.Vector3(
            -crossDirection.x,
            -crossDirection.y,
            -crossDirection.z
          ); // 方向取反
          const atGridPt = NearGrid.NearPt; // 鼠标最近的网格点
          if (
            partitionWallGuid === "" ||
            (partitionWallGuid !== "" &&
              partitionWallGuid !== NearGrid.wallIt.Guid)
          ) {
            partitionWallGuid = NearGrid.wallIt.Guid;
            beforeAtGridPt = atGridPt;
            // 改变预览多段线的形状
            let NewPt = MovePt(
              atGridPt,
              crossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, direction, tableRow.params.B / 2);
            PolylineObj.setPointAt(0, NewPt);

            NewPt = MovePt(
              atGridPt,
              negateCrossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, direction, tableRow.params.B / 2);
            PolylineObj.setPointAt(1, NewPt);

            NewPt = MovePt(
              atGridPt,
              negateCrossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, negateDirection, tableRow.params.B / 2);
            PolylineObj.setPointAt(2, NewPt);

            NewPt = MovePt(atGridPt, crossDirection, NearGrid.wallThick / 2);
            NewPt = MovePt(NewPt, negateDirection, tableRow.params.B / 2);
            PolylineObj.setPointAt(3, NewPt);

            NewPt = MovePt(atGridPt, crossDirection, NearGrid.wallThick / 2);
            NewPt = MovePt(NewPt, direction, tableRow.params.B / 2);
            PolylineObj.setPointAt(4, NewPt);
          } else {
            // 已存在俯视轮廓，计算移动距离
            moveX = atGridPt.x - beforeAtGridPt.x;
            moveY = atGridPt.y - beforeAtGridPt.y;
            beforeAtGridPt = atGridPt;
          }
          // inputElement.style.display = "block"; // 显示输入框
          setContainerShow(true);
          mDimensionObj.visible = true; // 显示标注

          let ptTmp = MovePt(atGridPt, negateDirection, tableRow.params.B / 2);
          // 设置捕捉优化
          const snapPointTemp = enableSnapCorrection(currentPoint);
          let snapPoint = new McGePoint3d(snapPointTemp.x, snapPointTemp.y, 0);
          // 纠正点,当鼠标点在中线上下时,标注会歪,所以需要纠正
          const polyline = new McDbPolyline();
          polyline.addVertexAt(startPt);
          polyline.addVertexAt(endPt);
          snapPoint = polyline.getClosestPointTo(snapPoint).val;
          totalLength = endPt.distanceTo(startPt);
          let dist1 = snapPoint.distanceTo(startPt);
          let dist2 = snapPoint.distanceTo(endPt);
          // 计算标注点位
          let isChange = dist1 < dist2 ? false : true;
          console.log("isChange", isChange);
          //原始的st和ed被互换,所以ischange也换
          if (direction.x < 0 || direction.y < 0)
            store.commit("inspectionStore/setDoorWindowIsChange", !isChange);
          else store.commit("inspectionStore/setDoorWindowIsChange", isChange);

          let gridStPt = !isChange ? startPt : endPt;
          girdEccPt = gridStPt;
          // 计算标注点
          const snapVec = new THREE.Vector3()
            .subVectors(gridStPt, snapPoint)
            .normalize();
          const snapDist = snapPoint.distanceTo(ptTmp);

          snapPoint = MovePt(snapPoint, snapVec, snapDist);
          ptTmp = snapPoint || ptTmp;
          mDimensionObj.xLine1Point = gridStPt;
          mDimensionObj.xLine2Point = ptTmp;
          gridStPt = MovePt(
            gridStPt,
            negateCrossDirection,
            NearGrid.wallThick / 2 + 100
          );
          ptTmp = MovePt(
            ptTmp,
            negateCrossDirection,
            NearGrid.wallThick / 2 + 100
          );

          const midX = (gridStPt.x + ptTmp.x) / 2;
          const midY = (gridStPt.y + ptTmp.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);
          // 隔墙总长:
          const wallLength = startPt.distanceTo(endPt);
          doorwindowLength = Number(ptTmp.distanceTo(gridStPt).toFixed(0));
          if (
            Math.abs(
              wallLength / 2 - (doorwindowLength + tableRow.params.B / 2)
            ) <= 50
          ) {
            doorwindowLength = wallLength / 2 - tableRow.params.B / 2;
          }
          setInputElementPosition(doorwindowLength, midX, midY);
        } else {
          rlWallItem = null;
          totalLength = 0;
          store.commit("inspectionStore/setDoorWindowIsChange", false);
          // inputElement.style.display = "none"; // 隐藏输入框
          setContainerShow(false);
          mDimensionObj.visible = false; // 隐藏标注
          partitionWallGuid = "";
          PolylineObj.setPointAt(0, new McGePoint3d(pt1.x, pt1.y, pt1.z));
          PolylineObj.setPointAt(1, new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
          PolylineObj.setPointAt(
            2,
            new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z)
          );
          PolylineObj.setPointAt(3, new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
          PolylineObj.setPointAt(4, new McGePoint3d(pt1.x, pt1.y, pt1.z));
        }
        // 移动俯视图
        PolylineObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + moveX, pt1.y + moveY, pt1.z)
        );
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        // if (isOrthogonal) {
        //   // 打开正交模式
        //   fixOrthogonal(true);
        //   console.log("打开");
        // }
        let doorsWindowsObj = null;
        if (rlWallItem) {
          try {
            let doorsWindowsColor = getNonStructuralColor(
              Number(moduleForm.Mat)
            );
            //洞的颜色用白色,且没有材料
            if (moduleForm.doorsType == 2) {
              doorsWindowsColor = { r: 255, g: 255, b: 255, a: 1 };
            }
            // 绘制步数
            store.commit("globalData/setCanAddRawStep", true);
            if (rlWallItem.classTypeName == "rlWallSeg") {
              // 判断已存在墙洞
              let inputNum = getInptNum();
              if (store.state.inspectionStore.doorWindowIsChange) {
                inputNum = totalLength - inputNum - tableRow.params.B;
              }
              let holeEcc = 1; // 1==居左，0==居中，-1==居右
              const gridLength = new THREE.Vector3(
                ...rlWallItem.m_gridData.m_edJoint.m_pt
              ).distanceTo(
                new THREE.Vector3(...rlWallItem.m_gridData.m_stJoint.m_pt)
              );
              if (inputNum <= 1) {
                holeEcc = 1;
              } else if (inputNum + tableRow.params.B >= gridLength - 1) {
                holeEcc = -1;
              } else if (
                Math.abs(gridLength / 2 - inputNum - tableRow.params.B / 2) < 1
              ) {
                holeEcc = 0;
              } else {
                holeEcc = inputNum;
              }
              const tempOtherData = {
                startPoint: {
                  x: rlWallItem.m_gridData.m_stJoint.m_pt[0],
                  y: rlWallItem.m_gridData.m_stJoint.m_pt[1],
                  z: 0,
                },
                endPoint: {
                  x: rlWallItem.m_gridData.m_edJoint.m_pt[0],
                  y: rlWallItem.m_gridData.m_edJoint.m_pt[1],
                  z: 0,
                },
              };

              if (rlWallItem.m_HoleId) {
                const rlWAllHoleAssociation = getEntityData({
                  Guid: rlWallItem.m_HoleId,
                  classTypeName: "rlWallHole",
                });
                if (rlWAllHoleAssociation) {
                  rlWAllHoleAssociation.saveEditRevokeData();
                  rlWAllHoleAssociation.m_sectParamData.B = tableRow.params.B;
                  rlWAllHoleAssociation.m_sectParamData.H = tableRow.params.H;
                  rlWAllHoleAssociation.m_sectParamData.Guid = tableRow.Guid;
                  rlWAllHoleAssociation.Ecc = holeEcc;
                  rlWAllHoleAssociation.HDiff = Number(moduleForm.HDiff);
                  rlWAllHoleAssociation.isWasmGeted = false;
                  rlWAllHoleAssociation.Mat =
                    moduleForm.doorsType == 2 ? -1 : moduleForm.Mat;
                  rlWAllHoleAssociation.doorsWindowsType = moduleForm.doorsType;
                  rlWAllHoleAssociation.Color = doorsWindowsColor;
                  rlWAllHoleAssociation.doorOpenType = moduleForm.doorOpenType;
                  rlWAllHoleAssociation.updateThisObj(rlWAllHoleAssociation);

                  doorsWindowsObj = rlWAllHoleAssociation;
                  // 保存moduleForm到otherData中，用于后续重复布置
                  setOtherData({
                    rl_stdFlr_id,
                    rlWallItem,
                    moduleForm,
                    isCreatingNew: true,
                  });
                }
              } else {
                const rlWallHoleObject = new rlWallHoleData();
                rlWallHoleObject.isWasmGeted = false;
                rlWallHoleObject.initData({
                  m_sectParamData: {
                    Name: "",
                    B: tableRow.params.B,
                    H: tableRow.params.H,
                    Guid: tableRow.Guid,
                  },
                  m_wallEcc: Number(rlWallItem.Ecc),
                  Ecc: holeEcc,
                  Color: doorsWindowsColor,
                  HDiff: Number(moduleForm.HDiff),
                  m_wallThick: Number(rlWallItem.m_sectParamData.B),
                  m_gridData: rlWallItem.m_gridData,
                  LevelB: 0,
                  OtherData: JSON.stringify(tempOtherData),
                  Mat: moduleForm.doorsType == 2 ? -1 : moduleForm.Mat,
                  doorsWindowsType: moduleForm.doorsType,
                  doorOpenType: moduleForm.doorOpenType,
                  IsPartitionWall: 0,
                });
                rlWallHoleObject.draw();
                await addEntityToDrawing(rlWallHoleObject, false);
                rlWallItem.m_HoleId = rlWallHoleObject.Guid;

                doorsWindowsObj = rlWallHoleObject;
                // 保存moduleForm到otherData中，用于后续重复布置
                setOtherData({
                  rl_stdFlr_id,
                  rlWallItem,
                  moduleForm,
                  isCreatingNew: true,
                });
              }
            } else if (rlWallItem.classTypeName == "rlPartitionWallSeg") {
              // 距离
              let inputNum = doorwindowLength;
              if (store.state.inspectionStore.doorWindowIsChange) {
                inputNum = totalLength - doorwindowLength - tableRow.params.B;
              }
              const rlDoorsWindowsObject = new rlWallHoleData();
              const tempOtherData = {
                startPoint: {
                  x: rlWallItem.startPoint.x,
                  y: rlWallItem.startPoint.y,
                  z: 0,
                },
                endPoint: {
                  x: rlWallItem.endPoint.x,
                  y: rlWallItem.endPoint.y,
                  z: 0,
                },
              };
              rlDoorsWindowsObject.isWasmGeted = false;
              rlDoorsWindowsObject.initData({
                m_sectParamData: {
                  Name: "",
                  B: tableRow.params.B,
                  H: tableRow.params.H,
                  Guid: tableRow.Guid,
                  Mat: moduleForm.doorsType == 2 ? -1 : moduleForm.Mat,
                },
                m_wallEcc: Number(rlWallItem.Ecc),
                doorsWindowsType: moduleForm.doorsType,
                Ecc: inputNum,
                Color: doorsWindowsColor,
                HDiff: moduleForm.doorsType == 1 ? 0 : Number(moduleForm.HDiff),
                Mat: moduleForm.doorsType == 2 ? -1 : moduleForm.Mat,
                m_wallThick: Number(rlWallItem.m_sectParamData.B),
                m_gridData: rlWallItem,
                OtherData: JSON.stringify(tempOtherData),
                LevelB: 0,
                IsPartitionWall: 1,
                doorOpenType: moduleForm.doorOpenType,
              });
              rlDoorsWindowsObject.draw();
              await addEntityToDrawing(rlDoorsWindowsObject, false);
              // rlWallItem.m_HoleId = rlDoorsWindowsObject.Guid;
              doorsWindowsObj = rlDoorsWindowsObject;
              // 保存moduleForm到otherData中，用于后续重复布置
              setOtherData({
                rl_stdFlr_id,
                rlWallItem,
                moduleForm,
                isCreatingNew: true,
              });
            }

            // 将操作步骤下的所有数据更新到数据库中
            await saveDatabaseStore();
          } catch (error) {
            console.error("Error during operation:", error);
          } finally {
            // 隐藏加载
            tryHideFullScreenLoading();
          }
        }
        if (doorsWindowsObj) {
          oneMessage.info("请确认布置距离");
          setCurrDataObj(doorsWindowsObj);
          setContainerShow(true);
          // 保存moduleForm到otherData中，用于后续重复布置
          setOtherData({
            rl_stdFlr_id,
            rlWallItem,
            moduleForm,
            isCreatingNew: true,
          });
        }
        // 清理操作
        polylineMcDb.erase();
        mDimensionObj.erase();
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        // 如果doorsWindowsObj为null,说明创建失败，则重新布置
        if (!doorsWindowsObj) {
          await create_doorsWindows_ents(rl_stdFlr_id, moduleForm);
        }
        resolve();
      });
    });
  });
};

// 创建门窗--弃用
export const create_doorsWindows_ents1 = async (rl_stdFlr_id, moduleForm) => {
  if (!moduleForm) return;
  const { parameter, tableRow } = moduleForm;
  oneMessage.info("请点击屏幕拖动至墙中选择布置位置");

  // 保存模型对象的原始位置
  const originalPoint = new McGePoint3d(0, 0, 0);
  return new Promise(async (resolve) => {
    // 获取所有实体
    const PartitionWallData =
      store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];

    // 创建墙关联缓存，避免重复调用 getEntityData
    const wallAssociationCache = new Map();

    // 构建缓存，但不在 item 上添加属性
    for (const item of PartitionWallData) {
      wallAssociationCache.set(item.Guid, item);
    }
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    let pt1 = new McGePoint3d(0, 0, 0);

    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });

    // 设置第一个点位置
    const polyline = new McDbPolyline();
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
    polyline.addVertexAt(new McGePoint3d(pt1.x, pt1.y, pt1.z));
    const polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
    let partitionWallGuid = ""; // 记录当前隔墙guid
    let beforeAtGridPt = new McGePoint3d(); // 记录上一次在网格上的点,用于计算俯视图移动距离

    const mxcad = MxCpp.getCurrentMxCAD();
    // 创建一个新图层，并设置颜色为红色
    const redLayerId = mxcad.addLayer("LineLayer"); // 创建图层 "LineLayer"
    const redLayerObj = redLayerId.getMcDbEntity();

    mxcad.addDimStyle(
      "MyDimStyle2",
      "41,0.18,141,0.09,140,0,40,200",
      "77,1,271,3,73,1",
      "",
      ""
    );
    mxcad.drawDimStyle = "MyDimStyle2";
    const mDimensionId = mxcad.drawDimAligned(
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y,
      originalPoint.x,
      originalPoint.y
    );
    const mDimensionObj = mDimensionId.getMcDbEntity();
    // 设置颜色
    mDimensionObj.trueColor = new McCmColor(255, 0, 0);

    // 添加输入框
    let inputElement = getInputElement();
    if (!inputElement) {
      inputElement = createInputElement(mDimensionObj);
    } else {
      setCurrDataObj(mDimensionObj);
    }
    setContainerShow(false);
    let rlWallItem; // 鼠标最后停留的网格

    // 第一次点击鼠标
    getPoint.setInputToucheType(1);
    getPoint.go(async (status1) => {
      let girdEccPt;
      let doorwindowLength = 0;
      getPoint.setUserDraw((currentPoint) => {
        const SortGridArray = [];
        // 获取鼠标位置
        pt1 = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);
        // 判断鼠标是否在墙内
        for (const item of wallAssociationCache) {
          if (
            Array.isArray(item) &&
            item.length >= 2 &&
            item[1].startPoint &&
            item[1].endPoint
          ) {
            const polyline = new McDbPolyline();
            polyline.addVertexAt(item[1].startPoint);
            polyline.addVertexAt(item[1].endPoint);
            const ptClose = polyline.getClosestPointTo(pt1);
            const dDist = ptClose.val.distanceTo(pt1);
            if (item[1].m_sectParamData.B / 2 > dDist) {
              SortGridArray.push({
                dToGrid: dDist, // 鼠标到线的最近点的距离
                NearPt: ptClose.val, // 鼠标到线的最近点
                partitionWallIt: item[1], // 轴线数据
                wallThick: item[1].m_sectParamData.B,
              });
            }
            polyline.erase();
          }
        }
        const PolylineObj = polylineMcDb.getMcDbEntity();
        let moveX = 0; // 俯视图移动X
        let moveY = 0; // 俯视图移动Y
        if (Array.isArray(SortGridArray) && SortGridArray.length > 0) {
          // 按距离排序
          SortGridArray.sort((a, b) => a.dToGrid - b.dToGrid);
          const NearGrid = SortGridArray[0];
          rlWallItem = NearGrid.partitionWallIt;
          // 点位取整,避免浮点数精度问题
          let startPt = new McGePoint3d(
            Math.floor(NearGrid.partitionWallIt.startPoint.x),
            Math.floor(NearGrid.partitionWallIt.startPoint.y),
            0
          );
          let endPt = new McGePoint3d(
            Math.floor(NearGrid.partitionWallIt.endPoint.x),
            Math.floor(NearGrid.partitionWallIt.endPoint.y),
            0
          );
          let direction = new THREE.Vector3()
            .subVectors(endPt, startPt)
            .normalize();

          if (direction.x < 0 || direction.y < 0) {
            // 起末点互换
            [startPt, endPt] = [endPt, startPt];
            direction = new THREE.Vector3()
              .subVectors(endPt, startPt)
              .normalize();
          }

          const negateDirection = new THREE.Vector3(
            -direction.x,
            -direction.y,
            -direction.z
          ); // 方向取反
          const crossDirection = new THREE.Vector3();
          const vecZ = new THREE.Vector3(0, 0, 1);
          crossDirection.crossVectors(direction, vecZ).normalize();
          const negateCrossDirection = new THREE.Vector3(
            -crossDirection.x,
            -crossDirection.y,
            -crossDirection.z
          ); // 方向取反
          const atGridPt = NearGrid.NearPt; // 鼠标最近的网格点
          if (
            partitionWallGuid === "" ||
            (partitionWallGuid !== "" &&
              partitionWallGuid !== NearGrid.partitionWallIt.Guid)
          ) {
            partitionWallGuid = NearGrid.partitionWallIt.Guid;
            beforeAtGridPt = atGridPt;
            // 改变预览多段线的形状
            let NewPt = MovePt(
              atGridPt,
              crossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, direction, tableRow.B / 2);
            PolylineObj.setPointAt(0, NewPt);

            NewPt = MovePt(
              atGridPt,
              negateCrossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, direction, tableRow.B / 2);
            PolylineObj.setPointAt(1, NewPt);

            NewPt = MovePt(
              atGridPt,
              negateCrossDirection,
              NearGrid.wallThick / 2
            );
            NewPt = MovePt(NewPt, negateDirection, tableRow.B / 2);
            PolylineObj.setPointAt(2, NewPt);

            NewPt = MovePt(atGridPt, crossDirection, NearGrid.wallThick / 2);
            NewPt = MovePt(NewPt, negateDirection, tableRow.B / 2);
            PolylineObj.setPointAt(3, NewPt);

            NewPt = MovePt(atGridPt, crossDirection, NearGrid.wallThick / 2);
            NewPt = MovePt(NewPt, direction, tableRow.B / 2);
            PolylineObj.setPointAt(4, NewPt);
          } else {
            // 已存在俯视轮廓，计算移动距离
            moveX = atGridPt.x - beforeAtGridPt.x;
            moveY = atGridPt.y - beforeAtGridPt.y;
            beforeAtGridPt = atGridPt;
          }
          // inputElement.style.display = "block"; // 显示输入框
          setContainerShow(true);
          mDimensionObj.visible = true; // 显示标注
          // 计算标注点位
          let gridStPt = startPt;
          girdEccPt = startPt;
          let ptTmp = MovePt(atGridPt, negateDirection, tableRow.B / 2);
          // 设置捕捉优化
          const snapPointTemp = enableSnapCorrection(currentPoint);
          let snapPoint = new McGePoint3d(snapPointTemp.x, snapPointTemp.y, 0);
          // 纠正点,当鼠标点在中线上下时,标注会歪,所以需要纠正
          const polyline = new McDbPolyline();
          polyline.addVertexAt(startPt);
          polyline.addVertexAt(endPt);
          snapPoint = polyline.getClosestPointTo(snapPoint).val;
          // 计算标注点
          const snapVec = new THREE.Vector3()
            .subVectors(gridStPt, snapPoint)
            .normalize();
          const snapDist = snapPoint.distanceTo(ptTmp);

          snapPoint = MovePt(snapPoint, snapVec, snapDist);
          ptTmp = snapPoint || ptTmp;
          mDimensionObj.xLine1Point = gridStPt;
          mDimensionObj.xLine2Point = ptTmp;
          gridStPt = MovePt(
            gridStPt,
            negateCrossDirection,
            NearGrid.wallThick / 2 + 100
          );
          ptTmp = MovePt(
            ptTmp,
            negateCrossDirection,
            NearGrid.wallThick / 2 + 100
          );

          const midX = (gridStPt.x + ptTmp.x) / 2;
          const midY = (gridStPt.y + ptTmp.y) / 2;
          mDimensionObj.dimLinePoint = new McGePoint3d(midX, midY, 0);
          // 隔墙总长:
          const wallLength = startPt.distanceTo(endPt);
          doorwindowLength = Number(ptTmp.distanceTo(gridStPt).toFixed(0));
          if (
            Math.abs(wallLength / 2 - (doorwindowLength + tableRow.B / 2)) <= 50
          ) {
            doorwindowLength = wallLength / 2 - tableRow.B / 2;
          }
          setInputElementPosition(doorwindowLength, midX, midY);
        } else {
          rlWallItem = null;
          // inputElement.style.display = "none"; // 隐藏输入框
          setContainerShow(false);
          mDimensionObj.visible = false; // 隐藏标注
          partitionWallGuid = "";
          PolylineObj.setPointAt(0, new McGePoint3d(pt1.x, pt1.y, pt1.z));
          PolylineObj.setPointAt(1, new McGePoint3d(pt1.x, pt1.y + 100, pt1.z));
          PolylineObj.setPointAt(
            2,
            new McGePoint3d(pt1.x + 100, pt1.y + 100, pt1.z)
          );
          PolylineObj.setPointAt(3, new McGePoint3d(pt1.x + 100, pt1.y, pt1.z));
          PolylineObj.setPointAt(4, new McGePoint3d(pt1.x, pt1.y, pt1.z));
        }
        // 移动俯视图
        PolylineObj.move(
          new McGePoint3d(pt1.x, pt1.y, pt1.z),
          new McGePoint3d(pt1.x + moveX, pt1.y + moveY, pt1.z)
        );
      });

      // 第二次点击鼠标
      getPoint.setInputToucheType(2);
      getPoint.go(async (status2) => {
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        let doorsWindowsObj = null;
        if (rlWallItem) {
          try {
            const doorsWindowsColor = getNonStructuralColor(
              Number(moduleForm.Mat)
            );
            // 绘制步数
            store.commit("globalData/setCanAddRawStep", true);

            // 距离
            const inputNum = doorwindowLength;
            const rlDoorsWindowsObject = new rlDoorsWindowsData();
            const tempOtherData = {
              startPoint: {
                x: rlWallItem.startPoint.x,
                y: rlWallItem.startPoint.y,
                z: 0,
              },
              endPoint: {
                x: rlWallItem.endPoint.x,
                y: rlWallItem.endPoint.y,
                z: 0,
              },
            };
            rlDoorsWindowsObject.isWasmGeted = false;
            rlDoorsWindowsObject.initData({
              m_sectParamData: {
                Name: "",
                B: tableRow.B,
                H: tableRow.H,
                Guid: tableRow.Guid,
                Mat: moduleForm.Mat,
              },
              m_partitionWallEcc: Number(rlWallItem.Ecc),
              doorsWindowsType: moduleForm.doorsType,
              Ecc: inputNum,
              Color: doorsWindowsColor,
              HDiff: moduleForm.doorsType == 1 ? 0 : Number(moduleForm.HDiff),
              Mat: moduleForm.Mat,
              m_partitionWallThick: Number(rlWallItem.m_sectParamData.B),
              m_partitionWallData: rlWallItem,
              OtherData: JSON.stringify(tempOtherData),
              LevelB: 0,
            });
            rlDoorsWindowsObject.draw();
            await addEntityToDrawing(rlDoorsWindowsObject, false);
            // rlWallItem.m_HoleId = rlDoorsWindowsObject.Guid;
            doorsWindowsObj = rlDoorsWindowsObject;
            // 保存moduleForm到otherData中，用于后续重复布置
            setOtherData({
              rl_stdFlr_id,
              rlWallItem,
              moduleForm,
              isCreatingNew: true,
            });
            // 将操作步骤下的所有数据更新到数据库中
            await saveDatabaseStore();
          } catch (error) {
            console.error("Error during operation:", error);
          } finally {
            // 隐藏加载
            tryHideFullScreenLoading();
          }
        }
        if (doorsWindowsObj) {
          oneMessage.info("请确认布置距离");
          setCurrDataObj(doorsWindowsObj);
          setContainerShow(true);
          // 保存moduleForm到otherData中，用于后续重复布置
          setOtherData({
            rl_stdFlr_id,
            rlWallItem,
            moduleForm,
            isCreatingNew: true,
          });
        }
        // 清理操作
        polylineMcDb.erase();
        mDimensionObj.erase();
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识
        // 如果doorsWindowsObj为null,说明创建失败，则重新布置
        if (!doorsWindowsObj) {
          await create_doorsWindows_ents(rl_stdFlr_id, moduleForm);
        }
        resolve();
      });
    });
  });
};

// 创建用途
export const create_Use_ents = async (
  rl_stdFlr_id,
  rlModules,
  useFunctionType,
  isInvestigate
) => {
  return new Promise(async (resolve, reject) => {
    if (!useFunctionType) return;
    // 拿到对应标准层
    // businessTypePermission:detect 可靠性鉴定报告/investigate 排查报告
    // 检测----选楼板,布置用途
    if (!isInvestigate) {
      // one; // Message.info("请框选需要的对象");
      // 显示 loading
      // let el = document.querySelector(".MD_PG");
      const set_Use = async (ids) => {
        const rlSlabGroup = []; // 楼板
        const rlPartitionWallGroup = []; // 隔墙
        if (!ids || !ids.length) resolve();
        try {
          // 绘制步数
          store.commit("globalData/setCanAddRawStep", true);
          // 执行loading
          if (ids.length > 10) {
            showFullScreenLoading("正在布置用途..");
            // 确保 showFullScreenLoading 执行完毕
            await new Promise((resolve) => setTimeout(resolve, 50));
          }

          ids.forEach((item) => {
            const mcObj = item.getMcDbEntity();
            if (mcObj) {
              const objGuid = mcObj.getxDataString("Guid").val;
              const objClassName = mcObj.getxDataString("classTypeName").val;
              const selectObj = getEntityData({
                Guid: objGuid,
                classTypeName: objClassName,
              });
              if (objClassName == "rlSlab") rlSlabGroup.push(selectObj);
              if (objClassName == "rlPartitionWallSeg") {
                if (
                  !rlPartitionWallGroup.find(
                    (itW) => itW.Guid == selectObj.Guid
                  )
                )
                  rlPartitionWallGroup.push(selectObj);
              }
            }
          });

          if (rl_stdFlr_id == -999) {
            return;
          }
          // 获取最大房间编号
          // let iMaxIndex = getMaxRoomNo(useFunctionType.label);
          // // 获取最大房间编号
          // iMaxIndex++;
          for (let index = 0; index < rlSlabGroup.length; index++) {
            const item = rlSlabGroup[index];
            const Slab2dUpView = item.index2dData;
            const points = [];
            if (Slab2dUpView) {
              for (let i = 0; i < Slab2dUpView.length; i += 3) {
                points.push(
                  new McGePoint3d(Slab2dUpView[i], Slab2dUpView[i + 1], 0)
                );
              }
            }
            // 如果存在用途,则更改用途属性
            if (item.m_useId) {
              const objtmp = getEntityData({
                classTypeName: "rlUse",
                Guid: item.m_useId,
              });

              if (objtmp) {
                objtmp.saveEditRevokeData();
                objtmp.useFunction = useFunctionType.label;
                objtmp.useFunctionName = useFunctionType.label;
                await objtmp.updateThisObj(objtmp);
              }
            } else {
              const rlUseObject = new rlUseData();
              rlUseObject.initData({
                useFunction: useFunctionType.label,
                useFunctionName: useFunctionType.label,
                points: points,
                m_slabId: item.Guid,
                m_SlabData: item,
                m_useType: "UseName",
              });
              rlUseObject.draw();
              await addEntityToDrawing(rlUseObject, false);
            }
          }
          // 更新显示
          rlAppObj.rlMxDrawObject.updateDisplay();
          // 将操作步骤下的所有数据更新到数据库中
          await saveDatabaseStore();
          // 隔墙布置用途
          await create_Use_ents_By_PartitionWall(
            rl_stdFlr_id,
            rlPartitionWallGroup,
            isInvestigate,
            useFunctionType.label
          );
        } catch (error) {
          console.error("Error during set_slab operation:", error);
        } finally {
          // 隐藏 loading
          tryHideFullScreenLoading();
        }
      };
      // 调用 userSelect 并传递 set_slab 回调
      userSelect(set_Use);
    } else if (isInvestigate) {
      // 排查----选隔墙,布置房间命名
      await create_Use_ents_By_PartitionWall(
        rl_stdFlr_id,
        [],
        isInvestigate,
        useFunctionType.label
      );
    }
  });
};

// 通过隔墙布置房间命名
export const create_Use_ents_By_PartitionWall = async (
  rl_stdFlr_id,
  rlPartitionWallGroup,
  isInvestigate,
  useFunctionName
) => {
  return new Promise(async (resolve, reject) => {
    const allUse = store.state.rlEntData.totalEntityData["rlUse"];
    const allPartitionWalls = isInvestigate
      ? store.state.rlEntData.totalEntityData["rlPartitionWallSeg"]
      : rlPartitionWallGroup;
    const allBeams = store.state.rlEntData.totalEntityData["rlBeamSeg"];
    const allColumns = store.state.rlEntData.totalEntityData["rlColSeg"];
    const allWalls = store.state.rlEntData.totalEntityData["rlWallSeg"];
    const allSlabs = store.state.rlEntData.totalEntityData["rlSlab"];
    console.log("allPartitionWalls", allPartitionWalls);

    const gridDataRecord = {}; // 记录隔墙的guid
    const gridWallDataRecord = {}; // 记录墙的guid

    const rlLinePartitionWallGroup = [];
    try {
      // 绘制步数
      store.commit("globalData/setCanAddRawStep", true);
      // 执行loading
      if (allPartitionWalls.length > 10) {
        showFullScreenLoading("正在布置用途..");
        // 确保 showFullScreenLoading 执行完毕
        await new Promise((resolve) => setTimeout(resolve, 50));
      }
      // 获取隔墙数据
      allPartitionWalls.forEach((item) => {
        if (item.startPoint && item.endPoint) {
          rlLinePartitionWallGroup.push(item);
          gridDataRecord[item.Guid] = item;
        }
      });
      // 排查--增加隔墙与墙围成的区域,把墙的线也增加进去
      if (isInvestigate) {
        allWalls.forEach((itemW) => {
          const ptStartW = new McGePoint3d(
            itemW.m_gridData.m_stJoint.m_pt[0],
            itemW.m_gridData.m_stJoint.m_pt[1],
            0
          );
          const ptEndW = new McGePoint3d(
            itemW.m_gridData.m_edJoint.m_pt[0],
            itemW.m_gridData.m_edJoint.m_pt[1],
            0
          );
          // 记录隔墙与墙的交点
          const ptIntersections = [];
          ptIntersections.push(ptStartW);
          ptIntersections.push(ptEndW);
          allPartitionWalls.forEach((itemP) => {
            if (itemP.startPoint && itemP.endPoint) {
              const ptStartP = itemP.startPoint;
              const ptEndP = itemP.endPoint;
              const res = lineInsection(
                ptStartW,
                ptEndW,
                ptStartP,
                ptEndP,
                false
              );
              if (res.isIntersected) {
                if (
                  !isPointEqual(res.intersectionPoint, ptStartW) &&
                  !isPointEqual(res.intersectionPoint, ptEndW)
                ) {
                  ptIntersections.push(res.intersectionPoint);
                }
              }
            }
          });
          gridWallDataRecord[itemW.Guid] = itemW;
          if (ptIntersections.length > 2) {
            // 获取交点之间的线段
            const lines = groupPoints(ptIntersections);
            for (let i = 0; i < lines.length; i++) {
              rlLinePartitionWallGroup.push({
                Guid: itemW.Guid,
                startPoint: lines[i].startPt,
                endPoint: lines[i].endPt,
              });
            }
          } else {
            rlLinePartitionWallGroup.push({
              Guid: itemW.Guid,
              startPoint: ptStartW,
              endPoint: ptEndW,
            });
          }
        });
      }

      if (rl_stdFlr_id == -999) {
        return;
      }
      let allPoints = [];
      const partitionWallData = rlLinePartitionWallGroup.map((item) => {
        const isArc =
          (item.m_gridData && item.m_gridData.m_centerJoint) ||
          (item.m_gridData &&
            item.m_gridData.m_Axis &&
            item.m_gridData.m_Axis.IsMainAxis < 0);
        if (isArc) {
          const stPoint = new McGePoint3d(...item.m_gridData.m_stJoint.m_pt);
          const edPoint = new McGePoint3d(...item.m_gridData.m_edJoint.m_pt);
          const centerPoint = new McGePoint3d(
            item.m_gridData.centerPoint[0],
            item.m_gridData.centerPoint[1],
            0
          );
          const dRadius = item.m_gridData.mcDbGrid.radius;
          const points = getArcPoints(stPoint, edPoint, centerPoint, dRadius);
          const pointsStr = points
            .map((item) => `${item.x},${item.y},0`)
            .join(",");
          return `${item.Guid}:[${pointsStr}],`;
        } else {
          let pt1 = new McGePoint3d(item.startPoint.x, item.startPoint.y, 0);
          let pt2 = new McGePoint3d(item.endPoint.x, item.endPoint.y, 0);
          let isPt1 = false;
          let isPt2 = false;
          for (let i = 0; i < allPoints.length; i++) {
            if (isPointEqual(allPoints[i], pt1, 0.1)) {
              isPt1 = true;
              continue;
            } else {
              let dist = allPoints[i].distanceTo(pt1);
              if (dist < 3) {
                pt1.x = allPoints[i].x;
                pt1.y = allPoints[i].y;
                isPt1 = true;
                continue;
              }
            }
            if (isPointEqual(allPoints[i], pt2, 0.1)) {
              isPt2 = true;
              continue;
            } else {
              let dist = allPoints[i].distanceTo(pt2);
              if (dist < 3) {
                pt2.x = allPoints[i].x;
                pt2.y = allPoints[i].y;
                isPt2 = true;
                continue;
              }
            }
          }
          if (!isPt1) allPoints.push(pt1);
          if (!isPt2) allPoints.push(pt2);
          return `${item.Guid}:[${[pt1.x, pt1.y, 0, pt2.x, pt2.y, 0]}],`;
        }
      });
      let data = "";
      partitionWallData.forEach((item) => (data += item));
      // 获取隔墙围成的闭合区域
      // let res = await rlModules.getSlabJsonData(data);
      const createSlab = new CreateSlab();
      const res = createSlab.getSlabJsonData(data);
      if (!res) {
        resolve();
        return;
      }
      const model = JSON.parse(res)?.Slab;
      const modelKeys = Object.keys(model);
      const modelData = Object.values(model).flat();

      // 把原楼板存进Map,方便后续查找,键为楼板2维点集的和,值为楼板对象
      const mapOldUse = new Map();
      const RoomType = isInvestigate ? "RoomName" : "UseName";
      const RoomName = isInvestigate ? "未命名房间" : useFunctionName;
      for (let i = 0; i < allUse.length; i++) {
        // 如果用途类型不是房间名称,则跳过
        if (allUse[i].m_useType !== RoomType) continue;
        let Old2dUpView = allUse[i].points;
        // 找出多边形的端点
        Old2dUpView = findVertices(Old2dUpView);
        const OldSlabTotalPoints = [0, 0, 0];
        // 旧楼板2维点集
        for (let index = 0; index < Old2dUpView.length; index++) {
          OldSlabTotalPoints[0] += Math.floor(Old2dUpView[index].x);
          OldSlabTotalPoints[1] += Math.floor(Old2dUpView[index].y);
        }
        mapOldUse.set(OldSlabTotalPoints.join(","), allUse[i]);
      }
      // 获取最大房间编号
      let iMaxIndex = getMaxRoomNo(RoomName);
      // 获取最大房间编号
      iMaxIndex++;
      // console.log("mapOldUse...", mapOldUse);

      for (let index = 0; index < modelData.length; index++, iMaxIndex++) {
        const item = modelData[index];
        if (!modelKeys[index]) continue;
        // 新板的2维点集的总和
        const NewSlabTotalPoint = [0, 0, 0];
        let NewSlabTotalPoints = [];
        const New2dUpView = item["2DUpView"];
        for (let index = 0; index < New2dUpView.length - 2; index += 3) {
          NewSlabTotalPoints.push(
            new McGePoint3d(New2dUpView[index], New2dUpView[index + 1], 0)
          );
        }
        // 找出多边形的端点
        NewSlabTotalPoints = findVertices(NewSlabTotalPoints);
        for (let index = 0; index < NewSlabTotalPoints.length; index++) {
          NewSlabTotalPoint[0] += Math.floor(NewSlabTotalPoints[index].x);
          NewSlabTotalPoint[1] += Math.floor(NewSlabTotalPoints[index].y);
        }
        const points = [];
        if (New2dUpView) {
          for (let i = 0; i < New2dUpView.length; i += 3) {
            points.push(new McGePoint3d(New2dUpView[i], New2dUpView[i + 1], 0));
          }
        }
        // 将隔墙guid添加到用途中
        const gridGuids = modelKeys[index];
        const gridGuidsArray = gridGuids.split(",");
        const partitionWallGuids = [];
        const allEntGuids = {
          partitionWallGuids: [],
          wallGuids: [],
          slabGuids: [],
          beamGuids: [],
          columnGuids: [],
        }; // 记录所有与该房间有关的实体
        if (gridGuidsArray.length > 0) {
          gridGuidsArray.forEach((guidTmp) => {
            // 把有关的隔墙的guid添加到allEntGuids中
            if (gridDataRecord[guidTmp]) {
              partitionWallGuids.push(gridDataRecord[guidTmp].Guid);
            }
            // 把有关的墙的guid添加到allEntGuids中
            if (gridWallDataRecord[guidTmp]) {
              // 如果墙的guid不在allEntGuids.wallGuids中,则添加
              if (
                !allEntGuids.wallGuids.find(
                  (guid) => guid == gridWallDataRecord[guidTmp].Guid
                )
              ) {
                allEntGuids.wallGuids.push(gridWallDataRecord[guidTmp].Guid);
              }
            }
          });
        }
        allEntGuids.partitionWallGuids = partitionWallGuids;
        // 找房间内的隔墙
        allPartitionWalls.forEach((item) => {
          if (
            item &&
            !allEntGuids.partitionWallGuids.find((guid) => guid == item.Guid)
          ) {
            if (
              isPointInPolygon(item.startPoint, points, 0.1) &&
              isPointInPolygon(item.endPoint, points, 0.1)
            ) {
              allEntGuids.partitionWallGuids.push(item.Guid);
            }
          }
        });
        // 找在区域内的墙梁板柱
        // 柱
        allColumns.forEach((item) => {
          if (item) {
            const pt = new McGePoint3d(
              item.m_JointData.m_pt[0],
              item.m_JointData.m_pt[1],
              0
            );
            if (isPointInPolygon(pt, points, 0.1)) {
              allEntGuids.columnGuids.push(item.Guid);
            }
          }
        });
        // 梁
        allBeams.forEach((item) => {
          if (item) {
            const ptStart = new McGePoint3d(
              item.m_gridData.m_stJoint.m_pt[0],
              item.m_gridData.m_stJoint.m_pt[1],
              0
            );
            const ptEnd = new McGePoint3d(
              item.m_gridData.m_edJoint.m_pt[0],
              item.m_gridData.m_edJoint.m_pt[1],
              0
            );
            if (
              isPointInPolygon(ptStart, points, 0.1) &&
              isPointInPolygon(ptEnd, points, 0.1)
            ) {
              allEntGuids.beamGuids.push(item.Guid);
            }
          }
        });
        // 墙
        allWalls.forEach((item) => {
          if (item) {
            const ptStart = new McGePoint3d(
              item.m_gridData.m_stJoint.m_pt[0],
              item.m_gridData.m_stJoint.m_pt[1],
              0
            );
            const ptEnd = new McGePoint3d(
              item.m_gridData.m_edJoint.m_pt[0],
              item.m_gridData.m_edJoint.m_pt[1],
              0
            );
            if (
              isPointInPolygon(ptStart, points, 0.1) &&
              isPointInPolygon(ptEnd, points, 0.1)
            ) {
              // 如果墙的guid不在allEntGuids.wallGuids中,则添加
              if (!allEntGuids.wallGuids.find((guid) => guid == item.Guid)) {
                allEntGuids.wallGuids.push(item.Guid);
              }
            }
          }
        });
        // 板
        allSlabs.forEach((item) => {
          if (item) {
            const slabpPoints = [];
            for (let i = 0; i < item.points.length; i += 3) {
              slabpPoints.push(
                new McGePoint3d(item.points[i], item.points[i + 1], 0)
              );
            }
            for (let i = 0; i < slabpPoints.length; i++) {
              if (isPointInPolygon(slabpPoints[i], points, 0.1)) {
                allEntGuids.slabGuids.push(item.Guid);
                break;
              }
            }
          }
        });
        // 校验房间命名是否重复
        while (check_RoomName_Repeat(RoomName + iMaxIndex)) {
          iMaxIndex++;
        }
        let name = RoomName + iMaxIndex;
        // 鉴定时,房间命名不加编号
        if (!isInvestigate) {
          name = RoomName;
        }
        const key = NewSlabTotalPoint.join(",");
        // 如果存在一样的用途,则跳过
        if (mapOldUse.has(key)) {
          const oldUse = mapOldUse.get(key);
          oldUse.saveEditRevokeData();
          oldUse.useFunction = name;
          oldUse.useFunctionName = name;
          oldUse.allEntGuids = allEntGuids;
          oldUse.updateEntRoomName();
          oldUse.updateThisObj(oldUse);
          mapOldUse.delete(key);
          iMaxIndex--;
          continue;
        }
        // 创建用途
        const rlUseObject = new rlUseData();
        rlUseObject.initData({
          useFunction: name,
          useFunctionName: name,
          points: points,
          m_slabId: "",
          m_SlabData: null,
          m_useType: RoomType,
          allEntGuids: allEntGuids,
        });
        rlUseObject.draw();
        await addEntityToDrawing(rlUseObject, false);
      }
      // 删除掉mapOldUse中不存在的用途
      // const allNewUse = store.state.rlEntData.totalEntityData["rlUse"];
      // mapOldUse.forEach((value, key) => {
      //   if (value) {
      //     if (!value.m_SlabData) {
      //       for (let i = 0; i < allNewUse.length; i++) {
      //         if (allNewUse[i].Guid == value.Guid) continue;
      //         if (value.points.length == 0) continue;
      //         if (isPolygonsIntersect(value.points, allNewUse[i].points)) {
      //           value.erase();
      //           break;
      //         }
      //       }
      //     }
      //   }
      // });
      // 更新显示
      rlAppObj.rlMxDrawObject.updateDisplay();
      // 将操作步骤下的所有数据更新到数据库中
      await saveDatabaseStore();
      resolve();
    } catch (error) {
      console.error("Error during set_slab operation:", error);
    } finally {
      // 隐藏 loading
      tryHideFullScreenLoading();
    }
  });
};
/**
 *
 * @param {房间号名称} useFunctionType
 * @param {是否房间号关联排查} isIncrease
 * @returns
 */

// 房间命名非闭合区域布置-旧
export const nonClosedAreaLayout_Old = async (useFunctionType, isIncrease) => {
  oneMessage.info("请点击选择房间命名的位置");
  if (isIncrease) {
    if (check_RoomName_Repeat(useFunctionType.label)) {
      oneMessage.info(useFunctionType.label + "房间号已存在!");
      return;
    }
  }
  return new Promise(async (resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });

    getPoint.go(async (status1) => {
      if (status1 == 0) {
        // 获取所有实体
        const allUse = store.state.rlEntData.totalEntityData["rlUse"];
        const allPartitionWalls =
          store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
        const allBeams = store.state.rlEntData.totalEntityData["rlBeamSeg"];
        const allColumns = store.state.rlEntData.totalEntityData["rlColSeg"];
        const allWalls = store.state.rlEntData.totalEntityData["rlWallSeg"];
        const allSlabs = store.state.rlEntData.totalEntityData["rlSlab"];
        const pt = new McGePoint3d(getPoint.value().x, getPoint.value().y, 0);

        // 判断是否点击在已存在的房间上
        let isExist = false;
        allUse.forEach((item) => {
          if (isPointInPolygon(pt, item.points, 0.1)) {
            isExist = true;
          }
        });
        if (isExist) {
          oneMessage.info("请点击在未命名的区域");
          await nonClosedAreaLayout(useFunctionType);
          return;
        }
        // 获取最大房间编号
        let iMaxIndex = getMaxRoomNo(useFunctionType.label);
        // 获取最大房间编号
        iMaxIndex++;

        // 从点发出射线检测墙和隔墙
        const raycastWalls = (center, allWalls, allPartitionWalls) => {
          console.log("center", center);
          // center.x = 4090.7886410329193;
          // center.y = 15593.537591761007;

          // center.x = 3520.896871048244;
          // center.y = 4321.412891947719;

          // center.x = 2026.6834859581923;
          // center.y = 8485.062705043965;

          const hitWalls = []; // 使用Set避免重复
          const rayLength = 15000; // 射线长度
          const angleStep = 3; // 每5度发射一条射线
          // 转换Set为数组并返回实体对象
          const result = {
            walls: [],
            partitionWalls: [],
          };
          // 遍历360度
          for (let angle = 0; angle < 360; angle += angleStep) {
            // 计算射线终点
            const radians = (angle * Math.PI) / 180;
            const rayEndX = center.x + rayLength * Math.cos(radians);
            const rayEndY = center.y + rayLength * Math.sin(radians);
            const rayEnd = new McGePoint3d(rayEndX, rayEndY, 0);

            // 检测射线与墙的交点
            let closestHit = null;
            let closestDistance = Infinity;

            // 检测墙
            for (const wall of allWalls) {
              if (
                !wall.m_gridData ||
                !wall.m_gridData.m_stJoint ||
                !wall.m_gridData.m_edJoint
              ) {
                continue;
              }
              let intersection = null;
              if (wall.m_gridData.m_centerJoint) {
                const pt1 = new McGePoint3d(...wall.m_gridData.m_stJoint.m_pt);
                const pt2 = new McGePoint3d(...wall.m_gridData.m_edJoint.m_pt);
                const center1 = new McGePoint3d(
                  ...wall.m_gridData.m_centerJoint.m_pt
                );
                const redius1 = pt1.distanceTo(center1);
                const startAngle1 = toDegrees(calculateArcAngle(center1, pt1));
                const endAngle1 = toDegrees(calculateArcAngle(center1, pt2));
                intersection = lineArcIntersection(
                  center,
                  rayEnd,
                  center1,
                  redius1,
                  startAngle1,
                  endAngle1
                );
              } else {
                const wallStart = new McGePoint3d(
                  wall.m_gridData.m_stJoint.m_pt[0],
                  wall.m_gridData.m_stJoint.m_pt[1],
                  0
                );
                const wallEnd = new McGePoint3d(
                  wall.m_gridData.m_edJoint.m_pt[0],
                  wall.m_gridData.m_edJoint.m_pt[1],
                  0
                );

                intersection = lineInsection(
                  center,
                  rayEnd,
                  wallStart,
                  wallEnd,
                  false
                );
              }

              if (intersection.isIntersected) {
                let distance = 99999999;

                if (intersection.intersectionPoints) {
                  let tempDist = 999999999;
                  for (
                    let i = 0;
                    i < intersection.intersectionPoints.length;
                    i++
                  ) {
                    tempDist = center.distanceTo(
                      intersection.intersectionPoints[i]
                    );
                    if (tempDist < distance) {
                      distance = tempDist;
                    }
                  }
                } else {
                  let ptIntersection = new McGePoint3d(
                    intersection.intersectionPoint.x,
                    intersection.intersectionPoint.y,
                    0
                  );

                  // distance = Math.round(center.distanceTo(ptIntersection));
                  distance = center.distanceTo(ptIntersection);
                }
                if (distance < closestDistance) {
                  // if (wall.Guid == "e51569f7-8b33-430a-bb9e-64613c23c386") {
                  //   let line = new McDbLine();
                  //   line.startPoint = center;
                  //   line.endPoint = rayEnd;
                  //   rlAppObj.mxcadObject.drawEntity(line);
                  //   console.log("distance", distance);
                  //   console.log("closestDistance", closestDistance);
                  //   console.log("closestHit", closestHit);
                  //   console.log("angle", angle);
                  // }
                  closestDistance = distance;
                  closestHit = {
                    entity: wall,
                    type: "wall",
                    point: intersection.intersectionPoint,
                    distance: distance,
                    num: 1,
                  };
                }
              }
            }

            // 检测隔墙
            for (const partitionWall of allPartitionWalls) {
              if (!partitionWall.startPoint || !partitionWall.endPoint) {
                continue;
              }
              let intersection = null;
              if (
                partitionWall.m_gridData &&
                partitionWall.m_gridData.m_centerJoint
              ) {
                const pt1 = new McGePoint3d(
                  ...partitionWall.m_gridData.m_stJoint.m_pt
                );
                const pt2 = new McGePoint3d(
                  ...partitionWall.m_gridData.m_edJoint.m_pt
                );
                const center1 = new McGePoint3d(
                  ...partitionWall.m_gridData.m_centerJoint.m_pt
                );
                const redius1 = pt1.distanceTo(center1);
                const startAngle1 = toDegrees(calculateArcAngle(center1, pt1));
                const endAngle1 = toDegrees(calculateArcAngle(center1, pt2));
                intersection = lineArcIntersection(
                  center,
                  rayEnd,
                  center1,
                  redius1,
                  startAngle1,
                  endAngle1
                );
              } else {
                const partitionStart = partitionWall.startPoint;
                const partitionEnd = partitionWall.endPoint;
                intersection = lineInsection(
                  center,
                  rayEnd,
                  partitionStart,
                  partitionEnd,
                  false
                );
              }

              if (intersection.isIntersected) {
                let distance = 99999999;
                if (intersection.intersectionPoints) {
                  let tempDist = 999999999;
                  for (
                    let i = 0;
                    i < intersection.intersectionPoints.length;
                    i++
                  ) {
                    tempDist = center.distanceTo(
                      intersection.intersectionPoints[i]
                    );
                    if (tempDist < distance) {
                      distance = tempDist;
                    }
                  }
                } else {
                  let ptIntersection = new McGePoint3d(
                    intersection.intersectionPoint.x,
                    intersection.intersectionPoint.y,
                    0
                  );
                  // distance = Math.round(center.distanceTo(ptIntersection));
                  distance = center.distanceTo(ptIntersection);
                }

                if (distance < closestDistance) {
                  closestDistance = distance;
                  closestHit = {
                    entity: partitionWall,
                    type: "partitionWall",
                    point: intersection.intersectionPoint,
                    distance: distance,
                    num: 1,
                  };
                }
              }
            }

            // 如果找到交点，添加到结果集
            if (closestHit) {
              const existing = hitWalls.find(
                (item) => item.guid === closestHit.entity.Guid
              );
              if (existing) {
                existing.num++;
              } else {
                hitWalls.push({ guid: closestHit.entity.Guid, num: 1 });
              }
            }
          }

          // 获取墙实体
          for (const wall of allWalls) {
            const existing = hitWalls.find((item) => item.guid === wall.Guid);
            if (existing && existing.num >= 2) {
              result.walls.push(wall);
            }
          }

          // 获取隔墙实体
          for (const partitionWall of allPartitionWalls) {
            const existing = hitWalls.find(
              (item) => item.guid === partitionWall.Guid
            );
            if (existing && existing.num >= 2) {
              result.partitionWalls.push(partitionWall);
            }
          }

          return result;
        };

        // 执行射线检测
        const hitEntities = raycastWalls(pt, allWalls, allPartitionWalls);
        // console.log("检测到的墙:", hitEntities.walls.length);
        // console.log("检测到的隔墙:", hitEntities.partitionWalls.length);

        // 使用检测到的墙和隔墙创建房间
        if (
          hitEntities.walls.length > 0 ||
          hitEntities.partitionWalls.length > 0
        ) {
          const wallEnts = [];
          const partitionWallEnts = [];
          const allBeforeEnts = [];
          hitEntities.partitionWalls.forEach((itemP) => {
            allBeforeEnts.push({
              Guid: itemP.Guid,
              startPoint: itemP.startPoint,
              endPoint: itemP.endPoint,
            });
          });
          hitEntities.walls.forEach((item) => {
            allBeforeEnts.push({
              Guid: item.Guid,
              startPoint: new McGePoint3d(
                item.m_gridData.m_stJoint.m_pt[0],
                item.m_gridData.m_stJoint.m_pt[1],
                0
              ),
              endPoint: new McGePoint3d(
                item.m_gridData.m_edJoint.m_pt[0],
                item.m_gridData.m_edJoint.m_pt[1],
                0
              ),
            });
          });
          // 遍历墙,找出被隔墙打断的墙区域
          hitEntities.walls.forEach((itemW) => {
            const ptStartW = new McGePoint3d(
              itemW.m_gridData.m_stJoint.m_pt[0],
              itemW.m_gridData.m_stJoint.m_pt[1],
              0
            );
            const ptEndW = new McGePoint3d(
              itemW.m_gridData.m_edJoint.m_pt[0],
              itemW.m_gridData.m_edJoint.m_pt[1],
              0
            );
            // 记录隔墙与墙的交点
            const ptIntersections = [];
            ptIntersections.push(ptStartW);
            ptIntersections.push(ptEndW);
            hitEntities.partitionWalls.forEach((itemP) => {
              if (itemP.startPoint && itemP.endPoint) {
                const ptStartP = itemP.startPoint;
                const ptEndP = itemP.endPoint;
                const res = lineInsection(
                  ptStartW,
                  ptEndW,
                  ptStartP,
                  ptEndP,
                  false
                );
                if (res.isIntersected) {
                  if (
                    !isPointEqual(res.intersectionPoint, ptStartW) &&
                    !isPointEqual(res.intersectionPoint, ptEndW)
                  ) {
                    ptIntersections.push(res.intersectionPoint);
                  }
                }
              }
            });
            // 如果交点大于2个,则需要把交点之间的线段连起来
            if (ptIntersections.length > 2) {
              // 获取交点之间的线段
              const lines = groupPoints(ptIntersections);

              // 关键修复：按照墙的方向对线段进行排序
              // 计算每个线段起点到墙起点的距离，按距离排序
              lines.sort((a, b) => {
                const distA = Math.sqrt(
                  Math.pow(a.startPt.x - ptStartW.x, 2) +
                    Math.pow(a.startPt.y - ptStartW.y, 2)
                );
                const distB = Math.sqrt(
                  Math.pow(b.startPt.x - ptStartW.x, 2) +
                    Math.pow(b.startPt.y - ptStartW.y, 2)
                );
                return distA - distB;
              });

              lines.forEach((item) => {
                let isStart = false;
                let isEnd = false;
                for (let i = 0; i < allBeforeEnts.length; i++) {
                  if (itemW.Guid == allBeforeEnts[i].Guid) continue;
                  if (!isStart) {
                    if (
                      isPointEqual(item.startPt, allBeforeEnts[i].startPoint) ||
                      isPointEqual(item.startPt, allBeforeEnts[i].endPoint)
                    ) {
                      isStart = true;
                    }
                  }
                  if (!isEnd) {
                    if (
                      isPointEqual(item.endPt, allBeforeEnts[i].startPoint) ||
                      isPointEqual(item.endPt, allBeforeEnts[i].endPoint)
                    ) {
                      isEnd = true;
                    }
                  }
                  if (isStart && isEnd) {
                    break;
                  }
                }

                if (isStart && isEnd) {
                  wallEnts.push({
                    type: "wall",
                    Guid: itemW.Guid,
                    entity: itemW,
                    startPoint: item.startPt,
                    endPoint: item.endPt,
                  });
                }
              });
            } else {
              wallEnts.push({
                type: "wall",
                Guid: itemW.Guid,
                entity: itemW,
                startPoint: ptStartW,
                endPoint: ptEndW,
              });
            }
          });
          hitEntities.partitionWalls.forEach((itemP) => {
            partitionWallEnts.push({
              type: "partitionWall",
              Guid: itemP.Guid,
              entity: itemP,
              startPoint: itemP.startPoint,
              endPoint: itemP.endPoint,
            });
          });
          const allEnts = [...wallEnts, ...partitionWallEnts];

          // 把隔墙和墙连起来
          let GroupEnts = [];
          // 用于标记已处理的线段
          const processedSegments = new Set();

          // 存储所有找到的线段组
          const allSegmentGroups = [];

          // 寻找所有可能的线段组
          for (let i = 0; i < allEnts.length; i++) {
            if (processedSegments.has(i)) continue;

            // 关键修复：找到最左下角的点作为起点
            // 收集所有未处理的线段
            const remainingSegments = [];
            for (let j = 0; j < allEnts.length; j++) {
              if (!processedSegments.has(j)) {
                remainingSegments.push({ index: j, segment: allEnts[j] });
              }
            }

            // 找到最左下角的点（x最小，如果x相同则y最小）
            let minPoint = null;
            let startSegmentIndex = i;
            let startFromEnd = false; // 标记是从线段的起点还是终点开始

            for (const item of remainingSegments) {
              const seg = item.segment;
              // 检查起点
              if (
                !minPoint ||
                seg.startPoint.x < minPoint.x ||
                (Math.abs(seg.startPoint.x - minPoint.x) < 0.1 &&
                  seg.startPoint.y < minPoint.y)
              ) {
                minPoint = seg.startPoint;
                startSegmentIndex = item.index;
                startFromEnd = false;
              }
              // 检查终点
              if (
                !minPoint ||
                seg.endPoint.x < minPoint.x ||
                (Math.abs(seg.endPoint.x - minPoint.x) < 0.1 &&
                  seg.endPoint.y < minPoint.y)
              ) {
                minPoint = seg.endPoint;
                startSegmentIndex = item.index;
                startFromEnd = true;
              }
            }

            const currentSegmentIndex = startSegmentIndex;
            const currentSegment = allEnts[currentSegmentIndex];
            processedSegments.add(currentSegmentIndex);

            // 开始一个新的线段组
            const segmentGroup = {
              points: [], // 存储所有点
              wallGuids: [], // 存储墙的GUID
              partitionWallGuids: [], // 存储隔墙的GUID
            };

            // 添加当前线段的GUID
            if (currentSegment.type === "wall") {
              segmentGroup.wallGuids.push(currentSegment.Guid);
            } else if (currentSegment.type === "partitionWall") {
              segmentGroup.partitionWallGuids.push(currentSegment.Guid);
            }

            // 获取第一个线段的起点和终点
            let entity = currentSegment.entity;
            let isArc = entity.m_gridData && entity.m_gridData.m_centerJoint;
            let firstSegmentPoints = [];
            let startPoint, endPoint;

            if (isArc) {
              const stPoint = new McGePoint3d(
                ...entity.m_gridData.m_stJoint.m_pt
              );
              const edPoint = new McGePoint3d(
                ...entity.m_gridData.m_edJoint.m_pt
              );
              const centerPoint = new McGePoint3d(
                entity.m_gridData.centerPoint[0],
                entity.m_gridData.centerPoint[1],
                0
              );
              const dRadius = entity.m_gridData.mcDbGrid.radius;
              firstSegmentPoints = getArcPoints(
                stPoint,
                edPoint,
                centerPoint,
                dRadius
              );
              // 如果需要从终点开始，反转圆弧点
              if (startFromEnd) {
                firstSegmentPoints.reverse();
              }
              startPoint = firstSegmentPoints[0];
              endPoint = firstSegmentPoints[firstSegmentPoints.length - 1];
            } else {
              // 如果需要从终点开始，交换起点和终点
              if (startFromEnd) {
                startPoint = currentSegment.endPoint;
                endPoint = currentSegment.startPoint;
              } else {
                startPoint = currentSegment.startPoint;
                endPoint = currentSegment.endPoint;
              }
              firstSegmentPoints = [startPoint, endPoint];
            }
            // 辅助函数：从指定点开始单向搜索连接的线段
            const searchFromPoint = (fromPoint, excludeIndices) => {
              const chain = [];
              const chainGuids = { walls: [], partitionWalls: [] };
              const usedIndices = new Set(excludeIndices);
              let currentPoint = fromPoint;

              while (true) {
                let found = false;

                for (let j = 0; j < allEnts.length; j++) {
                  if (usedIndices.has(j)) continue;

                  const nextSegment = allEnts[j];
                  const entity2 = nextSegment.entity;
                  const isArc2 =
                    entity2.m_gridData && entity2.m_gridData.m_centerJoint;

                  let connectedPoints = [];
                  let nextPoint = null;

                  if (isArc2) {
                    const stPoint = new McGePoint3d(
                      ...entity2.m_gridData.m_stJoint.m_pt
                    );
                    const edPoint = new McGePoint3d(
                      ...entity2.m_gridData.m_edJoint.m_pt
                    );
                    const centerPoint = new McGePoint3d(
                      entity2.m_gridData.centerPoint[0],
                      entity2.m_gridData.centerPoint[1],
                      0
                    );
                    const dRadius = entity2.m_gridData.mcDbGrid.radius;
                    const arcPoints = getArcPoints(
                      stPoint,
                      edPoint,
                      centerPoint,
                      dRadius
                    );

                    if (isPointEqual(currentPoint, arcPoints[0], 0.1)) {
                      // 从起点连接，顺序添加（去掉第一个重复点）
                      connectedPoints = arcPoints.slice(1);
                      nextPoint = arcPoints[arcPoints.length - 1];
                    } else if (
                      isPointEqual(
                        currentPoint,
                        arcPoints[arcPoints.length - 1],
                        0.1
                      )
                    ) {
                      // 从终点连接，逆序添加（去掉最后一个重复点）
                      connectedPoints = arcPoints.slice(0, -1).reverse();
                      nextPoint = arcPoints[0];
                    }
                  } else {
                    if (
                      isPointEqual(currentPoint, nextSegment.startPoint, 0.1)
                    ) {
                      connectedPoints = [nextSegment.endPoint];
                      nextPoint = nextSegment.endPoint;
                    } else if (
                      isPointEqual(currentPoint, nextSegment.endPoint, 0.1)
                    ) {
                      connectedPoints = [nextSegment.startPoint];
                      nextPoint = nextSegment.startPoint;
                    }
                  }

                  if (connectedPoints.length > 0) {
                    // 找到连接
                    chain.push(...connectedPoints);
                    if (nextSegment.type === "wall") {
                      chainGuids.walls.push(nextSegment.Guid);
                    } else if (nextSegment.type === "partitionWall") {
                      chainGuids.partitionWalls.push(nextSegment.Guid);
                    }
                    usedIndices.add(j);
                    processedSegments.add(j);
                    currentPoint = nextPoint;
                    found = true;
                    break;
                  }
                }

                if (!found) break;
              }

              return { chain, chainGuids, usedIndices };
            };

            // 从终点向前搜索
            const forwardResult = searchFromPoint(endPoint, [
              currentSegmentIndex,
            ]);

            // 从起点向后搜索
            const backwardResult = searchFromPoint(startPoint, [
              currentSegmentIndex,
              ...Array.from(forwardResult.usedIndices),
            ]);

            // 组合结果：反向链 + 第一个线段 + 正向链
            segmentGroup.points = [
              ...backwardResult.chain.reverse(),
              ...firstSegmentPoints,
              ...forwardResult.chain,
            ];

            // 合并GUID
            segmentGroup.wallGuids.push(
              ...backwardResult.chainGuids.walls,
              ...forwardResult.chainGuids.walls
            );
            segmentGroup.partitionWallGuids.push(
              ...backwardResult.chainGuids.partitionWalls,
              ...forwardResult.chainGuids.partitionWalls
            );

            // 检查是否形成闭合轮廓，如果闭合则去掉最后一个重复点
            if (segmentGroup.points.length > 1) {
              const firstPt = segmentGroup.points[0];
              const lastPt =
                segmentGroup.points[segmentGroup.points.length - 1];
              if (isPointEqual(firstPt, lastPt, 0.1)) {
                segmentGroup.points.pop();
              }
            }

            // 保存找到的线段组
            if (
              segmentGroup.wallGuids.length > 0 ||
              segmentGroup.partitionWallGuids.length > 0
            ) {
              allSegmentGroups.push(segmentGroup);
            }
          }

          // console.log("找到线段组数量:", allSegmentGroups.length);

          // 将所有线段组添加到GroupEnts
          GroupEnts = allSegmentGroups;

          if (GroupEnts.length == 0) {
            resolve();
            return;
          }
          const newRoomGuids = [];
          for (let i = 0; i < GroupEnts.length; i++) {
            let points = GroupEnts[i].points;

            // 布置房间
            // 判断点是否在多边形内部
            if (!isPointInPolygon(pt, points, 0.1)) {
              continue;
            }
            const allEntGuids = {
              partitionWallGuids: [],
              wallGuids: [],
              slabGuids: [],
              beamGuids: [],
              columnGuids: [],
            };
            allEntGuids.partitionWallGuids.push(
              ...GroupEnts[i].partitionWallGuids
            );
            allEntGuids.wallGuids.push(...GroupEnts[i].wallGuids);
            // 找房间内的隔墙
            allPartitionWalls.forEach((item) => {
              if (
                item &&
                !allEntGuids.partitionWallGuids.find(
                  (guid) => guid == item.Guid
                )
              ) {
                if (
                  isPointInPolygon(item.startPoint, points, 0.1) &&
                  isPointInPolygon(item.endPoint, points, 0.1)
                ) {
                  allEntGuids.partitionWallGuids.push(item.Guid);
                }
              }
            });
            // 找在区域内的墙梁板柱
            // 柱
            allColumns.forEach((item) => {
              if (item) {
                const pt = new McGePoint3d(
                  item.m_JointData.m_pt[0],
                  item.m_JointData.m_pt[1],
                  0
                );
                if (isPointInPolygon(pt, points, 0.1)) {
                  allEntGuids.columnGuids.push(item.Guid);
                }
              }
            });
            // 梁
            allBeams.forEach((item) => {
              if (item) {
                const ptStart = new McGePoint3d(
                  item.m_gridData.m_stJoint.m_pt[0],
                  item.m_gridData.m_stJoint.m_pt[1],
                  0
                );
                const ptEnd = new McGePoint3d(
                  item.m_gridData.m_edJoint.m_pt[0],
                  item.m_gridData.m_edJoint.m_pt[1],
                  0
                );
                if (
                  isPointInPolygon(ptStart, points, 0.1) &&
                  isPointInPolygon(ptEnd, points, 0.1)
                ) {
                  allEntGuids.beamGuids.push(item.Guid);
                }
              }
            });
            // 墙
            allWalls.forEach((item) => {
              if (item) {
                const ptStart = new McGePoint3d(
                  item.m_gridData.m_stJoint.m_pt[0],
                  item.m_gridData.m_stJoint.m_pt[1],
                  0
                );
                const ptEnd = new McGePoint3d(
                  item.m_gridData.m_edJoint.m_pt[0],
                  item.m_gridData.m_edJoint.m_pt[1],
                  0
                );
                if (
                  isPointInPolygon(ptStart, points, 0.1) &&
                  isPointInPolygon(ptEnd, points, 0.1)
                ) {
                  // 如果墙的guid不在allEntGuids.wallGuids中,则添加
                  if (
                    !allEntGuids.wallGuids.find((guid) => guid == item.Guid)
                  ) {
                    allEntGuids.wallGuids.push(item.Guid);
                  }
                }
              }
            });
            // 板
            allSlabs.forEach((item) => {
              if (item) {
                const slabpPoints = [];
                for (let i = 0; i < item.points.length; i += 3) {
                  slabpPoints.push(
                    new McGePoint3d(item.points[i], item.points[i + 1], 0)
                  );
                }
                for (let i = 0; i < slabpPoints.length; i++) {
                  if (isPointInPolygon(slabpPoints[i], points, 0.1)) {
                    allEntGuids.slabGuids.push(item.Guid);
                    break;
                  }
                }
              }
            });
            // 校验房间命名是否重复
            let roomName = useFunctionType.label + iMaxIndex;
            if (isIncrease) {
              roomName = useFunctionType.label;
              if (check_RoomName_Repeat(roomName)) {
                resolve();
                return;
              }
            } else {
              while (check_RoomName_Repeat(roomName)) {
                iMaxIndex++;
                roomName = useFunctionType.label + iMaxIndex;
              }
            }
            // 创建用途
            const rlUseObject = new rlUseData();
            rlUseObject.initData({
              useFunction: roomName,
              useFunctionName: roomName,
              points: points,
              m_slabId: "",
              m_SlabData: null,
              m_useType: "RoomName",
              allEntGuids: allEntGuids,
            });
            rlUseObject.draw();
            await addEntityToDrawing(rlUseObject, false);
            newRoomGuids.push(rlUseObject.Guid);
          }
          // 更新显示
          rlAppObj.rlMxDrawObject.updateDisplay();
          // 将操作步骤下的所有数据更新到数据库中
          await saveDatabaseStore();
          if (isIncrease) {
            resolve(newRoomGuids);
            return;
          }
        }
        // 回调
        if (!isIncrease) {
          await nonClosedAreaLayout(useFunctionType, isIncrease);
        }
        // resolve();
      }
      // 回调
      resolve();
    });
  });
};

// 房间命名非闭合区域布置
export const nonClosedAreaLayout = async (
  useFunctionType,
  isIncrease,
  isClose = true
) => {
  if (isIncrease) {
    if (check_RoomName_Repeat(useFunctionType.label)) {
      oneMessage.info(useFunctionType.label + "房间号已存在!");
      return;
    }
  }
  return new Promise(async (resolve, reject) => {
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });
    if (isClose) oneMessage.info("请点击选择房间命名的位置");
    else oneMessage.error("请布置在闭合空间内");
    getPoint.go(async (status1) => {
      if (status1 == 0) {
        // 获取所有实体
        const allUse = store.state.rlEntData.totalEntityData["rlUse"];
        const allPartitionWalls =
          store.state.rlEntData.totalEntityData["rlPartitionWallSeg"];
        const allBeams = store.state.rlEntData.totalEntityData["rlBeamSeg"];
        const allColumns = store.state.rlEntData.totalEntityData["rlColSeg"];
        const allWalls = store.state.rlEntData.totalEntityData["rlWallSeg"];
        const allSlabs = store.state.rlEntData.totalEntityData["rlSlab"];
        const pt = new McGePoint3d(getPoint.value().x, getPoint.value().y, 0);

        // 判断是否点击在已存在的房间上
        let isExist = false;
        allUse.forEach((item) => {
          if (isPointInPolygon(pt, item.points, 0.1)) {
            isExist = true;
          }
        });
        if (isExist) {
          oneMessage.info("请点击在未命名的区域");
          await nonClosedAreaLayout(useFunctionType);
          return;
        }
        // 获取最大房间编号
        let iMaxIndex = getMaxRoomNo(useFunctionType.label);
        // 获取最大房间编号
        iMaxIndex++;

        // 从点发出射线检测墙和隔墙
        const raycastWalls = (allWalls, allPartitionWalls) => {
          const rlLinePartitionWallGroup = [];
          // 获取隔墙数据
          allPartitionWalls.forEach((item) => {
            if (item.startPoint && item.endPoint) {
              rlLinePartitionWallGroup.push(item);
            }
          });
          allWalls.forEach((itemW) => {
            const ptStartW = new McGePoint3d(
              itemW.m_gridData.m_stJoint.m_pt[0],
              itemW.m_gridData.m_stJoint.m_pt[1],
              0
            );
            const ptEndW = new McGePoint3d(
              itemW.m_gridData.m_edJoint.m_pt[0],
              itemW.m_gridData.m_edJoint.m_pt[1],
              0
            );
            // 记录隔墙与墙的交点
            const ptIntersections = [];
            ptIntersections.push(ptStartW);
            ptIntersections.push(ptEndW);
            allPartitionWalls.forEach((itemP) => {
              if (itemP.startPoint && itemP.endPoint) {
                const ptStartP = itemP.startPoint;
                const ptEndP = itemP.endPoint;
                const res = lineInsection(
                  ptStartW,
                  ptEndW,
                  ptStartP,
                  ptEndP,
                  false
                );
                if (res.isIntersected) {
                  if (
                    !isPointEqual(res.intersectionPoint, ptStartW) &&
                    !isPointEqual(res.intersectionPoint, ptEndW)
                  ) {
                    ptIntersections.push(res.intersectionPoint);
                  }
                }
              }
            });
            if (ptIntersections.length > 2) {
              // 获取交点之间的线段
              const lines = groupPoints(ptIntersections);
              for (let i = 0; i < lines.length; i++) {
                rlLinePartitionWallGroup.push({
                  Guid: itemW.Guid,
                  startPoint: lines[i].startPt,
                  endPoint: lines[i].endPt,
                });
              }
            } else {
              rlLinePartitionWallGroup.push({
                Guid: itemW.Guid,
                startPoint: ptStartW,
                endPoint: ptEndW,
              });
            }
          });
          let allPoints = [];
          const partitionWallData = rlLinePartitionWallGroup.map((item) => {
            const isArc =
              (item.m_gridData && item.m_gridData.m_centerJoint) ||
              (item.m_gridData &&
                item.m_gridData.m_Axis &&
                item.m_gridData.m_Axis.IsMainAxis < 0);
            if (isArc) {
              const stPoint = new McGePoint3d(
                ...item.m_gridData.m_stJoint.m_pt
              );
              const edPoint = new McGePoint3d(
                ...item.m_gridData.m_edJoint.m_pt
              );
              const centerPoint = new McGePoint3d(
                item.m_gridData.centerPoint[0],
                item.m_gridData.centerPoint[1],
                0
              );
              const dRadius = item.m_gridData.mcDbGrid.radius;
              const points = getArcPoints(
                stPoint,
                edPoint,
                centerPoint,
                dRadius
              );
              const pointsStr = points
                .map((item) => `${item.x},${item.y},0`)
                .join(",");
              return `${item.Guid}:[${pointsStr}],`;
            } else {
              let pt1 = new McGePoint3d(
                item.startPoint.x,
                item.startPoint.y,
                0
              );
              let pt2 = new McGePoint3d(item.endPoint.x, item.endPoint.y, 0);
              let isPt1 = false;
              let isPt2 = false;
              for (let i = 0; i < allPoints.length; i++) {
                if (isPointEqual(allPoints[i], pt1, 0.1)) {
                  isPt1 = true;
                  continue;
                } else {
                  let dist = allPoints[i].distanceTo(pt1);
                  if (dist < 3) {
                    pt1.x = allPoints[i].x;
                    pt1.y = allPoints[i].y;
                    isPt1 = true;
                    continue;
                  }
                }
                if (isPointEqual(allPoints[i], pt2, 0.1)) {
                  isPt2 = true;
                  continue;
                } else {
                  let dist = allPoints[i].distanceTo(pt2);
                  if (dist < 3) {
                    pt2.x = allPoints[i].x;
                    pt2.y = allPoints[i].y;
                    isPt2 = true;
                    continue;
                  }
                }
              }
              if (!isPt1) allPoints.push(pt1);
              if (!isPt2) allPoints.push(pt2);
              return `${item.Guid}:[${[pt1.x, pt1.y, 0, pt2.x, pt2.y, 0]}],`;
            }
          });
          let data = "";
          partitionWallData.forEach((item) => (data += item));

          const createSlab = new CreateSlab();
          const res = createSlab.getSlabJsonData(data);
          let result = res;
          if (!res) {
            resolve();
            return result;
          }

          return result;
        };

        // 执行射线检测
        const res = raycastWalls(allWalls, allPartitionWalls);
        // console.log("检测到的墙:", hitEntities.walls.length);
        // console.log("检测到的隔墙:", hitEntities.partitionWalls.length);

        // 使用检测到的墙和隔墙创建房间
        const newRoomGuids = [];
        if (res) {
          isClose = false;
          const model = JSON.parse(res)?.Slab;
          const modelKeys = Object.keys(model);
          const modelData = Object.values(model).flat();
          for (let index = 0; index < modelData.length; index++) {
            const item = modelData[index];
            const New2dUpView = item["2DUpView"];
            if (!modelKeys[index]) continue;
            const points = [];
            if (New2dUpView) {
              for (let i = 0; i < New2dUpView.length; i += 3) {
                points.push(
                  new McGePoint3d(New2dUpView[i], New2dUpView[i + 1], 0)
                );
              }
            }
            if (!isPointInPolygon(pt, points, 0.1)) {
              continue;
            }
            isClose = true;
            const allEntGuids = {
              partitionWallGuids: [],
              wallGuids: [],
              slabGuids: [],
              beamGuids: [],
              columnGuids: [],
            };
            // 找房间内的隔墙
            allPartitionWalls.forEach((item) => {
              if (
                item &&
                !allEntGuids.partitionWallGuids.find(
                  (guid) => guid == item.Guid
                )
              ) {
                if (
                  isPointInPolygon(item.startPoint, points, 0.1) &&
                  isPointInPolygon(item.endPoint, points, 0.1)
                ) {
                  allEntGuids.partitionWallGuids.push(item.Guid);
                }
              }
            });
            // 找在区域内的墙梁板柱
            // 柱
            allColumns.forEach((item) => {
              if (item) {
                const pt = new McGePoint3d(
                  item.m_JointData.m_pt[0],
                  item.m_JointData.m_pt[1],
                  0
                );
                if (isPointInPolygon(pt, points, 0.1)) {
                  allEntGuids.columnGuids.push(item.Guid);
                }
              }
            });
            // 梁
            allBeams.forEach((item) => {
              if (item) {
                const ptStart = new McGePoint3d(
                  item.m_gridData.m_stJoint.m_pt[0],
                  item.m_gridData.m_stJoint.m_pt[1],
                  0
                );
                const ptEnd = new McGePoint3d(
                  item.m_gridData.m_edJoint.m_pt[0],
                  item.m_gridData.m_edJoint.m_pt[1],
                  0
                );
                if (
                  isPointInPolygon(ptStart, points, 0.1) &&
                  isPointInPolygon(ptEnd, points, 0.1)
                ) {
                  allEntGuids.beamGuids.push(item.Guid);
                }
              }
            });
            // 墙
            allWalls.forEach((item) => {
              if (item) {
                const ptStart = new McGePoint3d(
                  item.m_gridData.m_stJoint.m_pt[0],
                  item.m_gridData.m_stJoint.m_pt[1],
                  0
                );
                const ptEnd = new McGePoint3d(
                  item.m_gridData.m_edJoint.m_pt[0],
                  item.m_gridData.m_edJoint.m_pt[1],
                  0
                );
                if (
                  isPointInPolygon(ptStart, points, 0.1) &&
                  isPointInPolygon(ptEnd, points, 0.1)
                ) {
                  // 如果墙的guid不在allEntGuids.wallGuids中,则添加
                  if (
                    !allEntGuids.wallGuids.find((guid) => guid == item.Guid)
                  ) {
                    allEntGuids.wallGuids.push(item.Guid);
                  }
                }
              }
            });
            // 板
            allSlabs.forEach((item) => {
              if (item) {
                const slabpPoints = [];
                for (let i = 0; i < item.points.length; i += 3) {
                  slabpPoints.push(
                    new McGePoint3d(item.points[i], item.points[i + 1], 0)
                  );
                }
                for (let i = 0; i < slabpPoints.length; i++) {
                  if (isPointInPolygon(slabpPoints[i], points, 0.1)) {
                    allEntGuids.slabGuids.push(item.Guid);
                    break;
                  }
                }
              }
            });
            // 校验房间命名是否重复
            let roomName = useFunctionType.label + iMaxIndex;
            if (isIncrease) {
              roomName = useFunctionType.label;
              if (check_RoomName_Repeat(roomName)) {
                resolve();
                return;
              }
            } else {
              while (check_RoomName_Repeat(roomName)) {
                iMaxIndex++;
                roomName = useFunctionType.label + iMaxIndex;
              }
            }
            iMaxIndex++;
            // 创建用途
            const rlUseObject = new rlUseData();
            rlUseObject.initData({
              useFunction: roomName,
              useFunctionName: roomName,
              points: points,
              m_slabId: "",
              m_SlabData: null,
              m_useType: "RoomName",
              allEntGuids: allEntGuids,
            });
            rlUseObject.draw();
            await addEntityToDrawing(rlUseObject, false);
            newRoomGuids.push(rlUseObject.Guid);
            break;
          }
          // 更新显示
          rlAppObj.rlMxDrawObject.updateDisplay();
          // 将操作步骤下的所有数据更新到数据库中
          await saveDatabaseStore();
          if (isIncrease) {
            resolve(newRoomGuids);
            return;
          }
        }
        // 回调
        if (!isIncrease) {
          await nonClosedAreaLayout(useFunctionType, isIncrease, isClose);
        }
        // resolve();
      }
      // 回调
      resolve();
    });
  });
};

/**
 *
 * @param {房间号名称} useFunctionType
 * @param {是否房间号关联排查} isIncrease
 * @param {是否是第一次调用} first
 * @param {之前的房间数据} beforeData
 * @returns
 */
// 更新房间命名
export const update_Use_ents = async (
  useFunctionType,
  isIncrease,
  beforeData,
  first
) => {
  oneMessage.info("请选择需要更新的房间命名");
  return new Promise(async (resolve, reject) => {
    if (!useFunctionType) return;
    if (first && isIncrease && check_RoomName_Repeat(useFunctionType.label)) {
      oneMessage.info(useFunctionType.label + "已存在!");
      return;
    }
    // const getUseEnts = async (ids) => {
    //   if (!ids || !ids.length) return;
    //   // 仅保留rlUse
    //   const rlUseIds = [];
    //   ids.forEach((item) => {
    //     const mcObj = item.getMcDbEntity();
    //     if (mcObj) {
    //       const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
    //       const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型
    //       if (objClassName == "rlUse") {
    //         rlUseIds.push(objGuid);
    //       }
    //     }
    //   });
    //   if (rlUseIds.length != 1) return;
    //   const selectObj = getEntityData({
    //     Guid: rlUseIds[0],
    //     classTypeName: "rlUse",
    //   });
    //   if (selectObj) {
    //     const { data: data1 } = await modelingList({
    //       project_id: store.state.cadModules.rlProject_id,
    //       guid: selectObj.Guid,
    //       non_structural: 1,
    //     });
    //     const { data: data2 } = await modelingList({
    //       project_id: store.state.cadModules.rlProject_id,
    //       guid: selectObj.Guid,
    //       non_structural: 0,
    //     });
    //     const data = [...data1, ...data2];
    //     if (data && data.length > 0) {
    //       // 提示模版已有数据,是否继续,继续会合并数据
    //       // 如果有检测数据,则提示用户确认是否删除
    //       const type = await VXETable.modal.confirm(
    //         "模版已有数据,是否继续,继续会合并数据"
    //       );
    //       if (type == "confirm") {
    //         // 更新当前房间命名
    //         beforeData = await set_Use(selectObj, beforeData);
    //         window.updataRoomNameBeforeData = beforeData;
    //       }
    //     } else {
    //       // 更新当前房间命名
    //       beforeData = await set_Use(selectObj, beforeData);
    //       window.updataRoomNameBeforeData = beforeData;
    //     }
    //   }
    // };

    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });
    getPoint.go(async (status1) => {
      if (status1 == 0) {
        const pt = getPoint.value();
        const rlUseGroup = store.state.rlEntData.totalEntityData["rlUse"];
        const selectObj = rlUseGroup.find((item) =>
          isPointInPolygon(pt, item.points, 0.1)
        );
        if (selectObj) {
          let { data: data1 } = await modelingList({
            project_id: store.state.cadModules.rlProject_id,
            guid: selectObj.Guid,
            non_structural: 1,
          });
          let { data: data2 } = await modelingList({
            project_id: store.state.cadModules.rlProject_id,
            guid: selectObj.Guid,
            non_structural: 0,
          });
          let data = [...data1, ...data2];
          let TempBeforeData = null;
          let goon = true;
          if (data && data.length > 0) {
            //提示模版已有数据,是否继续,继续会合并数据
            // 如果有检测数据,则提示用户确认是否删除
            const type = await VXETable.modal.confirm(
              "模版已有数据,是否继续,继续会合并数据"
            );
            if (type == "confirm") {
              goon = false;
              //更新当前房间命名
              beforeData = await set_Use(selectObj, beforeData);
              window.updataRoomNameBeforeData = beforeData;
            }
          } else {
            //更新当前房间命名
            beforeData = await set_Use(selectObj, beforeData);
            window.updataRoomNameBeforeData = beforeData;
          }
          if (goon) {
            // 递归调用
            await update_Use_ents(
              useFunctionType,
              isIncrease,
              beforeData,
              false
            );
          }
          resolve(beforeData);
          return;
        } else {
          await update_Use_ents(useFunctionType, isIncrease, beforeData, false);
        }
      }
      resolve();
    });

    const set_Use = async (obj, beforeData) => {
      if (!obj) return;
      try {
        // 绘制步数
        // store.commit("globalData/setCanAddRawStep", true);
        // 获取所有实体
        let iMaxIndex = getMaxRoomNo(useFunctionType.label); // 获取最大房间编号
        iMaxIndex++;

        const updata_Ents_Name = async (
          EntGuids,
          classTypeName,
          NowName,
          Guid,
          ModelType
        ) => {
          if (!EntGuids || !EntGuids.length) return;
          for (let i = 0; i < EntGuids.length; i++) {
            const selectObj = getEntityData({
              Guid: EntGuids[i],
              classTypeName: classTypeName,
            });
            if (selectObj) {
              for (let j = 0; j < selectObj.useFunctionNames.length; j++) {
                if (selectObj.useFunctionNames[j].Guid === Guid) {
                  selectObj.useFunctionNames[j].roomName =
                    NowName + "-" + ModelType + selectObj.No_;
                }
              }
            }
          }
        };
        // 更新用途关联的实体
        const updataAffiliateUse = async (ents, roomName) => {
          ents.saveEditRevokeData();
          ents.useFunction = roomName;
          ents.useFunctionName = roomName;
          // 更新隔墙名称
          await updata_Ents_Name(
            ents.allEntGuids.partitionWallGuids,
            "rlPartitionWallSeg",
            ents.useFunctionName,
            ents.Guid,
            "隔墙"
          );
          // 更新墙名称
          await updata_Ents_Name(
            ents.allEntGuids.wallGuids,
            "rlWallSeg",
            ents.useFunctionName,
            ents.Guid,
            "墙"
          );
          // 更新板名称
          await updata_Ents_Name(
            ents.allEntGuids.slabGuids,
            "rlSlab",
            ents.useFunctionName,
            ents.Guid,
            "板"
          );
          // 更新梁名称
          await updata_Ents_Name(
            ents.allEntGuids.beamGuids,
            "rlBeamSeg",
            ents.useFunctionName,
            ents.Guid,
            "梁"
          );
          // 更新柱名称
          await updata_Ents_Name(
            ents.allEntGuids.columnGuids,
            "rlColSeg",
            ents.useFunctionName,
            ents.Guid,
            "柱"
          );
          await ents.updateThisObj(ents);
        };

        const item = obj;
        // 校验房间命名是否重复
        while (check_RoomName_Repeat(useFunctionType.label + iMaxIndex)) {
          iMaxIndex++;
        }

        let roomName = useFunctionType.label + iMaxIndex;
        if (isIncrease) {
          roomName = useFunctionType.label;
          if (beforeData.beforeUseEnt) {
            await updataAffiliateUse(
              beforeData.beforeUseEnt,
              beforeData.beforeName
            );
          }
          beforeData.beforeName = item.useFunctionName;
          beforeData.beforeUseEnt = item;
        }
        await updataAffiliateUse(item, roomName);
        // 更新显示
        rlAppObj.rlMxDrawObject.updateDisplay();
        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
        return beforeData;
      } catch (error) {
        console.error("Error during set_slab operation:", error);
      } finally {
        // 隐藏 loading
        tryHideFullScreenLoading();
      }
    };
    // await userSelect(getUseEnts);
  });
};

// 校验房间命名是否重复
export const check_RoomName_Repeat = (roomName) => {
  const rlUse = store.state.rlEntData.totalEntityData["rlUse"];
  const repeat = rlUse.filter((item) => item.useFunctionName == roomName);
  if (repeat.length > 0) {
    repeat.forEach((item) => {
      if (item.points.length == 0) {
        repeat.splice(repeat.indexOf(item), 1);
      }
    });
  }
  return repeat.length > 0;
};

//判断当前构件属于哪些房间
export const get_Ent_RoomName = (guids) => {
  if (
    store.state.cadModules.rlProject_detail.businessTypePermission !=
    "investigate"
  )
    return {
      roomNames: [],
      roomNameEnts: [],
    };
  if (!guids || guids.length == 0)
    return {
      roomNames: [],
      roomNameEnts: [],
    };
  const rlUse = store.state.rlEntData.totalEntityData["rlUse"];
  let roomNameHasGuids = [];
  for (let i = 0; i < rlUse.length; i++) {
    let tempGuids = {
      rlUse: rlUse[i],
      roomName: rlUse[i].useFunctionName,
      guids: [],
    };
    if (rlUse[i].allEntGuids.beamGuids.length > 0) {
      for (let j = 0; j < rlUse[i].allEntGuids.beamGuids.length; j++) {
        let beamEnt = getEntityData({
          Guid: rlUse[i].allEntGuids.beamGuids[j],
          classTypeName: "rlBeamSeg",
        });
        if (beamEnt) {
          tempGuids.guids.push(beamEnt.m_gridData.Guid);
          tempGuids.guids.push(beamEnt.m_gridData.m_stJoint.Guid);
          tempGuids.guids.push(beamEnt.m_gridData.m_edJoint.Guid);
        }
      }
    }
    if (rlUse[i].allEntGuids.slabGuids.length > 0) {
      for (let j = 0; j < rlUse[i].allEntGuids.slabGuids.length; j++) {
        let slabEnt = getEntityData({
          Guid: rlUse[i].allEntGuids.slabGuids[j],
          classTypeName: "rlSlab",
        });
        if (slabEnt) {
          for (let k = 0; k < slabEnt.gridsObjs.length; k++) {
            tempGuids.guids.push(slabEnt.gridsObjs[k].Guid);
            tempGuids.guids.push(slabEnt.gridsObjs[k].m_stJoint.Guid);
            tempGuids.guids.push(slabEnt.gridsObjs[k].m_edJoint.Guid);
          }
        }
      }
    }
    if (rlUse[i].allEntGuids.wallGuids.length > 0) {
      for (let j = 0; j < rlUse[i].allEntGuids.wallGuids.length; j++) {
        let wallEnt = getEntityData({
          Guid: rlUse[i].allEntGuids.wallGuids[j],
          classTypeName: "rlWallSeg",
        });
        if (wallEnt) {
          tempGuids.guids.push(wallEnt.m_gridData.Guid);
          tempGuids.guids.push(wallEnt.m_gridData.m_stJoint.Guid);
          tempGuids.guids.push(wallEnt.m_gridData.m_edJoint.Guid);
        }
      }
    }
    if (rlUse[i].allEntGuids.columnGuids.length > 0) {
      for (let j = 0; j < rlUse[i].allEntGuids.columnGuids.length; j++) {
        tempGuids.guids.push(rlUse[i].allEntGuids.columnGuids[j]);
      }
    }
    if (rlUse[i].allEntGuids.partitionWallGuids.length > 0) {
      for (let j = 0; j < rlUse[i].allEntGuids.partitionWallGuids.length; j++) {
        let partitionWallEnt = getEntityData({
          Guid: rlUse[i].allEntGuids.partitionWallGuids[j],
          classTypeName: "rlPartitionWallSeg",
        });
        if (partitionWallEnt && partitionWallEnt.m_gridData) {
          tempGuids.guids.push(partitionWallEnt.m_gridData.Guid);
          tempGuids.guids.push(partitionWallEnt.m_gridData.m_stJoint.Guid);
          tempGuids.guids.push(partitionWallEnt.m_gridData.m_edJoint.Guid);
        }
      }
    }
    roomNameHasGuids.push(tempGuids);
  }
  let roomNames = [];
  let roomNameEnts = [];
  for (let i = 0; i < roomNameHasGuids.length; i++) {
    let isSameLength = 0;
    for (let j = 0; j < guids.length; j++) {
      if (roomNameHasGuids[i].guids.includes(guids[j])) {
        isSameLength++;
      }
    }
    if (isSameLength == guids.length) {
      roomNames.push(roomNameHasGuids[i].roomName);
      roomNameEnts.push(roomNameHasGuids[i].rlUse);
    }
  }
  return {
    roomNames,
    roomNameEnts,
  };
};

// 创建板洞
// slabHoleType：是否是全洞,true全洞。false板洞
export const create_slabHole_ents = async (
  rl_stdFlr_id,
  moduleForm,
  slabHoleType
) => {
  if (!moduleForm) return;
  const { parameter, tableRow } = moduleForm;
  if (!slabHoleType) oneMessage.info("请点击屏幕拖动至板中选择布置位置");
  else oneMessage.info("请双击楼板布置全洞");

  // 保存模型对象的原始位置
  await new Promise((resolve) => {
    // 获取所有实体
    const rlSlabGroup = store.state.rlEntData.totalEntityData["rlSlab"];
    const getPoint = new rlAppObj._rlMx.MrxDbgUiPrPoint();
    getPoint.setInputToucheType(1);
    store.commit("cadModules/setSnapPoint", {
      snapPoint: null,
      needCatchSnap: false,
    });

    const mxcad = MxCpp.getCurrentMxCAD();
    mxcad.addDimStyle(
      "MeasureDimStyle", // 样式名称
      "41,1,141,1,40,200,140,1", // 所有双精度数据改为整数
      "77,0,271,0", // 77=0 表示只显示整数，172=4 文字在线段中间
      "", // 字符串型数据为空
      "343,1,344,1" // ID 数据，控制箭头样式
    );
    mxcad.drawDimStyle = "MeasureDimStyle";
    const mDimensionId1 = mxcad.drawDimAligned(0, 0, 0, 0, 0, 0);
    const mDimensionId2 = mxcad.drawDimAligned(0, 0, 0, 0, 0, 0);

    // 绘制步数
    store.commit("globalData/setCanAddRawStep", true);
    let pt1 = new McGePoint3d(0, 0, 0);
    // 设置第一个点位置
    const polyline = new McDbPolyline();
    let PolylineObj = null; // 用于绘制板洞时预览显示的轮廓
    let mDimensionObj1 = mDimensionId1.getMcDbEntity(); // 用于绘制板洞时预览显示的标注1
    let mDimensionObj2 = mDimensionId2.getMcDbEntity(); // 用于绘制板洞时预览显示的标注2
    let inputElement = getInputElement(); // 用于绘制板洞时预览显示的输入框
    // 绘制板洞预览图和标注
    if (!slabHoleType) {
      // 预览图
      polyline.addVertexAt(
        new McGePoint3d(
          pt1.x - tableRow.params.B / 2,
          pt1.y + tableRow.params.H / 2,
          pt1.z
        )
      );
      polyline.addVertexAt(
        new McGePoint3d(
          pt1.x + tableRow.params.B / 2,
          pt1.y + tableRow.params.H / 2,
          pt1.z
        )
      );
      polyline.addVertexAt(
        new McGePoint3d(
          pt1.x + tableRow.params.B / 2,
          pt1.y - tableRow.params.H / 2,
          pt1.z
        )
      );
      polyline.addVertexAt(
        new McGePoint3d(
          pt1.x - tableRow.params.B / 2,
          pt1.y - tableRow.params.H / 2,
          pt1.z
        )
      );
      polyline.addVertexAt(
        new McGePoint3d(
          pt1.x - tableRow.params.B / 2,
          pt1.y + tableRow.params.H / 2,
          pt1.z
        )
      );
      polyline.trueColor = new McCmColor(173, 153, 153);
      const polylineMcDb = rlAppObj.mxcadObject.drawEntity(polyline);
      PolylineObj = polylineMcDb.getMcDbEntity();
      PolylineObj.visible = false;
      // 设置颜色
      mDimensionObj1.trueColor = new McCmColor(255, 0, 0);
      // 添加输入框
      if (!inputElement) {
        inputElement = createInputElement(mDimensionObj1);
      } else {
        eraseOtherData();
        setCurrDataObj(mDimensionObj1);
      }
      setContainerShow(false);
      // setInputElementPosition(0, 0, 0); //把输入框隐藏在0,0点
    }
    getPoint.setInputToucheType(1);
    let PrevSlabGuid = null;
    getPoint.go(async (status1) => {
      let mouseInSlab; // 鼠标所在的楼板
      let NearNodePtObj; // 最近的节点
      const rlLayer = await getRlLayer();
      let slabHoleColor = rlLayer.filter(
        (rlGridItem) => rlGridItem.Type == "rlSlabHole"
      );
      if (slabHoleColor && slabHoleColor.length > 0) {
        slabHoleColor = slabHoleColor[0].Color;
      }
      let ptNow = null;
      getPoint.setUserDraw((currentPoint) => {
        if (!window.isDrawAllHole && !window.activeMain) {
          //清理预览图
          if (PolylineObj) PolylineObj.erase();
          if (mDimensionObj1) mDimensionObj1.erase();
          if (mDimensionObj2) mDimensionObj2.erase();
          setContainerShow(false);
          return;
        }
        // 取消绘制
        // if (status1 == -2) {
        //   if (PolylineObj) PolylineObj.erase();
        //   if (mDimensionObj1) mDimensionObj1.erase();
        //   if (mDimensionObj2) mDimensionObj2.erase();
        //   resolve();
        //   return;
        // }
        // 当前鼠标所在点
        ptNow = new McGePoint3d(currentPoint.x, currentPoint.y, currentPoint.z);
        mouseInSlab = null;
        NearNodePtObj = null;
        // 判断鼠标是否在楼板内
        const findId = isPointInModel(currentPoint, rlSlabGroup);
        if (findId) {
          mouseInSlab = getEntityById(findId);
        }

        // 板洞
        if (!slabHoleType) {
          // 鼠标点到最近的两根网格线的方向-方向指向网格
          let vecTemp1 = null;
          let vecTemp2 = null;
          if (mouseInSlab && !mouseInSlab.RoomIsHole) {
            // 找到最近的节点
            let gridLine1 = null; // 节点所在网格线1
            let gridLine2 = null; // 节点所在网格线2
            if (mouseInSlab.gridsObjs) {
              let dMinDist = 1000000; // 记录最近的距离
              for (let i = 0; i < mouseInSlab.gridsObjs.length; i++) {
                let nNext = i + 1;
                if (nNext >= mouseInSlab.gridsObjs.length) nNext = 0;
                let nPrev = i - 1;
                if (nPrev < 0) nPrev = mouseInSlab.gridsObjs.length - 1;
                const GridStPt = new McGePoint3d(
                  ...mouseInSlab.gridsObjs[i].m_stJoint.m_pt
                );
                const GridEdPt = new McGePoint3d(
                  ...mouseInSlab.gridsObjs[i].m_edJoint.m_pt
                );

                // 找到最近的节点并且找到节点所在的网格线
                if (GridStPt.distanceTo(ptNow) < dMinDist) {
                  dMinDist = GridStPt.distanceTo(ptNow);
                  NearNodePtObj = mouseInSlab.gridsObjs[i].m_stJoint;
                  gridLine1 = mouseInSlab.gridsObjs[i];
                } else if (GridEdPt.distanceTo(ptNow) < dMinDist) {
                  dMinDist = GridEdPt.distanceTo(ptNow);
                  NearNodePtObj = mouseInSlab.gridsObjs[i].m_edJoint;
                  gridLine1 = mouseInSlab.gridsObjs[i];
                } else continue;
                // 找到节点所在的另一条网格线
                for (
                  let index = 0;
                  index < mouseInSlab.gridsObjs.length;
                  index++
                ) {
                  if (index === i) continue;
                  if (
                    mouseInSlab.gridsObjs[index].m_stJoint.Guid ===
                      NearNodePtObj.Guid ||
                    mouseInSlab.gridsObjs[index].m_edJoint.Guid ===
                      NearNodePtObj.Guid
                  ) {
                    gridLine2 = mouseInSlab.gridsObjs[index];
                    break;
                  }
                }
              }
            }
            // 找到最近的节点
            if (NearNodePtObj) {
              // console.log("节点guid", NearNodePtObj.Guid)

              PolylineObj.visible = true;
              // inputElement.style.display = "block";
              setContainerShow(true);
              mDimensionObj1.visible = true; // 显示标注
              mDimensionObj2.visible = true; // 显示标注
              // 鼠标点节点两旁的网格线的最近点
              const ptclose1 = gridLine1.mcDbGrid.getClosestPointTo(ptNow);
              const ptclose2 = gridLine2.mcDbGrid.getClosestPointTo(ptNow);
              // 设置标注两个点
              let ptTemp1 = new McGePoint3d(ptNow.x, ptNow.y, ptNow.z);
              let ptTemp2 = new McGePoint3d(ptNow.x, ptNow.y, ptNow.z);
              vecTemp1 = new THREE.Vector3(
                ptclose1.val.x - ptNow.x,
                ptclose1.val.y - ptNow.y,
                0
              ).normalize();
              vecTemp2 = new THREE.Vector3(
                ptclose2.val.x - ptNow.x,
                ptclose2.val.y - ptNow.y,
                0
              ).normalize();
              // 计算两个向量的叉积
              const vecX = new THREE.Vector3(1, 0, 0);
              const crossProduct = new THREE.Vector3().crossVectors(
                vecTemp1,
                vecX
              );
              // 判断是否平行,减   截面的一半,标注只标网格线到板洞的距离,而非板洞中心的距离
              if (Math.abs(crossProduct.z) < Number.EPSILON) {
                ptTemp1 = MovePt(ptTemp1, vecTemp1, tableRow.params.B / 2);
                ptTemp2 = MovePt(ptTemp2, vecTemp2, tableRow.params.H / 2);
              } else {
                ptTemp1 = MovePt(ptTemp1, vecTemp1, tableRow.params.H / 2);
                ptTemp2 = MovePt(ptTemp2, vecTemp2, tableRow.params.B / 2);
              }
              // 设置标注两个点
              mDimensionObj1.xLine1Point = ptTemp1;
              mDimensionObj1.xLine2Point = ptclose1.val;
              let midX = (ptNow.x + ptclose1.val.x) / 2;
              let midY = (ptNow.y + ptclose1.val.y) / 2;
              // 设置标注文字的位置
              mDimensionObj1.dimLinePoint = new McGePoint3d(midX, midY, 0);
              midX = (ptNow.x + ptclose2.val.x) / 2;
              midY = (ptNow.y + ptclose2.val.y) / 2;
              // 设置标注两个点
              mDimensionObj2.xLine1Point = ptTemp2;
              mDimensionObj2.xLine2Point = ptclose2.val;
              // 设置标注文字的位置
              mDimensionObj2.dimLinePoint = new McGePoint3d(midX, midY, 0);
              // 当标注1不平行于X,则标注1,2互换
              if (Math.abs(crossProduct.z) > Number.EPSILON) {
                [mDimensionObj1, mDimensionObj2] = [
                  mDimensionObj2,
                  mDimensionObj1,
                ];
                [vecTemp1, vecTemp2] = [vecTemp2, vecTemp1];
              }
            }
          } else {
            PrevSlabGuid = "";
            PolylineObj.visible = false;
            // inputElement.style.display = "none";
            setContainerShow(false);
            mDimensionObj1.visible = false; // 显示标注
            mDimensionObj2.visible = false; // 显示标注
          }
          // console.log("PolylineObj.visible", PolylineObj.visible);
          const dDim1 = mDimensionObj1.xLine1Point.distanceTo(
            mDimensionObj1.xLine2Point
          );
          const dDim2 = mDimensionObj2.xLine1Point.distanceTo(
            mDimensionObj2.xLine2Point
          );

          // 节点所在点
          let currentPointX = currentPoint.x;
          let currentPointY = currentPoint.y;
          // 当板洞在板的边缘时,板洞的中心点不能超出板的边缘,把板洞贴在板的边缘上
          if (NearNodePtObj) {
            const ptNode = new McGePoint3d(
              NearNodePtObj.m_pt[0],
              NearNodePtObj.m_pt[1],
              0
            );
            currentPointX =
              dDim1 > tableRow.params.B / 2
                ? currentPointX
                : ptNode.x - vecTemp1.x * (tableRow.params.B / 2);
            currentPointY =
              dDim2 > tableRow.params.H / 2
                ? currentPointY
                : ptNode.y - vecTemp2.y * (tableRow.params.H / 2);
          }
          // 移动预览图
          PolylineObj.move(
            new McGePoint3d(pt1.x, pt1.y, pt1.z),
            new McGePoint3d(currentPointX, currentPointY, currentPoint.z)
          );
          // 更新pt1的位置
          pt1 = new McGePoint3d(currentPointX, currentPointY, currentPoint.z);
        }
      });
      // 第一次点击鼠标
      // if (!mouseInSlab) return;
      getPoint.setInputToucheType(2);

      getPoint.go(async (status2) => {
        // 取消绘制
        if (status2 == -2) {
          if (PolylineObj) PolylineObj.erase();
          if (mDimensionObj1) mDimensionObj1.erase();
          if (mDimensionObj2) mDimensionObj2.erase();
          resolve();
          return;
        }
        window.canvas
          .getContext("2d")
          .clearRect(0, 0, canvas.width, canvas.height); // 清空捕捉标识

        // 板洞绘制
        if (!slabHoleType) {
          PolylineObj.erase();
          if (mouseInSlab && !mouseInSlab.RoomIsHole) {
            const rlSlabHoleObject = new rlSlabHoleData();
            rlSlabHoleObject.isWasmGeted = false;
            var shapKey = tableRow.section.split("*").join(",");
            // 节点所在点
            const ptNode = new McGePoint3d(
              NearNodePtObj.m_pt[0],
              NearNodePtObj.m_pt[1],
              NearNodePtObj.m_pt[2]
            );
            const dDim1 = mDimensionObj1.xLine1Point.distanceTo(
              mDimensionObj1.xLine2Point
            );
            const dDim2 = mDimensionObj2.xLine1Point.distanceTo(
              mDimensionObj2.xLine2Point
            );
            // 计算X方向的距离
            let deltaX = ptNow.x - ptNode.x;
            // 当板洞在板的边缘时,板洞的中心点不能超出板的边缘,把板洞贴在板的边缘上
            if (dDim1 < tableRow.params.B / 2) {
              deltaX =
                deltaX > 0 ? tableRow.params.B / 2 : -tableRow.params.B / 2;
            }
            // 计算Y方向的距离
            let deltaY = ptNow.y - ptNode.y;
            // 当板洞在板的边缘时,板洞的中心点不能超出板的边缘,把板洞贴在板的边缘上
            if (dDim2 < tableRow.params.H / 2) {
              deltaY =
                deltaY > 0 ? tableRow.params.H / 2 : -tableRow.params.H / 2;
            }
            rlSlabHoleObject.initData({
              m_sectParamData: {
                ShapeVal: `${tableRow.section_param},${shapKey},6,${tableRow.Guid}`,
                // kind截面类型:1:矩形,3:圆形
                Kind: tableRow.section_param,
                Guid: tableRow.Guid,
              },
              No_: tableRow.No_,
              m_JointData: NearNodePtObj,
              m_SlabData: mouseInSlab,
              Color: slabHoleColor,
              Rotation: 0,
              EccY: deltaY,
              EccX: deltaX,
              Height: mouseInSlab.Height,
              LevelB: mouseInSlab.LevelB,
              slabThickness: mouseInSlab.m_sectParamData.Thickness,
            });
            rlSlabHoleObject.draw();
            await addEntityToDrawing(rlSlabHoleObject, false);

            const midX = (ptNow.x + ptNode.x) / 2;
            const midY = ptNow.y;
            const showText =
              Math.abs(ptNow.x - ptNode.x) - tableRow.params.B / 2 <
              tableRow.params.B / 2
                ? 0
                : Math.abs(ptNow.x - ptNode.x) - tableRow.params.B / 2;
            setInputElementPosition(showText.toFixed(0), midX, midY);
            setCurrDataObj(rlSlabHoleObject);
            const otherData = {
              mDimensionObj1: mDimensionObj1,
              mDimensionObj2: mDimensionObj2,
              moduleForm: moduleForm,
              rl_stdFlr_id: rl_stdFlr_id,
              slabHoleType: slabHoleType,
              isCreatingNew: true,
            };
            // 给输入框传参
            setOtherData(otherData);
            oneMessage.info("请输入X方向布置距离");
          } else {
            if (!store.state.app.isPcMode) {
              //当移动端移动画布的时候,没点中楼板,则重新调用墙洞布置
              setTimeout(async () => {
                if (window.activeMain && window.activeMain.Guid) {
                  setContainerShow(false);
                  // 重新调用墙洞布置
                  await create_slabHole_ents(
                    rl_stdFlr_id,
                    moduleForm,
                    slabHoleType
                  );
                  return; // 提前返回，避免执行后面的清理代码
                }
              }, 50);
            }
          }
        }
        // 全洞绘制
        if (slabHoleType && mouseInSlab && !mouseInSlab.RoomIsHole) {
          mouseInSlab.saveEditRevokeData();
          mouseInSlab.RoomIsHole = 1; // 修改全洞标识
          mouseInSlab.updateThisObj(mouseInSlab);
          console.log(window.isDrawAllHole);

          if (window.isDrawAllHole)
            await create_slabHole_ents(rl_stdFlr_id, moduleForm, slabHoleType);
        }

        // 将操作步骤下的所有数据更新到数据库中
        await saveDatabaseStore();
        resolve();
      });
    });
  });
};

// 获取非结构构件(隔墙/门窗)不同材料的颜色
export const getNonStructuralColor = (type) => {
  let color = null;
  switch (type) {
    case 51: // 砖
      color = { r: 51, g: 255, b: 0, a: 1 };
      break;
    case 52: // 玻璃
      color = { r: 173, g: 216, b: 230, a: 0.3 };
      break;
    case 53: // 金属
      color = { r: 128, g: 0, b: 128, a: 0.6 };
      break;
    case 54: // 轻质材料
      color = { r: 239, g: 160, b: 177, a: 0.67 };
      break;
    case 55: // 人造板材
      color = { r: 139, g: 69, b: 19, a: 0.85 };
      break;
    case 56: // 其他
      color = { r: 128, g: 0, b: 128, a: 0.6 };
      break;
    default:
      break;
  }
  return color;
};

// 判断方向更偏向于哪个轴
const isMoreAlongX = (direction) => {
  return Math.abs(direction.x) > Math.abs(direction.y);
};

// 给两个点返回矩形点集
export const getRectPoints = (ptStart, ptEnd, RectThick) => {
  // 方向
  let vec = new THREE.Vector3().subVectors(ptStart, ptEnd).normalize();
  vec = vec.normalize();
  const crossDirection = new THREE.Vector3();
  const vecZ = new THREE.Vector3(0, 0, 1);
  crossDirection.crossVectors(vec, vecZ).normalize();
  const negateCrossDirection = new THREE.Vector3(
    -crossDirection.x,
    -crossDirection.y,
    -crossDirection.z
  );
  const points = [];
  // 绘制俯视图
  points.push(MovePt(ptEnd, crossDirection, RectThick / 2));
  points.push(MovePt(ptStart, crossDirection, RectThick / 2));
  points.push(MovePt(ptStart, negateCrossDirection, RectThick / 2));
  points.push(MovePt(ptEnd, negateCrossDirection, RectThick / 2));
  return points;
};

// 根据给的方向和距离移动点位
export const MovePt = (pt, vec, dist) => {
  //
  //
  //
  //

  const NewPt = new McGePoint3d(
    pt.x + vec.x * dist,
    pt.y + vec.y * dist,
    pt.z + vec.z * dist
  );

  //

  return NewPt;
};

// 判断新布置的隔墙线段之间是否相交
export const handleSelfIntersection = async (points) => {
  if (points.length < 3) return points;

  // 存储初始线段
  let segments = [];
  for (let i = 0; i < points.length - 1; i++) {
    segments.push({
      start: points[i],
      end: points[i + 1],
      originalIndex: i, // 记录原始顺序
    });
  }

  const maxIterations = 100;
  let iterations = 0;

  while (iterations < maxIterations) {
    iterations++;
    let hasNewIntersection = false;
    const newSegments = [];

    // 检查每条线段
    for (let i = 0; i < segments.length; i++) {
      const currentSegment = segments[i];
      const intersections = [];

      // 与其他线段检查相交
      for (let j = 0; j < segments.length; j++) {
        if (i === j) continue;

        // 转成三维点
        const start1 = new McGePoint3d(
          currentSegment.start.x,
          currentSegment.start.y,
          0
        );
        const end1 = new McGePoint3d(
          currentSegment.end.x,
          currentSegment.end.y,
          0
        );

        const start2 = new McGePoint3d(
          segments[j].start.x,
          segments[j].start.y,
          0
        );
        const end2 = new McGePoint3d(segments[j].end.x, segments[j].end.y, 0);
        const intersection = lineInsection(start1, end1, start2, end2);

        if (intersection.isIntersected) {
          const intersectionPoint = intersection.intersectionPoint;

          // 确保交点不是端点
          if (
            !isPointEqual(intersectionPoint, currentSegment.start) &&
            !isPointEqual(intersectionPoint, currentSegment.end)
          ) {
            intersections.push({
              point: intersectionPoint,
              originalIndex: currentSegment.originalIndex,
            });
            hasNewIntersection = true;
          }
        }
      }

      if (intersections.length > 0) {
        // 按照到起点的距离排序交点
        intersections.sort((a, b) => {
          const distA = getDistanceToStart(a.point, currentSegment.start);
          const distB = getDistanceToStart(b.point, currentSegment.start);
          return distA - distB;
        });

        // 创建分割后的线段
        let lastPoint = currentSegment.start;
        for (const intersection of intersections) {
          newSegments.push({
            start: lastPoint,
            end: intersection.point,
            originalIndex: currentSegment.originalIndex,
          });
          lastPoint = intersection.point;
        }

        // 添加最后一段
        newSegments.push({
          start: lastPoint,
          end: currentSegment.end,
          originalIndex: currentSegment.originalIndex,
        });
      } else {
        // 如果没有相交，保留原线段
        newSegments.push(currentSegment);
      }
    }

    // 更新线段数组
    segments = newSegments;

    // 如果没有新的相交点，结束循环
    if (!hasNewIntersection) {
      break;
    }
  }

  // 按原始顺序和位置排序线段
  segments.sort((a, b) => {
    if (a.originalIndex !== b.originalIndex) {
      return a.originalIndex - b.originalIndex;
    }
    return (
      getDistanceToStart(a.start, points[a.originalIndex]) -
      getDistanceToStart(b.start, points[b.originalIndex])
    );
  });

  // 重建点集，确保连续性
  const resultPoints = [];
  if (segments.length > 0) {
    resultPoints.push(segments[0].start);

    for (let i = 0; i < segments.length; i++) {
      const currentSeg = segments[i];

      // 检查是否需要添加终点
      if (
        !isPointEqual(resultPoints[resultPoints.length - 1], currentSeg.end)
      ) {
        resultPoints.push(currentSeg.end);
      }

      // 如果不是最后一段，且下一段的起点与当前段的终点不同
      if (
        i < segments.length - 1 &&
        !isPointEqual(currentSeg.end, segments[i + 1].start)
      ) {
        resultPoints.push(segments[i + 1].start);
      }
    }
  }

  // 移除距离太近的点
  return removeDuplicatePoints(resultPoints);
};

// 移除重复点和距离太近的点
const removeDuplicatePoints = (points, tolerance = 0.0001) => {
  if (points.length <= 1) return points;

  const result = [points[0]];

  for (let i = 1; i < points.length; i++) {
    const lastPoint = result[result.length - 1];
    if (getDistanceToStart(lastPoint, points[i]) > tolerance) {
      result.push(points[i]);
    }
  }

  return result;
};

// 计算点到起点的距离
const getDistanceToStart = (point1, point2) => {
  return Math.sqrt(
    Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2)
  );
};

// 判断两点是否相等
export const isPointEqual = (p1, p2, tolerance = 0.0001) => {
  return Math.abs(p1.x - p2.x) < tolerance && Math.abs(p1.y - p2.y) < tolerance;
};

// 创建圈梁
export const create_ringBeam_ents = async (rl_stdFlr_id, moduleForm) => {
  return new Promise(async (resolve, reject) => {
    if (rl_stdFlr_id == -999 || !moduleForm) {
      return;
    }
    const { parameter, tableRow } = moduleForm;
    // 拿到对应标准层
    var StlData = await getrlStdFlr(rl_stdFlr_id);
    // Message.info("请框选需要的对象");

    // 绘制回调方法
    const set_ringBeam = async (ids) => {
      if (!ids || !ids.length) return;

      const rlLayer = await getRlLayer();
      let ringBeamColor = rlLayer.filter(
        (item) => item.Type == "rlRingBeamSeg"
      );
      ringBeamColor = ringBeamColor[0].Color;
      // 绘制步数
      store.commit("globalData/setCanAddRawStep", true);

      await ids.map(async (item) => {
        const mcObj = item.getMcDbEntity();
        if (mcObj) {
          const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
          const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型

          if (objClassName == "rlGrid") {
            const rlGridData = getEntityData({
              Guid: objGuid,
              classTypeName: objClassName,
            });

            if (!rlGridData) {
              console.warn("当前选择对象为空");
              return;
            }

            if (rlGridData.m_ringBeamId) {
              // 判断当前网格是否存在梁
              const rlBeamAssociation = getEntityData({
                Guid: rlGridData.m_ringBeamId,
                classTypeName: "rlRingBeamSeg",
              });
              if (rlBeamAssociation) {
                rlBeamAssociation.saveEditRevokeData();

                rlBeamAssociation.m_sectParamData.Mat = tableRow.material;
                rlBeamAssociation.m_sectParamData.Kind = tableRow.section_param;
                rlBeamAssociation.m_sectParamData.Guid = tableRow.Guid;
                rlBeamAssociation.m_sectParamData.ShapeVal = `${
                  tableRow.section_param
                },${tableRow.section.split("*").join(",")},1,1`;

                rlBeamAssociation.Height = StlData.Height ?? 3000;
                rlBeamAssociation.LevelB = 0;
                rlBeamAssociation.Ecc = Number(parameter[0].value);
                rlBeamAssociation.HDiff1 = Number(parameter[1].value);
                rlBeamAssociation.HDiff2 = Number(parameter[2].value);
                // rlBeamAssociation.ModelNo = ModelNo;
                // rlBeamAssociation.draw();
                // rlBeamAssociation.mcDbId = rlAppObj.mxcadObject.drawEntity(
                //   rlBeamAssociation.mcDbPolyline
                // );
                rlBeamAssociation.updateThisObj(rlBeamAssociation);
                // rlBeamAssociation.statusType = 2;
              }
            } else {
              const rlBeamObject = new rlRingBeamData();
              rlBeamObject.initData({
                m_sectParamData: {
                  Mat: tableRow.material,
                  Kind: tableRow.section_param,
                  Guid: tableRow.Guid,
                  ShapeVal: `${tableRow.section_param},${tableRow.section
                    .split("*")
                    .join(",")},1,1`,
                },
                Ecc: Number(parameter[0].value),
                HDiff1: Number(parameter[1].value),
                HDiff2: Number(parameter[2].value),
                LevelB: 0,
                Height: StlData.Height ?? 3000,
                Color: ringBeamColor,
                m_gridData: rlGridData,
                Attribute: 1,
              });
              // m_sectParamData.Mat = tableRow.material;
              // m_sectParamData.Kind = tableRow.section_param;
              // m_sectParamData.Guid = tableRow.Guid;
              // m_sectParamData.ShapeVal = `${
              //   tableRow.section_param
              // },${tableRow.section.split("*").join(",")},1,1`;
              // rlBeamObject.m_sectParamData = m_sectParamData;
              // rlBeamObject.m_gridData = rlGridData;
              // rlBeamObject.Height = 3000;
              // rlBeamObject.LevelB = 0;
              // rlBeamObject.Ecc = Number(parameter[0].value);
              // rlBeamObject.HDiff1 = Number(parameter[1].value);
              // rlBeamObject.HDiff2 = Number(parameter[2].value);
              // rlBeamObject.Color = ringBeamColor;
              rlBeamObject.draw();
              await addEntityToDrawing(rlBeamObject, false);
              // rlAppObj.rlMxDrawObject.addMxEntity(rlBeamObject);
              // // 添加到组
              // let rlBeamGroup = rlAppObj.rlMxDatabase.addGroup(
              //   rlBeamObject.m_groupName
              // );
              // rlBeamGroup.append(rlBeamObject);
            }
          }
        }
      });
      // 将操作步骤下的所有数据更新到数据库中
      await saveDatabaseStore();
      rlAppObj.rlMxDrawObject.updateDisplay();
    };
    // userSelect(set_ringBeam)
    //   .then(async (ids) => {
    //     resolve("绘制结束");
    //   })
    //   .catch((err) => {
    //
    //     reject(err);
    //   });
    userSelect(set_ringBeam);
  });
};

// 绘制板洞
export const draw_slabeHole = async (rl_stdFlr_id, moduleForm) => {
  return new Promise(async (resolve, reject) => {
    if (!moduleForm || rl_stdFlr_id == -999) return;
    // 拿到对应标准层
    var StlData = await getrlStdFlr(rl_stdFlr_id);
    const { parameter, tableRow } = moduleForm;

    // Message.info("请框选需要的对象");

    const rlSlabGroup = store.state.rlEntData.totalEntityData["rlSlab"]; // rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.getAll();
    if (!rlSlabGroup || !rlSlabGroup.length) {
      return;
    }

    // 获取各个楼板的平面轮廓
    const slabShapes = {};
    rlSlabGroup.forEach((slab) => {
      const pts = [];
      for (let i = 0; i < slab.index2dData.length; i += 3) {
        pts.push([slab.index2dData[i], slab.index2dData[i + 1]]);
      }
      slabShapes[slab.Guid] = pts;
    });

    const bIsAllHole = moduleForm.parameter[0].value == 2; // 是否全洞
    const set_slabHole = async (ids) => {
      if (!ids || !ids.length) return;

      // 绘制步数
      store.commit("globalData/setCanAddRawStep", true);

      await ids.map(async (item) => {
        const mcObj = item.getMcDbEntity();
        const objGuid = mcObj.getxDataString("Guid").val; // 获取绑定的guid
        const objClassName = mcObj.getxDataString("classTypeName").val; // 获取绑定的类型

        if (objClassName == "rlJoint") {
          const obj = getEntityData({
            Guid: objGuid,
            classTypeName: objClassName,
          });

          if (!obj) {
            console.warn("当前选择对象为空");
            return;
          }

          if (obj.m_slabHoleId) {
            const rlSlabHole = getEntityData({
              Guid: obj.m_slabHoleId,
              classTypeName: "rlSlabHole",
            });
            if (rlSlabHole) {
              await rlSlabHole.erase();
            }
          }

          if (!bIsAllHole) {
            let nRotation = 0; // 柱转角
            if (moduleForm.parameter[0].value) {
              nRotation = moduleForm.parameter[0].value;
            }

            let nEccX = 0; // 沿轴偏心
            if (moduleForm.parameter[2].value) {
              nEccX = Number(moduleForm.parameter[2].value);
            }

            let nEccY = 0; // 偏轴偏心
            if (moduleForm.parameter[3].value) {
              nEccY = Number(moduleForm.parameter[3].value);
            }

            // 板洞插入位置
            const holeInsertPt = [obj.m_pt[0] + nEccX, obj.m_pt[1] + nEccY];

            const shapePts = [];
            // 计算板洞布置位置
            if (moduleForm.tableRow.label == "矩形") {
              const sectB = moduleForm.tableRow.params.B;
              const sectH = moduleForm.tableRow.params.H;

              shapePts.push(holeInsertPt);
              shapePts.push([holeInsertPt[0] + sectB, holeInsertPt[1]]);
              shapePts.push([holeInsertPt[0] + sectB, holeInsertPt[1] + sectH]);
              shapePts.push([holeInsertPt[0], holeInsertPt[1] + sectH]);
            } else {
              // 圆形

              const dRedis = Number(moduleForm.tableRow.params.B);
              const nDivid = 16;
              const rotateAngPre = (Math.PI * 2.0) / nDivid;
              for (let i = 0; i < nDivid; ++i) {
                const x = holeInsertPt[0] + dRedis * Math.cos(rotateAngPre * i);
                const y = holeInsertPt[0] + dRedis * Math.sin(rotateAngPre * i);

                shapePts.push([x, y]);
              }
              // const shape = new THREE.Shape();
              // // 添加轮廓的点
              // shape.moveTo(holeInsertPt);
              // shape.arc()
            }

            // 计算板洞位置上的楼板
            let shapeInSlab = null; // 板洞所在的楼板
            for (let i = 0; i < Object.keys(slabShapes).length; i++) {
              const slabPolygons = slabShapes[Object.keys(slabShapes)[i]];
              let allContains = true; // 是否全部在此楼板内

              shapePts.forEach((item) => {
                if (!isInPolygon(item, slabPolygons)) {
                  allContains = false;
                }
              });
              if (allContains) {
                shapeInSlab = Object.keys(slabShapes)[i];
                break;
              }
            }
            if (shapeInSlab) {
              const onSlabObj = getEntityData({
                Guid: shapeInSlab,
                classTypeName: "rlSlab",
              }); // get_entity_by_id(shapeInSlab);
              const slabThickness = onSlabObj
                ? onSlabObj.m_sectParamData.Thickness
                : 0;
              // 布置板洞
              const rlSlabObject = new rlSlabHoleData();
              const m_sectParamData = new rlSlabHoleModelSectData();
              rlSlabObject.initData({
                m_sectParamData: {
                  Mat: tableRow.material,
                  Kind: tableRow.section_param,
                  Guid: tableRow.Guid,
                  ShapeVal: `${tableRow.section_param},${tableRow.section
                    .split("*")
                    .join(",")},1,1`,
                },
                m_JointData: obj,
                Height: StlData.Height ?? 3000,
                LevelB: 0,
                EccX: Number(parameter[0].value),
                EccY: Number(parameter[1].value),
                HDiffB: Number(parameter[2].value),
                Rotation: Number(parameter[3].value),
                slabThickness: slabThickness,
                Attribute: 1,
              });
              // m_sectParamData.Mat = tableRow.material;
              // m_sectParamData.Kind = tableRow.section_param;
              // m_sectParamData.Guid = tableRow.Guid;
              // m_sectParamData.ShapeVal = `${
              //   tableRow.section_param
              // },${tableRow.section.split("*").join(",")},1,1`;

              // rlSlabObject.m_JointData = obj;

              // rlSlabObject.m_sectParamData = m_sectParamData;
              // rlSlabObject.Height = 3000;
              // rlSlabObject.LevelB = 0;

              // rlSlabObject.EccX = Number(parameter[0].value);
              // rlSlabObject.EccY = Number(parameter[1].value);
              // rlSlabObject.HDiffB = Number(parameter[2].value);
              // rlSlabObject.Rotation = Number(parameter[3].value);
              // rlSlabObject.slabThickness = slabThickness;
              // 新增构件保存到indexdb
              rlSlabObject.draw();
              await addEntityToDrawing(rlSlabObject, false);
            }
          } else if (bIsAllHole && obj.classTypeName === "rlSlab") {
            obj.RoomIsHole = 1;
            await obj.updateThisObj(obj);
          }
        }
      });
      // 将操作步骤下的所有数据更新到数据库中
      await saveDatabaseStore();
      rlAppObj.rlMxDrawObject.updateDisplay();
    };
    // userSelect(set_slabHole)
    //   .then(async () => {
    //     resolve("绘制结束");
    //   })
    //   .catch((err) => {
    //
    //     reject(err);
    //   });
    userSelect(set_slabHole);
  });
};

// 刷新构件编号
export const updata_totalModel_No = async (rl_stdFlr_id) => {
  if (rl_stdFlr_id === -999) {
    return;
  }

  const rlColumnGroup = store.state.rlEntData.totalEntityData["rlColSeg"]; // rlAppObj.rlMxDatabase.getGroup("rlColumnGroup")?.getAll();
  const rlBeamGroup = store.state.rlEntData.totalEntityData["rlBeamSeg"]; // rlAppObj.rlMxDatabase.getGroup("rlBeamGroup")?.getAll();
  const rlWallGroup = store.state.rlEntData.totalEntityData["rlWallSeg"]; // rlAppObj.rlMxDatabase.getGroup("rlWallGroup")?.getAll();
  const rlSlabGroup = store.state.rlEntData.totalEntityData["rlSlab"]; // rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.getAll();
  if (!rlColumnGroup && !rlBeamGroup && !rlWallGroup && !rlSlabGroup) {
    return;
  }

  // 设置柱子的构件号
  if (rlColumnGroup && rlColumnGroup.length) {
    rlColumnGroup.forEach(async (item) => {
      item.saveEditRevokeData();

      const gridsData = item.m_JointData.m_gridIds;
      const axisNos = [];
      gridsData.map((grid) => {
        const objTmp = getEntityData({
          Guid: grid,
          classTypeName: "rlGrid",
        });
        // })rlAppObj.rlMxDrawObject.getMxEntity(grid);
        if (objTmp && axisNos.indexOf(objTmp.m_Axis.Name) < 0) {
          axisNos.push(objTmp.m_Axis.Name);
        }
      });
      item.ModelNo = axisNos.join("-");
      item.updateThisObj(item, false);
    });
  }
  // 设置梁的构件号
  setBeamWallModelNo(1, rlBeamGroup);
  // 设置墙的构件号
  setBeamWallModelNo(2, rlWallGroup);
  // 设置楼板的构件号

  const rlJointGroup = store.state.rlEntData.totalEntityData["rlJoint"]; // rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.getAll();
  if (rlSlabGroup && rlSlabGroup.length) {
    rlSlabGroup.map(async (item) => {
      item.saveEditRevokeData();

      const VertexX = item.VertexX.split(",");
      const VertexY = item.VertexY.split(",");
      const VertexZ = item.VertexZ.split(",");
      const axisDatas = [];
      for (let index = 0; index < VertexX.length; index++) {
        const vX = VertexX[index];
        const vY = VertexY[index];
        const vZ = VertexZ[index];
        // points.push(new THREE.Vector3(vX, vY, vZ));
        const objJoint = rlJointGroup.filter(
          (item) =>
            Math.abs(item.m_pt[0] - vX) < 1 && Math.abs(item.m_pt[1] - vY) < 1
        );

        if (objJoint && objJoint.length) {
          const gridIds = objJoint[0].m_gridIds;
          gridIds.forEach((id) => {
            const objTmp = getEntityData({
              Guid: id,
              classTypeName: "rlGrid",
            }); // //rlAppObj.rlMxDrawObject.getMxEntity(grid);
            if (objTmp && objTmp.m_Axis && !axisDatas.includes(objTmp.m_Axis)) {
              axisDatas.push(objTmp.m_Axis);
            }
          });
        }
      }

      let modelNo = "";
      let indexTmp = 0;
      const resSortedAxisData = await sortAxisData(axisDatas);

      if (resSortedAxisData) {
        Object.keys(resSortedAxisData).forEach((key) => {
          const values = Object.values(resSortedAxisData[key]);
          if (values && values.length > 1) {
            if (indexTmp > 0) {
              modelNo += `-`;
            }
            indexTmp++;
            modelNo += `${values[0].item.Name}-${
              values[values.length - 1].item.Name
            }`;
          }
        });
      }
      item.ModelNo = modelNo;

      //
      item.updateThisObj(item, false);
    });
  }
};

const setBeamWallModelNo = (modelType /* 1==beam,2==wall*/, modelGroup) => {
  if (!modelGroup || !modelGroup.length) {
    return;
  }

  // 设置梁的构件号
  const rlBeamGroup = modelGroup;

  const calAxisDataArray = []; // 记录已经计算过的轴线
  if (rlBeamGroup && rlBeamGroup.length) {
    for (let i = 0; i < rlBeamGroup.length; i++) {
      const itemBeam = rlBeamGroup[i];
      // rlBeamGroup.forEach((itemBeam) => {
      const gridData = itemBeam.m_gridData;
      const curAxis = gridData.m_Axis;
      if (!calAxisDataArray.includes(curAxis)) {
        calAxisDataArray.push(curAxis);
        // 搜索同一轴线上是否还有相邻的构件
        const contectGroup = getContectModelArray(curAxis, modelType);
        Object.keys(contectGroup).forEach((key) => {
          const values = contectGroup[key];
          // 获取起点、终点轴线号
          if (values && values.length > 0) {
            const stGrids = values[0].m_stJoint.m_gridIds;
            const edGrids = values[values.length - 1].m_edJoint.m_gridIds;
            let stAxisName = "";
            let edAxisName = "";
            stGrids.forEach((item) => {
              const objTmp = getEntityData({
                Guid: item,
                classTypeName: "rlGrid",
              }); // rlAppObj.rlMxDrawObject.getMxEntity(item);
              if (objTmp && objTmp.m_Axis != curAxis) {
                stAxisName = objTmp.m_Axis.Name;
              }
            });

            edGrids.forEach((item) => {
              const objTmp = getEntityData({
                Guid: item,
                classTypeName: "rlGrid",
              }); // rlAppObj.rlMxDrawObject.getMxEntity(item);
              if (objTmp && objTmp.m_Axis != curAxis) {
                edAxisName = objTmp.m_Axis.Name;
              }
            });
            const ModelNo = `${stAxisName}-${edAxisName}-${curAxis.Name}`;
            values.forEach(async (item) => {
              const modelId = modelType == 1 ? item.m_beamId : item.m_wallId;
              const objTmp = getEntityData({
                Guid: modelId,
                classTypeName: modelType == 1 ? "rlBeamSeg" : "rlWallSeg",
              }); // rlAppObj.rlMxDrawObject.getMxEntity(modelId);
              if (objTmp) {
                objTmp.saveEditRevokeData();
                objTmp.ModelNo = ModelNo;
                objTmp.updateThisObj(objTmp, false);
              }
            });
          }
        });
      }
    }
  }
};
// 获取相邻构件数据
const getContectModelArray = (axisObj, searchType) => {
  // 获取轴线上所有网格
  const gridIds = axisObj.m_gridIds;
  const axisStPt = new THREE.Vector3(...axisObj.m_stJoint.m_pt); // 轴线的起点
  const axisEdPt = new THREE.Vector3(...axisObj.m_edJoint.m_pt); // 轴线的终点

  const sortGridObjs = {}; // 按照在轴线上的位置对网格排序
  gridIds.forEach((grid) => {
    const objGrid = getEntityData({
      Guid: grid,
      classTypeName: "rlGrid",
    }); // rlAppObj.rlMxDrawObject.getMxEntity(grid);
    if (objGrid) {
      const stPt = new THREE.Vector3(...objGrid.m_stJoint.m_pt);
      const edPt = new THREE.Vector3(...objGrid.m_edJoint.m_pt);
      const distSt = stPt.distanceTo(axisStPt);
      const distEd = edPt.distanceTo(axisStPt);
      const dist = distSt > distEd ? distEd : distSt;

      sortGridObjs[dist] = objGrid;
    }
  });
  // 获取轴线上所有有墙/梁
  let lastJointObj = axisObj.m_stJoint; // 上一个计算的节点
  const contectGroup = {}; // 能够连接为一个的墙/梁集合，key为起始点，value为对象集合
  Object.keys(sortGridObjs).forEach((key) => {
    const gridObj = sortGridObjs[key];
    if (
      (searchType == 1 && gridObj.m_beamId) ||
      (searchType == 2 && gridObj.m_wallId)
    ) {
      // 添加数据
      if (contectGroup[lastJointObj.Guid]) {
        contectGroup[lastJointObj.Guid].push(gridObj);
      } else {
        contectGroup[lastJointObj.Guid] = [];
        contectGroup[lastJointObj.Guid].push(gridObj);
      }

      if (gridObj.m_edJoint.m_cloumId) {
        lastJointObj =
          lastJointObj.Guid == gridObj.m_stJoint.Guid
            ? gridObj.m_edJoint
            : gridObj.m_stJoint; // 计算下一段
      }
      // if (lastJointObj.Guid == gridObj.m_stJoint.Guid) {
      //   if (gridObj.m_edJoint.m_cloumId) {
      //     lastJointObj = gridObj.m_edJoint; //计算下一段
      //   }
      // } else if (lastJointObj.Guid == gridObj.m_edJoint.Guid) {
      // }
    } else {
      // 跳过此段，计算下一段
      lastJointObj =
        lastJointObj.Guid == gridObj.m_stJoint.Guid
          ? gridObj.m_edJoint
          : gridObj.m_stJoint;
    }
  });
  return contectGroup;
};

// 判断两线段是否平行
export function isParallel(A, B, C, D) {
  // 计算线段的方向向量
  const AB = new THREE.Vector3().subVectors(B, A);
  const CD = new THREE.Vector3().subVectors(D, C);

  const slope1 = Math.abs(AB.x) < Math.exp(-1) ? 9999 : AB.y / AB.x;
  const slope2 = Math.abs(CD.x) < Math.exp(-1) ? 9999 : CD.y / CD.x;

  // 两线段斜率相等，则平行
  if (Math.abs(slope1 - slope2) < Math.exp(-4)) {
    // 斜率相等且在同一直线上
    return true;
  } else {
    return false;
  }
}

// 判断两个方向是否互相垂直
export const isPerpendicular = (vec1, vec2) => {
  // 归一化向量
  const normalize = (v) => {
    const len = Math.sqrt(v.x * v.x + v.y * v.y);
    return len === 0 ? v : { x: v.x / len, y: v.y / len };
  };

  // 将输入向量归一化
  const v1 = normalize(vec1);
  const v2 = normalize(vec2);

  // 计算点积,由于浮点数精度问题,使用一个小的容差值
  const dotProduct = v1.x * v2.x + v1.y * v2.y;
  const tolerance = 0.001;

  // 如果点积接近0,则两向量垂直
  return Math.abs(dotProduct) < tolerance;
};

/**
 * 将点集分组,确保每组中的点之间没有其他点
 * @param {Array<McGePoint3d>} points 原始点集
 * @returns {Array<Array<McGePoint3d>>} 分组后的点集数组
 */
export const groupPoints = (points) => {
  if (!points || points.length < 2) return [];

  // 获取所有可能的线段
  const getAllPossibleSegments = (points) => {
    const segments = [];

    // 计算点到线段的距离
    const getDistanceToSegment = (point, lineStart, lineEnd) => {
      const A = point.x - lineStart.x;
      const B = point.y - lineStart.y;
      const C = lineEnd.x - lineStart.x;
      const D = lineEnd.y - lineStart.y;

      const dot = A * C + B * D;
      const lenSq = C * C + D * D;
      let param = -1;

      if (lenSq !== 0) {
        param = dot / lenSq;
      }

      let xx, yy;

      if (param < 0) {
        xx = lineStart.x;
        yy = lineStart.y;
      } else if (param > 1) {
        xx = lineEnd.x;
        yy = lineEnd.y;
      } else {
        xx = lineStart.x + param * C;
        yy = lineStart.y + param * D;
      }

      const dx = point.x - xx;
      const dy = point.y - yy;

      return Math.sqrt(dx * dx + dy * dy);
    };

    for (let i = 0; i < points.length; i++) {
      for (let j = i + 1; j < points.length; j++) {
        const pt1 = points[i];
        const pt2 = points[j];

        // 检查两点之间是否有其他点
        let hasPointBetween = false;

        for (const point of points) {
          if (isPointEqual(point, pt1) || isPointEqual(point, pt2)) continue;

          const dist = getDistanceToSegment(point, pt1, pt2);
          if (dist < 0.001) {
            // 计算点是否在线段上
            const d1 = Math.sqrt(
              Math.pow(point.x - pt1.x, 2) + Math.pow(point.y - pt1.y, 2)
            );
            const d2 = Math.sqrt(
              Math.pow(point.x - pt2.x, 2) + Math.pow(point.y - pt2.y, 2)
            );
            const lineLength = Math.sqrt(
              Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2)
            );

            if (Math.abs(d1 + d2 - lineLength) < 0.001) {
              hasPointBetween = true;
              break;
            }
          }
        }

        if (!hasPointBetween) {
          segments.push({
            startPt: new McGePoint3d(pt1.x, pt1.y, pt1.z),
            endPt: new McGePoint3d(pt2.x, pt2.y, pt2.z),
          });
        }
      }
    }
    return segments;
  };

  // 检查两条线段是否相交
  const doSegmentsIntersect = (seg1, seg2) => {
    const res = lineInsection(
      seg1.startPt,
      seg1.endPt,
      seg2.startPt,
      seg2.endPt,
      false
    );
    if (!res.isIntersected) return false;

    const intersectPt = res.intersectionPoint;
    return (
      !isPointEqual(intersectPt, seg1.startPt) &&
      !isPointEqual(intersectPt, seg1.endPt) &&
      !isPointEqual(intersectPt, seg2.startPt) &&
      !isPointEqual(intersectPt, seg2.endPt)
    );
  };

  const allSegments = getAllPossibleSegments(points);
  const result = [];
  const usedSegments = new Set();

  for (let i = 0; i < allSegments.length; i++) {
    if (usedSegments.has(i)) continue;

    const currentGroup = [allSegments[i]];
    usedSegments.add(i);

    for (let j = i + 1; j < allSegments.length; j++) {
      if (usedSegments.has(j)) continue;

      let canAdd = true;
      for (const segment of currentGroup) {
        if (doSegmentsIntersect(segment, allSegments[j])) {
          canAdd = false;
          break;
        }
      }

      if (canAdd) {
        currentGroup.push(allSegments[j]);
        usedSegments.add(j);
      }
    }

    result.push(...currentGroup);
  }

  return result;
};

// 更新构件编号---已弃用
export const updata_structural_modelNo = (rl_stdFlr_id) => {
  if (rl_stdFlr_id === -999) {
    return;
  }
  const rlBeamGroup = rlAppObj.rlMxDatabase.getGroup("rlBeamGroup")?.getAll();
  const rlColumnGroup = rlAppObj.rlMxDatabase
    .getGroup("rlColumnGroup")
    ?.getAll();
  const rlWallGroup = rlAppObj.rlMxDatabase.getGroup("rlWallGroup")?.getAll();
  const rlSlabGroup = rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.getAll();

  if (rlBeamGroup && rlBeamGroup.length) {
    rlBeamGroup.forEach((item) => {
      // 编号
      const rlGridData = item.m_gridData;
      const startAxis = getEntityData({
        Guid: rlGridData.m_stJoint.startAxisObjId,
        classTypeName: "rlAxis",
      }); // get_entity_by_id(rlGridData.m_stJoint.startAxisObjId);
      const endAxis = getEntityData({
        Guid: rlGridData.m_stJoint.endAxisObjId,
        classTypeName: "rlAxis",
      }); // get_entity_by_id(rlGridData.m_stJoint.endAxisObjId);
      if (startAxis && endAxis) {
        const startAxis2 = getEntityData({
          Guid: rlGridData.m_edJoint.startAxisObjId,
          classTypeName: "rlAxis",
        }); // get_entity_by_id(rlGridData.m_edJoint.startAxisObjId);
        const endAxis2 = getEntityData({
          Guid: rlGridData.m_edJoint.endAxisObjId,
          classTypeName: "rlAxis",
        }); // get_entity_by_id(rlGridData.m_edJoint.endAxisObjId);
        // rlBeamObject.Name = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${startAxis2.Name}-${endAxis.Name} 梁`
        const mAxis = rlGridData.m_Axis;
        const newModelNo = `${rl_stdFlr_id.No_}F ${
          mAxis.axisVector > 0 ? "" : startAxis.Name + "-"
        }${startAxis2.Name}-${endAxis.Name}${
          mAxis.axisVector > 0 ? "-" + endAxis2.Name : ""
        } 梁`;
        if (item.ID && item.ModelNo != newModelNo) {
          item.ModelNo = newModelNo;
          item.statusType = 2;
        }
      }
    });
  }

  if (rlWallGroup && rlWallGroup.length) {
    rlWallGroup.forEach((item) => {
      // 编号
      const rlGridData = item.m_gridData;
      const startAxis = getEntityData({
        Guid: rlGridData.m_stJoint.startAxisObjId,
        classTypeName: "rlAxis",
      }); // get_entity_by_id(rlGridData.m_stJoint.startAxisObjId);
      const endAxis = getEntityData({
        Guid: rlGridData.m_stJoint.endAxisObjId,
        classTypeName: "rlAxis",
      }); // get_entity_by_id(rlGridData.m_stJoint.endAxisObjId);
      if (startAxis && endAxis) {
        const startAxis2 = getEntityData({
          Guid: rlGridData.m_edJoint.startAxisObjId,
          classTypeName: "rlAxis",
        }); // get_entity_by_id(rlGridData.m_edJoint.startAxisObjId);
        const endAxis2 = getEntityData({
          Guid: rlGridData.m_edJoint.endAxisObjId,
          classTypeName: "rlAxis",
        }); // get_entity_by_id(rlGridData.m_edJoint.endAxisObjId);
        // rlWallObject.Name = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${startAxis2.Name}-${endAxis.Name} 墙`
        const mAxis = rlGridData.m_Axis;
        const newModelNo = `${rl_stdFlr_id.No_}F ${
          mAxis.axisVector > 0 ? "" : startAxis.Name + "-"
        }${startAxis2.Name}-${endAxis.Name}${
          mAxis.axisVector > 0 ? "-" + endAxis2.Name : ""
        } 墙`;
        if (item.ID && item.ModelNo !== newModelNo) {
          item.ModelNo = newModelNo;
          item.statusType = 2;
        }
      }
    });
  }

  if (rlColumnGroup && rlColumnGroup.length) {
    rlColumnGroup.forEach((item) => {
      const rlPoint = item.m_JointData;
      // 编号
      if (rlPoint) {
        const startAxis = getEntityData({
          Guid: rlPoint.startAxisObjId,
          classTypeName: "rlAxis",
        }); // get_entity_by_id(rlPoint.startAxisObjId);
        const endAxis = getEntityData({
          Guid: rlPoint.endAxisObjId,
          classTypeName: "rlAxis",
        }); // get_entity_by_id(rlPoint.endAxisObjId);
        if (startAxis && endAxis) {
          const newModelNo = `${rl_stdFlr_id.No_}F ${startAxis.Name}-${endAxis.Name} 柱`;
          if (item.ID && item.ModelNo !== newModelNo) {
            item.ModelNo = newModelNo;
            item.statusType = 2;
          }
        }
      }
    });
  }
};

// 获取最大房间编号
export const getMaxRoomNo = (useFunctionName) => {
  const allUse = store.state.rlEntData.totalEntityData["rlUse"];
  let iMaxIndex = 0;

  // 获取最大房间编号
  for (let i = 0; i < allUse.length; i++) {
    const roomName = allUse[i].useFunctionName;
    // 确保只匹配以useFunctionName开头的房间名
    if (roomName.startsWith(useFunctionName)) {
      // 提取数字部分 - 从useFunctionName长度位置开始
      const numberPart = roomName.substring(useFunctionName.length);
      // 确保提取的是纯数字
      if (/^\d+$/.test(numberPart)) {
        const iIndex = parseInt(numberPart);
        if (iIndex > iMaxIndex) {
          iMaxIndex = iIndex;
        }
      }
    }
  }
  return iMaxIndex;
};

// 判断两个多边形面是否相交
export const isPolygonsIntersect = (polygon1, polygon2) => {
  if (polygon1.length == 0 || polygon2.length == 0) {
    return false;
  }
  // 检查任意一个多边形的边是否与另一个多边形的边相交
  for (let i = 0; i < polygon1.length; i++) {
    const p1Start = polygon1[i];
    const p1End = polygon1[(i + 1) % polygon1.length];

    for (let j = 0; j < polygon2.length; j++) {
      const p2Start = polygon2[j];
      const p2End = polygon2[(j + 1) % polygon2.length];

      // 检查两条边是否相交
      const intersection = lineInsection(
        new McGePoint3d(p1Start.x, p1Start.y, 0),
        new McGePoint3d(p1End.x, p1End.y, 0),
        new McGePoint3d(p2Start.x, p2Start.y, 0),
        new McGePoint3d(p2End.x, p2End.y, 0)
      );

      if (intersection.isIntersected) {
        return true;
      }
    }
  }

  // 检查一个多边形是否完全包含在另一个多边形内
  // 只需检查一个多边形的任意一点是否在另一个多边形内
  if (
    isPointInPolygon(polygon1[0], polygon2, 0.1) ||
    isPointInPolygon(polygon2[0], polygon1, 0.1)
  ) {
    return true;
  }

  return false;
};

// 判断多边形是否包含另一个多边形
export const isPolygonContainsPolygon = (outerPolygon, innerPolygon) => {
  // 检查内部多边形的所有点是否都在外部多边形内
  for (let i = 0; i < innerPolygon.length; i++) {
    if (!isPointInPolygon(innerPolygon[i], outerPolygon, 0.1)) {
      return false;
    }
  }
  return true;
};

// 计算多边形中心点 - 只考虑端点
const calculateCenter = (points) => {
  // 先找出所有端点
  const vertices = findVertices(points);
  console.log("vertices", vertices);

  const center = { x: 0, y: 0 };
  vertices.forEach((pt) => {
    center.x += pt.x;
    center.y += pt.y;
  });
  center.x /= vertices.length;
  center.y /= vertices.length;
  return center;
};

// 找出多边形的端点
const findVertices = (points) => {
  if (points.length <= 2) return points;

  const vertices = [];
  for (let i = 0; i < points.length; i++) {
    const prev = i === 0 ? points[points.length - 1] : points[i - 1];
    const curr = points[i];
    const next = i === points.length - 1 ? points[0] : points[i + 1];

    // 如果当前点不在前后两点的连线上,则为端点
    if (!isPointOnLine(curr, prev, next)) {
      vertices.push(curr);
    }
  }

  return vertices;
};

// 判断点是否在线段上
const isPointOnLine = (point, lineStart, lineEnd, tolerance = 0.001) => {
  // 计算点到线段的距离
  const d = distanceToLine(point, lineStart, lineEnd);
  if (d > tolerance) return false;

  // 确保点在线段范围内
  const d1 = Math.sqrt(
    Math.pow(point.x - lineStart.x, 2) + Math.pow(point.y - lineStart.y, 2)
  );
  const d2 = Math.sqrt(
    Math.pow(point.x - lineEnd.x, 2) + Math.pow(point.y - lineEnd.y, 2)
  );
  const lineLength = Math.sqrt(
    Math.pow(lineEnd.x - lineStart.x, 2) + Math.pow(lineEnd.y - lineStart.y, 2)
  );

  return Math.abs(d1 + d2 - lineLength) < tolerance;
};

// 计算点到线段的距离
const distanceToLine = (point, lineStart, lineEnd) => {
  const A = point.x - lineStart.x;
  const B = point.y - lineStart.y;
  const C = lineEnd.x - lineStart.x;
  const D = lineEnd.y - lineStart.y;

  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  let param = -1;

  if (lenSq !== 0) {
    param = dot / lenSq;
  }

  let xx, yy;

  if (param < 0) {
    xx = lineStart.x;
    yy = lineStart.y;
  } else if (param > 1) {
    xx = lineEnd.x;
    yy = lineEnd.y;
  } else {
    xx = lineStart.x + param * C;
    yy = lineStart.y + param * D;
  }

  const dx = point.x - xx;
  const dy = point.y - yy;

  return Math.sqrt(dx * dx + dy * dy);
};

// 对点集进行排序，确保形成的区域不会有相交
export const sortPointsToAvoidIntersection = (points) => {
  if (!points || points.length < 3) return points;

  // 计算质心作为参考点
  const centroid = calculateCentroid(points);

  // 按照与质心的角度排序
  return points.slice().sort((a, b) => {
    const angleA = Math.atan2(a.y - centroid.y, a.x - centroid.x);
    const angleB = Math.atan2(b.y - centroid.y, b.x - centroid.x);
    return angleA - angleB;
  });
};

// 计算点集的质心
const calculateCentroid = (points) => {
  if (!points || points.length === 0) return { x: 0, y: 0 };

  let sumX = 0;
  let sumY = 0;

  for (const point of points) {
    sumX += point.x;
    sumY += point.y;
  }

  return {
    x: sumX / points.length,
    y: sumY / points.length,
  };
};

// 检查多边形是否为凸多边形
export const isConvexPolygon = (points) => {
  if (!points || points.length < 3) return false;

  const n = points.length;
  let sign = 0;

  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    const k = (i + 2) % n;

    const crossProduct =
      (points[j].x - points[i].x) * (points[k].y - points[j].y) -
      (points[j].y - points[i].y) * (points[k].x - points[j].x);

    if (i === 0) {
      sign = Math.sign(crossProduct);
    } else if (Math.sign(crossProduct) !== sign) {
      return false;
    }
  }

  return true;
};

// 检查多边形是否自相交
export const isSelfIntersecting = (points) => {
  if (!points || points.length < 4) return false;

  const n = points.length;

  for (let i = 0; i < n; i++) {
    const a1 = points[i];
    const a2 = points[(i + 1) % n];

    for (let j = i + 2; j < n; j++) {
      // 跳过相邻边
      if ((j + 1) % n === i) continue;

      const b1 = points[j];
      const b2 = points[(j + 1) % n];

      // 检查两条线段是否相交
      const intersection = lineInsection(
        new McGePoint3d(a1.x, a1.y, 0),
        new McGePoint3d(a2.x, a2.y, 0),
        new McGePoint3d(b1.x, b1.y, 0),
        new McGePoint3d(b2.x, b2.y, 0)
      );

      if (intersection.isIntersected) return true;
    }
  }

  return false;
};

// 优化点集，确保形成简单多边形（无自相交） 排序点集
export const optimizePolygonPoints = (points) => {
  if (!points || points.length < 3) return points;

  // 首先尝试按角度排序
  const sortedPoints = sortPointsToAvoidIntersection(points);

  // 检查排序后是否仍有自相交
  if (!isSelfIntersecting(sortedPoints)) {
    return sortedPoints;
  }

  // 如果仍有自相交，尝试凸包算法
  return computeConvexHull(points);
};

// 计算凸包（Graham扫描算法）
const computeConvexHull = (points) => {
  if (!points || points.length < 3) return points;

  // 找到y坐标最小的点（如果有多个，取x最小的）
  let lowestPoint = points[0];
  for (let i = 1; i < points.length; i++) {
    if (
      points[i].y < lowestPoint.y ||
      (points[i].y === lowestPoint.y && points[i].x < lowestPoint.x)
    ) {
      lowestPoint = points[i];
    }
  }

  // 按照与最低点的极角排序
  const sortedPoints = points.slice().sort((a, b) => {
    if (a === lowestPoint) return -1;
    if (b === lowestPoint) return 1;

    const angleA = Math.atan2(a.y - lowestPoint.y, a.x - lowestPoint.x);
    const angleB = Math.atan2(b.y - lowestPoint.y, b.x - lowestPoint.x);

    if (angleA === angleB) {
      // 如果角度相同，取距离最近的点
      const distA = Math.sqrt(
        Math.pow(a.x - lowestPoint.x, 2) + Math.pow(a.y - lowestPoint.y, 2)
      );
      const distB = Math.sqrt(
        Math.pow(b.x - lowestPoint.x, 2) + Math.pow(b.y - lowestPoint.y, 2)
      );
      return distA - distB;
    }

    return angleA - angleB;
  });

  // Graham扫描算法构建凸包
  const hull = [sortedPoints[0], sortedPoints[1]];

  for (let i = 2; i < sortedPoints.length; i++) {
    while (
      hull.length > 1 &&
      !isLeftTurn(hull[hull.length - 2], hull[hull.length - 1], sortedPoints[i])
    ) {
      hull.pop();
    }
    hull.push(sortedPoints[i]);
  }

  return hull;
};

// 判断是否为左转（叉积为正）
const isLeftTurn = (p1, p2, p3) => {
  return (p2.x - p1.x) * (p3.y - p1.y) - (p2.y - p1.y) * (p3.x - p1.x) > 0;
};

// 检查当前网格是否与其他网格重叠
export const checkGridOverlap = async (grid, thisIgnoreGridArray) => {
  //深拷贝
  let beforeAllGrid = JSON.parse(
    JSON.stringify(store.state.rlEntData.totalEntityData["rlGrid"])
  );
  let ignoreGridArray = [grid, ...thisIgnoreGridArray];
  let isExist = GridIsExist(grid, ignoreGridArray);
  // console.log("isExist", isExist);

  if (isExist) {
    return { isOverlap: true };
  }

  let isInsert = await gridLineInsertWith(grid, false);
  if (isInsert) {
    let afterAllGrid = store.state.rlEntData.totalEntityData["rlGrid"];
    let newGrid = [];
    for (const item of afterAllGrid) {
      let isExist = false;
      for (const item2 of beforeAllGrid) {
        if (item2.Guid === item.Guid) {
          isExist = true;
          break;
        }
      }
      if (!isExist) {
        newGrid.push(item.mcDbId);
      }
    }
    return { isLineInsert: true, newGrid };
  }
  return { isOverlap: false, isLineInsert: false };
};
